// Checksum utility functions
function generateChecksum(data) {
  // Simple hash function using the created field
  let hash = 0
  const str = data.toString()
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32-bit integer
  }
  // Convert to positive hex string and take first 8 characters
  return Math.abs(hash).toString(16).padStart(8, '0').substring(0, 8)
}

function generateSharingChecksum(propertyId, created) {
  return generateChecksum(`${propertyId}-${created}`)
}

function generateMeterSharingChecksum(propertyId, meterId, created) {
  return generateChecksum(`${propertyId}-${meterId}-${created}`)
}

function constructSharePointUrl(attachmentUrl) {
  // Extract domain from localStorage token
  const authData = JSON.parse(localStorage.getItem('auth') || '{}')
  const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
  const domainId = decodedToken.domainId || 1

  // Get domain code from domain ID
  const domain = resolveDomain(domainId)

  // Extract file path from attachment URL (remove :/content suffix)
  const filePath = attachmentUrl.replace(/:\/content$/, '')

  // Construct SharePoint base URLs based on domain
  let baseUrl, viewId
  switch (domain) {
    case 'erste-hausverwaltung-dus':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-Duesseldorf/Freigegebene Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37' // Use the same view ID
      break
    case 'hauscon':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSHauscon/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'cig':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-Capitol/Freigegebene Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'zieglmeier':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-Zieglmeier/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'erste-hausverwaltung-2':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSTesting/Freigegebene Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'ehv-service':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/EHVDMSTesting/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'ehv-test':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-EHV-Test/Freigegebene Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'sgv-murr':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-SGVMurr/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'hv-tesche':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-HVTesche/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'verwey':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-Verwey/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'bachem':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-Bachem/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'oehler':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-Oehler/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'fraenken':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-Fraenken-GmbH/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'bhv':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-BHV/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'benz-walker':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-Benz-Walker/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    case 'riebeling':
      baseUrl =
        'https://erstehausverwaltung.sharepoint.com/sites/DMS-Riebeling/Freigegebene%20Dokumente'
      viewId = 'd1467c95-50ff-4849-a3fb-7ef52e050f37'
      break
    default:
      baseUrl = '/'
      viewId = ''
  }

  if (!baseUrl || !viewId) {
    return '#'
  }

  // Encode the file path for URL
  const encodedFilePath = encodeURIComponent(
    `/sites/${
      domain === 'erste-hausverwaltung-dus'
        ? 'DMS-Duesseldorf'
        : domain === 'hauscon'
          ? 'NeovaroDMSHauscon'
          : domain === 'cig'
            ? 'DMS-Capitol'
            : domain === 'zieglmeier'
              ? 'DMS-Zieglmeier'
              : domain === 'erste-hausverwaltung-2'
                ? 'NeovaroDMSTesting'
                : domain === 'ehv-service'
                  ? 'EHVDMSTesting'
                  : domain === 'ehv-test'
                    ? 'DMS-EHV-Test'
                    : domain === 'sgv-murr'
                      ? 'DMS-SGVMurr'
                      : domain === 'hv-tesche'
                        ? 'DMS-HVTesche'
                        : domain === 'verwey'
                          ? 'DMS-Verwey'
                          : domain === 'bachem'
                            ? 'DMS-Bachem'
                            : domain === 'oehler'
                              ? 'DMS-Oehler'
                              : domain === 'fraenken'
                                ? 'DMS-Fraenken-GmbH'
                                : domain === 'bhv'
                                  ? 'DMS-BHV'
                                  : domain === 'benz-walker'
                                    ? 'DMS-Benz-Walker'
                                    : domain === 'riebeling'
                                      ? 'DMS-Riebeling'
                                      : 'DMS-EHV-Test'
    }/Freigegebene Dokumente/${filePath}`
  )

  // Get parent path (everything except the filename)
  const pathParts = filePath.split('/')
  const parentPath = pathParts.slice(0, -1).join('/')
  const encodedParentPath = encodeURIComponent(
    `/sites/${
      domain === 'erste-hausverwaltung-dus'
        ? 'DMS-Duesseldorf'
        : domain === 'hauscon'
          ? 'NeovaroDMSHauscon'
          : domain === 'cig'
            ? 'DMS-Capitol'
            : domain === 'zieglmeier'
              ? 'DMS-Zieglmeier'
              : domain === 'erste-hausverwaltung-2'
                ? 'NeovaroDMSTesting'
                : domain === 'ehv-service'
                  ? 'EHVDMSTesting'
                  : domain === 'ehv-test'
                    ? 'DMS-EHV-Test'
                    : domain === 'sgv-murr'
                      ? 'DMS-SGVMurr'
                      : domain === 'hv-tesche'
                        ? 'DMS-HVTesche'
                        : domain === 'verwey'
                          ? 'DMS-Verwey'
                          : domain === 'bachem'
                            ? 'DMS-Bachem'
                            : domain === 'oehler'
                              ? 'DMS-Oehler'
                              : domain === 'fraenken'
                                ? 'DMS-Fraenken-GmbH'
                                : domain === 'bhv'
                                  ? 'DMS-BHV'
                                  : domain === 'benz-walker'
                                    ? 'DMS-Benz-Walker'
                                    : domain === 'riebeling'
                                      ? 'DMS-Riebeling'
                                      : 'DMS-EHV-Test'
    }/Freigegebene Dokumente/${parentPath}`
  )

  // Construct the full URL with proper parameters
  return `${baseUrl}/Forms/AllItems.aspx?viewid=${viewId}&id=${encodedFilePath}&parent=${encodedParentPath}`
}

const onPropertyPageMatch = async (pathname, regex) => {
  const urlParams = pathname.match(regex)
  const propertyHrId = urlParams[1]
  const propertyEnhancementSelector = `.form-content > div[data-impowerx-property-enhanced="${propertyHrId}"]`
  const notificationsSectionId = 'ImpowerxPropertyNotificationsSection'
  const hasEnhancedForm = !!document.querySelector(propertyEnhancementSelector)
  const hasMatchingNotifications =
    document.getElementById(notificationsSectionId)?.dataset?.propertyHrId ===
    propertyHrId

  // Fully initialized (including duplicate timers after the first run finished).
  if (hasEnhancedForm && hasMatchingNotifications) {
    window.__impowerxPropertyInjectInFlight = null
    return
  }
  // Bail out before cleanup so a concurrent or duplicate match does not tear down an active inject.
  if (window.__impowerxPropertyInjectInFlight === propertyHrId) {
    return
  }

  if (typeof window.__impowerxPropertyCleanup === 'function') {
    window.__impowerxPropertyCleanup()
  }
  window.__impowerxPropertyInjectInFlight = propertyHrId

  // Remove the upload handler from any previous invocation to prevent accumulation on SPA re-navigation.
  // The .impowerxProperty handlers (DatePicker/select) are cleaned up at the start of editFunction.
  $(document).off('change.impowerxFileInput')
  const editModeStorageKey = 'isInEditMode'
  const saveActionButtonLabels = [
    'speichern',
    'save',
    'save all',
    'save and continue',
    'speichern und weiter',
    'als entwurf speichern',
    'bereit zur verbuchung',
    'ready for invoice',
  ]
  const editActionButtonLabels = ['bearbeiten', 'edit']
  let isSavingInProgress = false
  let applyEditModeFromSync = null
  let onPropertySaveSuccess = null

  const getVisibleHeaderButtonTexts = () => {
    const pageHeader =
      document.querySelector('.PageHeader[data-testid="page-header"]') ||
      document.querySelector('.PageHeader')
    const headerActionArea =
      pageHeader?.querySelector('.right-side') || pageHeader
    if (!headerActionArea) return []

    return Array.from(headerActionArea.querySelectorAll('button'))
      .filter((button) => button.offsetParent !== null && !button.disabled)
      .map((button) =>
        (button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase()
      )
  }

  const detectDomEditMode = () => {
    const visibleButtonTexts = getVisibleHeaderButtonTexts()
    const hasSaveButton = saveActionButtonLabels.some((label) =>
      visibleButtonTexts.includes(label)
    )
    if (hasSaveButton) return true

    const hasEditButton = editActionButtonLabels.some((label) =>
      visibleButtonTexts.includes(label)
    )
    if (hasEditButton) return false

    // Fallback for cases where header buttons are not visible yet.
    return !!document.querySelector(
      '.ant-radio-input:not([disabled]), .ant-checkbox-input:not([disabled]), .DatePicker input:not([disabled]), .impowerx-building-baujahr-year:not([disabled]), .impowerx-text-input:not([disabled]), .impowerx-currency-input:not([disabled]):not([readonly]), .impower-x-file-input:not([disabled])'
    )
  }

  const setEditModeInStorage = (isEditMode) => {
    localStorage.setItem(editModeStorageKey, isEditMode ? 'true' : 'false')
  }

  const syncEditModeWithDom = (verifyDelayMs = 120) => {
    if (isSavingInProgress) return
    const storedIsEditMode = localStorage.getItem(editModeStorageKey) === 'true'
    const domIsEditMode = detectDomEditMode()
    if (storedIsEditMode === domIsEditMode) return

    setEditModeInStorage(domIsEditMode)
    if (
      !storedIsEditMode &&
      domIsEditMode &&
      typeof applyEditModeFromSync === 'function'
    ) {
      applyEditModeFromSync()
    }

    // Verify again shortly after for fast UI transitions (e.g. clicked Edit before inject finished).
    if (verifyDelayMs > 0) {
      setTimeout(() => {
        if (isSavingInProgress) return
        const verifiedDomIsEditMode = detectDomEditMode()
        if (
          (localStorage.getItem(editModeStorageKey) === 'true') !==
          verifiedDomIsEditMode
        ) {
          setEditModeInStorage(verifiedDomIsEditMode)
          if (
            verifiedDomIsEditMode &&
            typeof applyEditModeFromSync === 'function'
          ) {
            applyEditModeFromSync()
          }
        }
      }, verifyDelayMs)
    }
  }

  if (window.__impowerxPropertyEditModeSyncInterval) {
    clearInterval(window.__impowerxPropertyEditModeSyncInterval)
  }
  setEditModeInStorage(detectDomEditMode())
  window.__impowerxPropertyEditModeSyncInterval = setInterval(() => {
    if (localStorage.getItem(editModeStorageKey) === 'false') {
      syncEditModeWithDom(120)
      return
    }
    syncEditModeWithDom(0)
  }, 350)
  injectImpowerXStyles()
  if (typeof injectHideBuildingServiceProvidersStyles === 'function') {
    injectHideBuildingServiceProvidersStyles()
  }
  // Before any await: native parts stay hidden while the rest of the inject loads.
  keepNativePropertyUiHidden()
  holdNativeInsuranceUi(propertyHrId)
  // Native building equipment is replaced by Lux technical assets on every property (EHV-1200).
  hideNativeEquipmentUi()
  if (typeof renameImpowerDienstleisterSection === 'function') {
    renameImpowerDienstleisterSection()
  }
  const authData = JSON.parse(localStorage.getItem('auth') || '{}')
  const token = authData.token
  let propertyData = null
  // The Impower property payload often lacks buildings; resolved once /api/impowerX/buildings has loaded.
  let resolveLoadedBuildings = () => {}
  const loadedBuildings = new Promise((resolve) => {
    resolveLoadedBuildings = resolve
  })

  // Impower /services/* must use the page origin (relative URLs). baseApiUrl points at Lux
  // (e.g. localhost:3000) and is only for /api/impowerX/* — cross-origin calls cause CORS errors.
  const resolvePropertyId = (data) => {
    if (!data) return null
    const record = Array.isArray(data?.content) ? data.content[0] : data
    const raw = record?.id ?? record?.propertyId
    const parsed = Number(raw)
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null
  }

  const fetchPropertyDataByHrId = async () => {
    const headers = { Authorization: `Bearer ${token}` }
    const encodedHrId = encodeURIComponent(propertyHrId)

    const fetchImpowerProperty = async (url) => {
      const response = await fetch(url, { headers })
      if (!response.ok) return null
      const data = await response.json()
      return resolvePropertyId(data) ? data : null
    }

    const endpoints = [
      `/services/pmp-accounting/api/v1/properties/simple/by-hr-id?propertyHrId=${encodedHrId}`,
      `/services/pmp-accounting/api/v1/properties/${encodedHrId}`,
      `/services/pmp-accounting/api/v1/properties/filter?propertyHrId=${encodedHrId}&size=1`,
    ]

    for (const endpoint of endpoints) {
      try {
        const data = await fetchImpowerProperty(endpoint)
        if (data) {
          return Array.isArray(data.content) ? data.content[0] : data
        }
      } catch (error) {
        console.error('Error fetching property data:', endpoint, error)
      }
    }
    return null
  }

  try {
    propertyData = await fetchPropertyDataByHrId()
    if (!propertyData) throw new Error('Property not found')
  } catch (error) {
    console.error('Error fetching property data:', error)
  }
  const propertyId = resolvePropertyId(propertyData)
  if (!propertyId) {
    console.error('Property ID not found for', propertyHrId)
    // Allow a later onPropertyPageMatch run to cleanup and retry after a transient fetch failure.
    window.__impowerxPropertyInjectInFlight = null
  }
  // "Technische Anlagen" is built when the user opens it; start its list request
  // with the page so the tables are usually filled on open (like Versicherungen).
  const initialTechnicalAssetsRequest =
    propertyId && typeof fetchTechnicalAssetsByPropertyId === 'function'
      ? fetchTechnicalAssetsByPropertyId(propertyId)
      : null
  // The section shows the error itself; this only keeps an unopened section from
  // surfacing an unhandled rejection.
  initialTechnicalAssetsRequest?.catch(() => {})
  const buildTechnicalAssetsSectionContent = () =>
    createTechnicalAssetsSectionContent({
      propertyId,
      propertyHrId,
      buildings: propertyData?.buildings || [],
      loadedBuildings,
      assetsRequest: initialTechnicalAssetsRequest,
    })

  let isDraft = false

  function getNextSectionNumber() {
    const sectionNumbers = [...document.querySelectorAll('.section-number')]
      .map((element) => parseInt(element.textContent, 10))
      .filter(Number.isInteger)
    return Math.max(0, ...sectionNumbers) + 1
  }

  function findLastSectionInsertionPoint() {
    const lastSectionNumber = getNextSectionNumber() - 1
    const sections = document.querySelectorAll('.FormSection .section-number')
    for (const section of sections) {
      if (parseInt(section.textContent, 10) === lastSectionNumber) {
        return section.closest('.FormSection')
      }
    }
    return null
  }

  function findLastSidebarLinkInsertionPoint() {
    const lastSectionNumber = getNextSectionNumber() - 1
    const links = document.querySelectorAll(
      '.FormSidebar .Link.main-link .link-title'
    )
    for (const link of links) {
      const linkNumber = parseInt(
        link.textContent.trim().split('&nbsp;')[0],
        10
      )
      if (linkNumber === lastSectionNumber) {
        return link.closest('.Link.main-link')
      }
    }
    return null
  }

  function insertSubSectionElement(sectionName, subSectionName) {
    const section = document.querySelector(`#${sectionName}`)
    if (!section) return
    if (section.querySelector(`#${subSectionName}`)) return

    const subSections = section.querySelectorAll('.sub-section')
    if (subSections.length) {
      const lastSubSection = subSections[subSections.length - 1]
      lastSubSection.insertAdjacentHTML(
        'afterend',
        generateSubSection(subSectionName)
      )
      return
    }

    const formSectionWrapper = section.querySelector('.form-section-wrapper')
    if (!formSectionWrapper) return

    // Reuse the content node created on open. A second `.section-content` stays
    // hidden (Impower hides them by default) so fields never appear.
    let sectionContent = formSectionWrapper.querySelector('.section-content')
    if (!sectionContent) {
      sectionContent = document.createElement('div')
      sectionContent.className = 'section-content'
      formSectionWrapper.appendChild(sectionContent)
    }
    if (isFormSectionOpen(section)) {
      sectionContent.style.display = 'block'
    }
    sectionContent.insertAdjacentHTML(
      'beforeend',
      generateSubSection(subSectionName)
    )
  }

  function isFormSectionOpen(sectionElement) {
    if (!sectionElement) return false
    const sectionHeader = sectionElement.querySelector(
      '.main-section-header.section-header'
    )
    if (!sectionHeader) return false
    return (
      sectionHeader.classList.contains('open') &&
      !sectionHeader.classList.contains('not-open')
    )
  }

  function propertyFormSidebarLink(
    { id, title, hasSubSection },
    sectionNumber
  ) {
    const existingLink = document.querySelector(
      `.FormSidebar .Link.main-link[data-section-id="${id}"]`
    )
    if (existingLink) return existingLink

    const link = document.createElement('div')
    link.className = 'Link main-link'
    link.innerHTML = `<div class="link-row level1 ${hasSubSection ? '' : 'arrow-placeholder'}">
          ${hasSubSection ? '<div class="arrow-wrapper" role="button" tabindex="-1"><span class="arrow">▶</span></div>' : ''}
          <div class="link-title" role="button" tabindex="-1">${sectionNumber}&nbsp;&nbsp;&nbsp;&nbsp;${title || ''}</div>
        </div>
      `
    link.dataset.sectionId = id

    const arrowWrapper = link.querySelector('.arrow-wrapper')
    if (arrowWrapper) {
      arrowWrapper.onclick = () => {
        arrowWrapper.classList.toggle('open')
      }
    }

    link.addEventListener('click', () => {
      document
        .querySelectorAll('.FormSidebar .Link.main-link .link-row')
        .forEach((row) => {
          row.classList.remove('active')
        })

      link.querySelector('.link-row').classList.add('active')

      const section = document.getElementById(id)
      if (section) {
        const sectionWrapper = section.querySelector('.form-section-wrapper')
        const sectionHeader = section.querySelector(
          '.main-section-header.section-header'
        )
        const sectionNumberBox = section.querySelector('.section-number-box')
        const sectionTitleBox = section.querySelector('.section-title-box')

        sectionWrapper.classList.add('open')
        if (sectionHeader.classList.contains('not-open')) {
          replaceElementClass(sectionHeader, 'not-open', 'open')
          let sectionContent = sectionWrapper.querySelector('.section-content')
          if (!sectionContent) {
            if (typeof section._impowerxOpenSection === 'function') {
              section._impowerxOpenSection()
              sectionContent = sectionWrapper.querySelector('.section-content')
            }
          }
          if (!sectionContent) {
            const components = {
              NotesSection: createNotesSectionContent,
              MeterReadingsSection: createMeterReadingsSectionContent,
              TaskAutomatorSection: () =>
                createTaskAutomatorSectionContent({
                  propertyId,
                  propertyHrId,
                  baseApiUrl,
                }),
              TechnicalAssetsSection: buildTechnicalAssetsSectionContent,
              ContactRolesSection: createContactRolesSectionContent,
            }
            const contentFunction = components[id]
            if (contentFunction) {
              // Handle async content functions
              if (contentFunction.constructor.name === 'AsyncFunction') {
                contentFunction().then((sectionContent) => {
                  if (sectionContent) {
                    sectionContent.classList.add('section-content')
                    sectionWrapper.appendChild(sectionContent)
                    sectionContent.style.display = 'block'
                  }
                })
                // Return a placeholder element for now
                sectionContent = document.createElement('div')
                sectionContent.className = 'section-content'
                sectionContent.style.display = 'none'
                sectionWrapper.appendChild(sectionContent)
              } else {
                sectionContent = contentFunction()
                sectionContent.classList.add('section-content')
                sectionWrapper.appendChild(sectionContent)
              }
            }
          }
          if (sectionContent) {
            sectionContent.style.display = 'block'
          }
        }
        sectionNumberBox.classList.add('open')
        sectionTitleBox.classList.add('open')

        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      }
    })

    const target = findLastSidebarLinkInsertionPoint()
    if (target) {
      const sidebar = document.querySelector('.FormSidebar')
      const allLinks = sidebar.querySelectorAll('.Link.main-link .link-title')

      allLinks.forEach((linkTitle) => {
        const titleText = linkTitle.textContent
        const numberMatch = titleText.match(/^(\d+)\s+/)
        if (numberMatch) {
          const currentNumber = parseInt(numberMatch[1], 10)
          if (currentNumber >= sectionNumber) {
            const newText = titleText.replace(
              /^\d+(\s+)/,
              `${currentNumber + 1}$1`
            )
            linkTitle.textContent = newText
          }
        }
      })

      target.after(link)
    } else {
      const sidebar = document.querySelector('.FormSidebar')
      if (sidebar) {
        sidebar.appendChild(link)
      }
    }

    return link
  }

  function initializeComponent(componentFunction, config) {
    const existing = config?.id ? document.getElementById(config.id) : null
    if (existing) {
      // Same property (SPA return): keep the mounted section.
      if (existing.dataset.propertyHrId === propertyHrId) return
      // Impower kept the form DOM while switching to another property: the section's
      // content (fetches, Hinzufügen links, table contexts) is bound to the previous
      // property, so drop it and its sidebar link and build a fresh one below.
      existing.remove()
      document
        .querySelector(
          `.FormSidebar .Link.main-link[data-section-id="${config.id}"]`
        )
        ?.remove()
    }
    const component = componentFunction(config)
    const target = findLastSectionInsertionPoint()
    if (target) {
      target.after(component)
    }
  }

  function replaceElementClass(element, oldClassName, newClassName) {
    if (element) {
      element.classList.remove(oldClassName)
      element.classList.add(newClassName)
    }
  }

  function createNoteElement(note) {
    const userName = note.user
      ? `${note.user.firstName || ''} ${note.user.lastName || ''}`.trim() ||
        'Unbekannt'
      : 'Unbekannt'
    let createdLabel = ''
    try {
      const d = new Date(note.createdAt)
      if (!Number.isNaN(d.getTime())) createdLabel = d.toLocaleString()
    } catch (_e) {
      /* ignore */
    }
    return luxCreateNoteListItem({
      id: note.id,
      titleText: userName,
      metaLines: createdLabel ? [createdLabel] : [],
      bodyText: note.note || '',
      className: 'note-item',
      editBtnClass: 'edit-note-btn',
      deleteBtnClass: 'delete-note-btn',
    })
  }

  async function loadNotes(propertyHrId) {
    const authRaw = localStorage.getItem('auth')
    const token = authRaw ? JSON.parse(authRaw).token : null
    if (!token) throw new Error('No auth token')
    const response = await fetch(
      `${baseApiUrl}/api/impowerX/properties/notes?propertyHrId=${propertyHrId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (!response.ok) throw new Error('Failed to load notes')
    const data = await response.json()
    return Array.isArray(data.notes) ? data.notes : []
  }

  async function saveNote(propertyHrId, note, editsNoteId = null) {
    const token = JSON.parse(localStorage.getItem('auth')).token
    const response = await fetch(
      `${baseApiUrl}/api/impowerX/properties/notes`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ propertyHrId, note, editsNoteId }),
      }
    )

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.error || 'Failed to save note')
    }
    return data
  }

  async function deleteNote(noteId) {
    try {
      const token = JSON.parse(localStorage.getItem('auth')).token
      const response = await fetch(
        `${baseApiUrl}/api/impowerX/properties/notes?noteId=${noteId}`,
        {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (!response.ok) throw new Error('Failed to delete note')
      return true
    } catch (error) {
      throw error
    }
  }

  function createContactRolesSectionContent() {
    const container = document.createElement('div')
    container.style.overflow = 'visible'
    if (typeof initContactRolesPropertySection === 'function' && propertyId) {
      initContactRolesPropertySection(container, propertyId, 'external')
    } else {
      container.innerHTML =
        '<div style="padding: 8px 0; color: rgba(0,0,0,0.45);">Rollen konnten nicht geladen werden.</div>'
    }
    return container
  }

  function createNotesSectionContent() {
    const notesContainer = document.createElement('div')
    notesContainer.className = 'notes-container'
    notesContainer.innerHTML = `
        <div class="ant-row ant-form-item ant-form-item-with-help" style="row-gap: 0px;">
          <div class="ant-col ant-form-item-control">
            <div class="ant-form-item-control-input">
              <div class="ant-form-item-control-input-content">
                <div class="notes-container">
                  <div class="notes-input-section">
                    <textarea 
                      class="ant-input notes-textarea" 
                      data-testid="notes-textarea"
                      placeholder="Füge eine neue Notiz hinzu..."
                      style="min-height: 100px; resize: none;"
                    ></textarea>
                    <div class="notes-actions" style="display: flex; justify-content: flex-end; margin-top: 8px;">
                      <button type="button" class="ant-btn ant-btn-default Button add-note-btn" data-testid="add-note-btn">
                        <span role="img" class="anticon">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="black"></path>
                          </svg>
                        </span>
                        <span>Erstellen</span>
                      </button>
                    </div>
                  </div>
                  <div class="ant-divider" style="margin-top: 8px;"></div>
                  <div class="notes-list" data-testid="notes-list" style="max-height: 400px; overflow-y: auto; margin-top: 24px;">
                    <div class="notes-loading-state" style="text-align: center; padding: 32px 0;">
                      <div class="ant-spin ant-spin-spinning">
                        <span class="ant-spin-dot ant-spin-dot-spin" style="color: black;">
                          <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.3;"></i>
                          <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.5;"></i>
                          <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.7;"></i>
                          <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.9;"></i>
                        </span>
                      </div>
                    </div>
                    <div class="notes-empty-state" style="display: none; text-align: center; padding: 32px 0; color: rgba(0, 0, 0, 0.45);">
                      Keine Notizen vorhanden.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ant-form-item-explain ant-form-item-explain-connected">
              <div role="alert" class="" style=""></div>
            </div>
          </div>
        </div>
      `

    const addNoteBtn = notesContainer.querySelector('.add-note-btn')
    const textarea = notesContainer.querySelector('.notes-textarea')
    const notesList = notesContainer.querySelector('.notes-list')
    const emptyState = notesContainer.querySelector('.notes-empty-state')
    const loadingState = notesContainer.querySelector('.notes-loading-state')
    let editsNoteId = null

    loadNotes(propertyHrId)
      .then((notes) => {
        loadingState.style.display = 'none'
        if (notes.length > 0) {
          emptyState.style.display = 'none'
          notes.forEach((note) => {
            const noteElement = createNoteElement(note)
            notesList.appendChild(noteElement)
          })
          setTimeout(() => {
            notesContainer.scrollIntoView({ behavior: 'smooth' })
          }, 100)
        } else {
          emptyState.style.display = 'block'
        }
      })
      .catch((error) => {
        console.error('[lux] property notes load failed', error)
        loadingState.style.display = 'none'
        emptyState.style.display = 'block'
        emptyState.textContent =
          'Notizen konnten nicht geladen werden. Bitte versuche es später noch einmal.'
      })

    addNoteBtn.addEventListener('click', async () => {
      const text = textarea.value.trim()
      if (!text) return

      try {
        const result = await saveNote(propertyHrId, text, editsNoteId)
        if (result && result.note) {
          const noteElement = createNoteElement(result.note)
          notesList.insertBefore(noteElement, notesList.firstChild)
          textarea.value = ''
          emptyState.style.display = 'none'
          editsNoteId = null
        } else {
          console.error('Invalid response format:', result)
          throw new Error('Invalid response format')
        }
      } catch (error) {
        console.error('Error saving note:', error)
        alert(
          'Notiz konnte nicht gespeichert werden. Bitte versuche es erneut.'
        )
      }
    })

    notesList.addEventListener('click', async (event) => {
      const deleteBtn = event.target.closest('.delete-note-btn')
      if (deleteBtn) {
        const noteElement = deleteBtn.closest('.note-item')
        const noteId = noteElement.dataset.noteId

        if (confirm('Möchtest du diese Notiz wirklich löschen?')) {
          try {
            await deleteNote(noteId)
            noteElement.remove()
            if (notesList.querySelectorAll('.note-item').length === 0) {
              emptyState.style.display = 'block'
              emptyState.textContent = 'Keine Notizen vorhanden.'
            }
          } catch (error) {
            alert(
              'Notiz konnte nicht gelöscht werden. Bitte versuche es erneut.'
            )
          }
        }
      }

      const editBtn = event.target.closest('.edit-note-btn')
      if (editBtn) {
        const noteElement = editBtn.closest('.note-item')
        const noteText = noteElement.children[1]?.textContent
        textarea.value = noteText
        editsNoteId = noteElement.dataset.noteId
        addNoteBtn.classList.add('is-editing')
        noteElement.remove()
        if (notesList.querySelectorAll('.note-item').length === 0) {
          emptyState.style.display = 'block'
          emptyState.textContent = 'Keine Notizen vorhanden.'
        }
      }
    })

    return notesContainer
  }

  async function createMeterReadingsSectionContent() {
    const meterReadingsContainer = document.createElement('div')
    meterReadingsContainer.className = 'meter-readings-container'

    // Fetch property data once and cache it
    let propertyData = {}
    let actualPropertyId = null
    const allMeters = []

    try {
      const propertyHrId = window.location.pathname.match(
        /\/properties\/([^\/]+)/
      )?.[1]
      if (propertyHrId) {
        const token = JSON.parse(localStorage.getItem('auth'))?.token
        if (token) {
          const propertyResponse = await fetch(
            `/services/pmp-accounting/api/v1/properties/${propertyHrId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            }
          )

          if (propertyResponse.ok) {
            propertyData = await propertyResponse.json()
            actualPropertyId = propertyData.id // Cache the actual property ID
          } else {
            console.warn(
              'Failed to fetch property data:',
              propertyResponse.status
            )
          }
        }
      }
    } catch (error) {
      console.error('Error fetching property data:', error)
    }

    const buildings = propertyData.buildings || []
    // Zählerstände track Lux technical assets of kind Zähler (asset id = meter id).
    const metersByBuildingId = new Map()
    let metersLoadError = ''
    if (
      actualPropertyId &&
      typeof fetchTechnicalAssetsByPropertyId === 'function'
    ) {
      try {
        const assetData =
          await fetchTechnicalAssetsByPropertyId(actualPropertyId)
        const contactNames = assetData.contactNames || {}
        Object.values(assetData.byBuildingId || {})
          .flat()
          .filter((asset) => asset && asset.typ === 'Zähler')
          .forEach((asset) => {
            const fields =
              asset.typeFields && typeof asset.typeFields === 'object'
                ? asset.typeFields
                : {}
            // Netzbetreiber is an Impower contact; `include=display` resolves its name.
            const gridOperatorId = fields.gridOperatorContactId
            const meter = {
              id: asset.id,
              name: asset.name,
              meterType: fields.meterType,
              counterNumber: fields.meterNumber || '',
              gridOperator:
                gridOperatorId != null
                  ? {
                      companyName:
                        contactNames[String(gridOperatorId)] ||
                        `Kontakt #${gridOperatorId}`,
                    }
                  : null,
            }
            const key = String(asset.buildingId)
            const list = metersByBuildingId.get(key) || []
            list.push(meter)
            metersByBuildingId.set(key, list)
          })
      } catch (error) {
        console.error('Error fetching technical-asset meters:', error)
        metersLoadError =
          (error && error.message) || 'Zähler konnten nicht geladen werden.'
      }
    } else if (actualPropertyId) {
      metersLoadError = 'Zähler konnten nicht geladen werden.'
    }

    const meterBuildings = buildings.map((building) => ({
      ...building,
      meters: metersByBuildingId.get(String(building.id)) || [],
    }))
    metersByBuildingId.forEach((meters, buildingId) => {
      if (meterBuildings.some((building) => String(building.id) === buildingId))
        return
      meterBuildings.push({
        id: Number(buildingId),
        name: `Gebäude ${buildingId}`,
        meters,
      })
    })

    meterBuildings.forEach((building) => {
      ;(building.meters || []).forEach((meter) => {
        allMeters.push({
          ...meter,
          buildingName: building.name,
          buildingHrId: building.buildingHrId,
        })
      })
    })

    // Generate meter list HTML grouped by building
    const metersListHTML = metersLoadError
      ? `
          <div style="text-align: center; padding: 32px; color: #cf1322;">
            <div style="font-size: 16px; margin-bottom: 8px;">Zähler konnten nicht geladen werden</div>
            <div style="font-size: 14px;">${escapeHtml(metersLoadError)}</div>
          </div>
        `
      : allMeters.length > 0
        ? meterBuildings
            .map((building) => {
              const buildingMeters = building.meters || []
              if (buildingMeters.length === 0) return ''

              const buildingMetersHTML = buildingMeters
                .map((meter) => {
                  const meterTypeText = getMeterTypeText(meter.meterType)
                  const gridOperatorName = meter.gridOperator
                    ? `${meter.gridOperator.firstName || ''} ${meter.gridOperator.lastName || ''}`.trim() ||
                      meter.gridOperator.companyName ||
                      'Unbekannt'
                    : 'Unbekannt'

                  return `
                <div class="meter-item" style="background: white; border-bottom: 1px solid #d9d9d9; cursor: pointer; transition: background-color 0.2s ease;" data-meter-id="${meter.id}">
                <div class="meter-header" style="padding: 16px; display: flex; justify-content: space-between; align-items: center;">
                  <div style="flex: 1; display: flex; gap: 24px; align-items: center;">
                    <div style="min-width: 120px; font-weight: 500; font-size: 14px; color: rgba(0, 0, 0, 0.85); display: flex; align-items: center; gap: 8px;">
                      ${
                        meter.meterType === 'WATER'
                          ? `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #1890ff;"><path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zM7.83 14c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12-.08-.45.28-.87.74-.87z" fill="currentColor"/></svg>`
                          : meter.meterType === 'ELECTRICITY' ||
                              meter.meterType === 'ENERGY'
                            ? `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #faad14;"><path d="M7 2v11h3v9l7-12h-4l4-8z" fill="currentColor"/></svg>`
                            : meter.meterType === 'GAS'
                              ? `<svg width="16" height="16" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #ff4d4f;"><path fill="currentColor" d="M143.38 17.85a8 8 0 0 0-12.63 3.41l-22 60.41l-24.16-23.41a8 8 0 0 0-11.93.89C51 87.53 40 116.08 40 144a88 88 0 0 0 176 0c0-59.45-50.79-108-72.62-126.15m40.51 135.49a57.6 57.6 0 0 1-46.56 46.55a7.7 7.7 0 0 1-1.33.11a8 8 0 0 1-1.32-15.89c16.57-2.79 30.63-16.85 33.44-33.45a8 8 0 0 1 15.78 2.68Z"/></svg>`
                              : `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: rgba(0, 0, 0, 0.45);"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/></svg>`
                      }
                      ${escapeHtml(meter.name || 'Unbenannter Zähler')}
                    </div>
                    <div style="min-width: 100px; font-size: 14px; color: rgba(0, 0, 0, 0.85);">
                      ${escapeHtml(meterTypeText)}
                    </div>
                    <div style="flex: 1; font-size: 14px; color: rgba(0, 0, 0, 0.85);">
                      <div style="text-decoration: underline; text-decoration-style: dotted; cursor: pointer;">${escapeHtml(gridOperatorName)}</div>
                      <div style="font-size: 12px; color: rgba(0, 0, 0, 0.45); margin-top: 2px;">Anbieter</div>
                    </div>
                    <div style="min-width: 120px; font-size: 14px; color: rgba(0, 0, 0, 0.85); text-align: right;">
                      <div style="font-weight: 500; color: rgba(0, 0, 0, 0.85);">${escapeHtml(meter.counterNumber || 'N/A')}</div>
                      <div style="font-size: 12px; color: rgba(0, 0, 0, 0.45); margin-top: 2px;">Zählernummer</div>
                    </div>
                  </div>
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <button class="ant-btn ant-btn-text ant-btn-icon-only share-meter-btn" title="Zähler teilen" data-meter-id="${meter.id}" style="padding: 6px;">
                      <span class="anticon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" fill="currentColor"/>
                        </svg>
                      </span>
                    </button>
                    <span class="meter-expand-icon" style="font-size: 16px; color: rgba(0, 0, 0, 0.45);">▼</span>
                  </div>
                </div>
                <div class="meter-content" style="display: none; border-top: 1px solid #d9d9d9; background: #fafafa;">
                  <div style="padding: 16px;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
                      <span style="font-weight: 600; font-size: 14px; color: rgba(0, 0, 0, 0.85);">Zählerstände</span>
                      <button class="ant-btn ant-btn-default add-reading-btn" style="font-size: 12px; height: 32px; padding: 0 16px;" data-meter-id="${meter.id}">
                        <span role="img" class="anticon">
                          <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="black"></path>
                          </svg>
                        </span>
                        <span>Stand hinzufügen</span>
                      </button>
                    </div>
                    
                    <div class="readings-table" style="background: #fff; clear: both; max-width: 100%; border-radius: 0.4rem; border: 0.2rem solid #eee; overflow: hidden;">
                      <div class="readings-list">
                        <div class="readings-loading" style="display: none; padding: 16px; text-align: center;">
                          <div class="ant-spin ant-spin-spinning" style="margin-bottom: 8px;">
                            <span class="ant-spin-dot ant-spin-dot-spin" style="color: #1890ff;">
                              <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.3;"></i>
                              <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.5;"></i>
                              <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.7;"></i>
                              <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.9;"></i>
                            </span>
                          </div>
                          <div style="color: rgba(0, 0, 0, 0.65); font-size: 12px;">Lade Zählerstände...</div>
                        </div>
                        <div class="readings-empty" style="padding: 16px; text-align: center; color: rgba(0, 0, 0, 0.45); font-size: 14px;">
                          Keine Zählerstände verfügbar
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              `
                })
                .join('')

              return `
              <div class="building-group" style="margin-bottom: 24px;">
                <div class="building-header" style="display: flex; align-items: center; gap: 8px; padding: 12px 16px; background: #f5f5f5; border-bottom: 2px solid #d9d9d9; margin-bottom: 8px;">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: rgba(0, 0, 0, 0.65);">
                    <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <h3 style="margin: 0; font-size: 16px; font-weight: 600; color: rgba(0, 0, 0, 0.85);">${escapeHtml(building.name)}</h3>
                  <span style="font-size: 14px; color: rgba(0, 0, 0, 0.45);">(${buildingMeters.length} ${buildingMeters.length === 1 ? 'Zähler' : 'Zähler'})</span>
                </div>
                <div class="building-meters" style="padding-left: 8px;">
                  ${buildingMetersHTML}
                </div>
              </div>
            `
            })
            .join('')
        : `
          <div style="text-align: center; padding: 32px; color: rgba(0, 0, 0, 0.45);">
            <div style="font-size: 16px; margin-bottom: 8px;">Keine Zähler gefunden</div>
            <div style="font-size: 14px;">Legen Sie Zähler im Bereich Technische Anlagen an (Typ „Zähler“).</div>
          </div>
        `

    meterReadingsContainer.innerHTML = `
        <div class="ant-row ant-form-item ant-form-item-with-help" style="row-gap: 0px;">
          <div class="ant-col ant-form-item-control">
            <div class="ant-form-item-control-input">
              <div class="ant-form-item-control-input-content">
                <div class="meter-readings-container">
                  <div class="meter-readings-header" style="margin-bottom: 24px;">
                    <h3 style="margin: 0 0 16px 0; font-size: 16px; font-weight: 600;">Zählerstände verwalten</h3>
                    <p style="margin: 0; color: rgba(0, 0, 0, 0.65); font-size: 14px;">
                      Zählerstände für die Zähler aus Technische Anlagen. Neue Zähler legen Sie dort als Typ „Zähler“ an.
                    </p>
                  </div>
                  
                  <div class="loading-state" style="text-align: center; padding: 48px 0;">
                    <div class="ant-spin ant-spin-spinning" style="margin-bottom: 16px;">
                      <span class="ant-spin-dot ant-spin-dot-spin" style="color: #1890ff;">
                        <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.3;"></i>
                        <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.5;"></i>
                        <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.7;"></i>
                        <i class="ant-spin-dot-item" style="background-color: #1890ff; opacity: 0.9;"></i>
                        </span>
                    </div>
                    <div style="color: rgba(0, 0, 0, 0.65); font-size: 14px;">Lade Zählerdaten...</div>
                          </div>
                  
                  <div class="meters-overview" style="display: none;">
                    <div class="meters-header" style="margin-bottom: 24px;">
                      <div style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 16px;">
                        <button class="ant-btn ant-btn-default share-property-btn" style="font-size: 12px; height: 32px; padding: 0 16px;">
                          <span role="img" class="anticon">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" fill="currentColor"/>
                            </svg>
                          </span>
                          <span>Alle Zähler teilen</span>
                        </button>
                      </div>
                      
                      <div style="position: relative; margin-bottom: 16px;">
                        <input type="text" id="meter-search" placeholder="Suche" style="width: 100%; padding: 12px 16px 12px 40px; border: 1px solid #d9d9d9; border-radius: 6px; font-size: 14px; background: white;">
                        <svg style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; color: rgba(0, 0, 0, 0.45);" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/>
                        </svg>
                      </div>
                    </div>
                    
                    <div class="meters-list" style="background: #fff; clear: both; max-width: 100%; border-radius: 0.4rem; border: 0.2rem solid #eee; overflow: hidden;">
                      ${metersListHTML}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ant-form-item-explain ant-form-item-explain-connected">
              <div role="alert" class="" style=""></div>
            </div>
          </div>
        </div>
      `

    // Function to show content when everything is loaded
    function showMeterContent() {
      const loadingState =
        meterReadingsContainer.querySelector('.loading-state')
      const metersOverview =
        meterReadingsContainer.querySelector('.meters-overview')

      if (loadingState) loadingState.style.display = 'none'
      if (metersOverview) metersOverview.style.display = 'block'
    }

    // Helper function to get meter type text
    function getMeterTypeText(meterType) {
      const typeMap = {
        WATER: 'Wasser',
        GAS: 'Gas',
        ELECTRICITY: 'Strom',
        ENERGY: 'Strom',
      }
      return typeMap[meterType] || meterType || 'Unbekannt'
    }

    // Helper function to get meter icon
    function getMeterIcon(meterType) {
      const iconMap = {
        WATER: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #1890ff;">
            <path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zM7.83 14c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12-.08-.45.28-.87.74-.87z" fill="currentColor"/>
          </svg>`,
        ENERGY: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #faad14;"><path d="M7 2v11h3v9l7-12h-4l4-8z" fill="currentColor"/></svg>`,
        ELECTRICITY: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #faad14;">
            <path d="M7 2v11h3v9l7-12h-4l4-8z" fill="currentColor"/>
          </svg>`,
        GAS: `<svg width="16" height="16" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #ff4d4f;"><path fill="currentColor" d="M143.38 17.85a8 8 0 0 0-12.63 3.41l-22 60.41l-24.16-23.41a8 8 0 0 0-11.93.89C51 87.53 40 116.08 40 144a88 88 0 0 0 176 0c0-59.45-50.79-108-72.62-126.15m40.51 135.49a57.6 57.6 0 0 1-46.56 46.55a7.7 7.7 0 0 1-1.33.11a8 8 0 0 1-1.32-15.89c16.57-2.79 30.63-16.85 33.44-33.45a8 8 0 0 1 15.78 2.68Z"/></svg>`,
      }
      return (
        iconMap[meterType] ||
        `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: rgba(0, 0, 0, 0.45);"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/></svg>`
      )
    }

    // Initialize meter readings API
    const meterApi = new window.MeterReadingsApi()

    // Ensure the API is available
    if (!window.MeterReadingsApi) {
      console.error('MeterReadingsApi not available')
      return meterReadingsContainer
    }

    // Load meter readings for each meter
    async function loadMeterReadings(meterId, readingsTable) {
      try {
        // Show loading spinner
        const loadingElement = readingsTable.querySelector('.readings-loading')
        const emptyElement = readingsTable.querySelector('.readings-empty')
        const readingsList = readingsTable.querySelector('.readings-list')

        if (loadingElement) loadingElement.style.display = 'block'
        if (emptyElement) emptyElement.style.display = 'none'

        // Get domainId from localStorage token
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
        const domainId = decodedToken.domainId || 1

        if (!actualPropertyId) {
          console.error('Property ID not found for loading readings')
          return Promise.resolve()
        }

        const readings = await meterApi.getReadings(
          actualPropertyId,
          meterId,
          domainId
        )

        if (readings.length > 0) {
          const readingsHTML = readings
            .map(
              (reading) => `
              <div class="reading-item" style="padding: 16px; border-bottom: 1px solid #d9d9d9; display: flex; justify-content: space-between; align-items: center;">
                <div style="flex: 1; display: flex; gap: 24px; align-items: center;">
                  <div style="min-width: 100px; font-size: 14px; color: rgba(0, 0, 0, 0.85);">
                    ${new Date(reading.readingDate).toLocaleDateString('de-DE')}
                  </div>
                  <div style="min-width: 80px; font-size: 14px; font-weight: 500; color: rgba(0, 0, 0, 0.85); text-align: right;">
                    ${parseFloat(reading.reading).toLocaleString('de-DE')}
                  </div>
                  <div style="flex: 1; font-size: 14px; color: rgba(0, 0, 0, 0.85);">
                    ${reading.notes ? escapeHtml(reading.notes) : '-'}
                  </div>
                </div>
                <div style="display: flex; gap: 8px;">
                  ${
                    reading.attachmentUrl
                      ? `
                    <a href="${constructSharePointUrl(reading.attachmentUrl)}" target="_blank" class="ant-btn ant-btn-text ant-btn-icon-only" title="Anhang öffnen" style="padding: 6px; color: #1890ff;">
                      <span class="anticon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="2" fill="none"/>
                          <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" fill="none"/>
                          <path d="M14 2v6h6" stroke="currentColor" stroke-width="2" fill="none"/>
                        </svg>
                      </span>
                    </a>
                  `
                      : ''
                  }
                  <button class="ant-btn ant-btn-text ant-btn-icon-only delete-reading-btn" title="Löschen" data-reading-id="${reading.id}" style="padding: 6px; color: #ff4d4f;">
                    <span class="anticon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor"/>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            `
            )
            .join('')

          // Hide loading spinner and show readings
          if (loadingElement) loadingElement.style.display = 'none'
          if (emptyElement) emptyElement.style.display = 'none'
          readingsTable.querySelector('.readings-list').innerHTML = readingsHTML
        } else {
          // Hide loading spinner and show empty state
          if (loadingElement) loadingElement.style.display = 'none'
          if (emptyElement) emptyElement.style.display = 'block'
        }
      } catch (error) {
        console.error('Error loading meter readings:', error)
        // Hide loading spinner and show error
        if (loadingElement) loadingElement.style.display = 'none'
        if (emptyElement) emptyElement.style.display = 'none'
        readingsTable.querySelector('.readings-list').innerHTML = `
            <div style="padding: 12px 16px; text-align: center; color: #ff4d4f; font-size: 12px;">
              Fehler beim Laden der Zählerstände
            </div>
          `
      }

      return Promise.resolve()
    }

    // Show content immediately since we're not pre-loading all readings
    showMeterContent()

    // Add search functionality
    const searchInput = meterReadingsContainer.querySelector('#meter-search')
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase()
        const meterItems =
          meterReadingsContainer.querySelectorAll('.meter-item')

        meterItems.forEach((item) => {
          const meterName = item
            .querySelector('.meter-header div:first-child div:first-child')
            .textContent.toLowerCase()
          const meterInfo = item
            .querySelector('.meter-header div:first-child div:last-child')
            .textContent.toLowerCase()

          if (
            meterName.includes(searchTerm) ||
            meterInfo.includes(searchTerm)
          ) {
            item.style.display = 'block'
          } else {
            item.style.display = 'none'
          }
        })
      })
    }

    // Add click handlers for expanding/collapsing meters
    const meterItems = meterReadingsContainer.querySelectorAll('.meter-item')
    meterItems.forEach((item) => {
      const header = item.querySelector('.meter-header')
      const content = item.querySelector('.meter-content')
      const expandIcon = item.querySelector('.meter-expand-icon')

      // Add hover effect
      header.addEventListener('mouseenter', () => {
        item.style.backgroundColor = '#fafafa'
      })

      header.addEventListener('mouseleave', () => {
        item.style.backgroundColor = 'white'
      })

      header.addEventListener('click', () => {
        const isExpanded = content.style.display !== 'none'

        if (isExpanded) {
          content.style.display = 'none'
          expandIcon.textContent = '▼'
        } else {
          content.style.display = 'block'
          expandIcon.textContent = '▲'

          // Load readings when expanding
          const meterId = item.getAttribute('data-meter-id')
          const readingsTable = content.querySelector('.readings-table')
          if (readingsTable) {
            loadMeterReadings(meterId, readingsTable)
          }
        }
      })
    })

    // Add event listeners for meter readings functionality
    const addReadingBtns =
      meterReadingsContainer.querySelectorAll('.add-reading-btn')

    addReadingBtns.forEach((btn) => {
      btn.addEventListener('click', async () => {
        const meterId = btn.getAttribute('data-meter-id')
        const meter = allMeters.find((m) => m.id === parseInt(meterId))

        // Create a simple modal for adding readings
        const modal = document.createElement('div')
        modal.style.cssText = `
            position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
            background: rgba(0,0,0,0.5); display: flex; align-items: center; 
            justify-content: center; z-index: 100000;
          `

        modal.innerHTML = `
            <div class="lux-meter-reading-modal" style="background: white; padding: 24px; border-radius: 8px; min-width: 400px;">
              <h3 style="margin: 0 0 16px 0;">Neuer Zählerstand für ${escapeHtml(meter?.name || 'Zähler')}</h3>
              <div style="margin-bottom: 16px;">
                <label style="display: block; margin-bottom: 4px; font-weight: 500;">Datum:</label>
                <div id="reading-date-container"></div>
              </div>
              <div style="margin-bottom: 16px;">
                <label style="display: block; margin-bottom: 4px; font-weight: 500;">Zählerstand:</label>
                <input type="number" id="reading-value" class="ant-input" step="0.01" placeholder="0,00">
              </div>
              <div style="margin-bottom: 16px;">
                <label style="display: block; margin-bottom: 4px; font-weight: 500;">Notizen (optional):</label>
                <textarea id="reading-notes" class="ant-input" rows="3" placeholder="Zusätzliche Notizen..."></textarea>
              </div>
              <div style="margin-bottom: 16px;">
                <label style="display: block; margin-bottom: 4px; font-weight: 500;">Foto/Anhang (optional):</label>
                <div id="reading-attachment-container"></div>
                <div style="font-size: 12px; color: #666; margin-top: 4px;">PNG, JPG, PDF bis 10MB</div>
              </div>
              <div style="display: flex; gap: 8px; justify-content: flex-end;">
                <button class="ant-btn ant-btn-default" id="cancel-reading">Abbrechen</button>
                <button class="ant-btn ant-btn-primary" id="save-reading">Speichern</button>
              </div>
            </div>
          `

        document.body.appendChild(modal)

        // Initialize datePicker for reading date
        const readingDateContainer = modal.querySelector(
          '#reading-date-container'
        )
        const readingDatePicker = datePicker('reading-date')
        readingDatePicker.setValue(new Date().toISOString())
        readingDateContainer.appendChild(readingDatePicker.wrapper)

        const attachmentPicker = filePicker({
          id: `reading-attachment-${meterId}`,
          accept: 'image/*,.pdf',
          placeholder: 'Datei auswählen...',
          validateFile: (file) => {
            const maxSize = 10 * 1024 * 1024
            if (file.size > maxSize) {
              return 'Datei ist zu groß. Maximal 10 MB.'
            }
            return true
          },
        })
        modal
          .querySelector('#reading-attachment-container')
          .appendChild(attachmentPicker.wrapper)

        // Handle save
        modal
          .querySelector('#save-reading')
          .addEventListener('click', async () => {
            const saveButton = modal.querySelector('#save-reading')
            const originalText = saveButton.textContent

            // Prevent double submission
            if (saveButton.disabled) return

            const readingDate = readingDatePicker.getValue()
            const readingValue = modal.querySelector('#reading-value').value
            const notes = modal.querySelector('#reading-notes').value
            const attachmentFile = attachmentPicker.getFile()

            if (!readingDate || !readingValue) {
              alert('Bitte füllen Sie alle Pflichtfelder aus.')
              return
            }

            // Show loading state
            saveButton.disabled = true
            saveButton.innerHTML = `
              <div style="display: flex; align-items: center; gap: 8px;">
                <div style="width: 16px; height: 16px; border: 2px solid #ffffff; border-top: 2px solid transparent; border-radius: 50%; animation: spin 1s linear infinite;"></div>
                Speichern...
              </div>
            `

            try {
              // Get domainId from localStorage token
              const authData = JSON.parse(localStorage.getItem('auth') || '{}')
              const decodedToken = JSON.parse(
                atob(authData.token.split('.')[1])
              )
              const domainId = decodedToken.domainId || 1

              if (!actualPropertyId) {
                throw new Error(
                  'Property ID not found. Please refresh the page and try again.'
                )
              }

              const readingData = {
                propertyId: actualPropertyId,
                meterId,
                reading: readingValue,
                readingDate,
                notes: notes || null,
              }
              const key = JSON.stringify(readingData)
              if (modal.dataset.savedReadingKey !== key) {
                const newReading = await meterApi.createReading(readingData)
                modal.dataset.savedReadingKey = key
                modal.dataset.savedReadingId = String(newReading.id)
              }

              // Upload attachment if file is selected
              if (attachmentFile) {
                const uploadFormData = new FormData()
                uploadFormData.append('file', attachmentFile)
                uploadFormData.append('readingId', modal.dataset.savedReadingId)
                uploadFormData.append('propertyId', actualPropertyId.toString())
                uploadFormData.append('meterId', meterId.toString())
                uploadFormData.append('meterSource', 'technical-asset')

                const uploadResponse = await fetch(
                  '/api/meter-readings/upload-attachment',
                  {
                    method: 'POST',
                    headers: {
                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth') || '{}').token}`,
                    },
                    body: uploadFormData,
                  }
                )

                if (!uploadResponse.ok) {
                  const uploadError = await uploadResponse.json()
                  throw new Error(
                    'Der Zählerstand wurde gespeichert, aber der Anhang nicht. Bitte erneut speichern. ' +
                      (uploadError.error || 'Upload fehlgeschlagen.')
                  )
                }
              }

              // Reload readings
              const meterItem = meterReadingsContainer
                .querySelector(`.add-reading-btn[data-meter-id="${meterId}"]`)
                .closest('.meter-item')
              const readingsTable = meterItem.querySelector('.readings-table')
              if (readingsTable) {
                loadMeterReadings(meterId, readingsTable)
              }

              document.body.removeChild(modal)
            } catch (error) {
              alert('Fehler beim Speichern: ' + error.message)

              // Reset button state on error
              saveButton.disabled = false
              saveButton.textContent = originalText
            }
          })

        // Handle cancel
        modal.querySelector('#cancel-reading').addEventListener('click', () => {
          document.body.removeChild(modal)
        })
      })
    })

    // Handle edit and delete reading buttons
    meterReadingsContainer.addEventListener('click', async (event) => {
      const deleteBtn = event.target.closest('.delete-reading-btn')

      if (deleteBtn) {
        const readingId = deleteBtn.getAttribute('data-reading-id')
        if (
          confirm(
            'Sind Sie sicher, dass Sie diesen Zählerstand löschen möchten?'
          )
        ) {
          try {
            await meterApi.deleteReading(readingId)

            // Reload readings for the specific meter
            const meterItem = deleteBtn.closest('.meter-item')
            const meterId = meterItem.getAttribute('data-meter-id')
            const readingsTable = meterItem.querySelector('.readings-table')
            if (readingsTable) {
              loadMeterReadings(meterId, readingsTable)
            }
          } catch (error) {
            alert('Fehler beim Löschen: ' + error.message)
          }
        }
      }
    })

    // Handle sharing buttons
    meterReadingsContainer.addEventListener('click', async (event) => {
      const shareMeterBtn = event.target.closest('.share-meter-btn')
      const sharePropertyBtn = event.target.closest('.share-property-btn')

      if (shareMeterBtn) {
        const meterId = shareMeterBtn.getAttribute('data-meter-id')
        const meter = allMeters.find((m) => m.id === parseInt(meterId))
        // Get domainId from localStorage token
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
        const domainId = decodedToken.domainId || 1

        if (!actualPropertyId) {
          alert('Property ID nicht gefunden. Bitte laden Sie die Seite neu.')
          return
        }

        // Generate checksum using property ID, meter ID and created field
        const checksum = generateMeterSharingChecksum(
          actualPropertyId,
          meterId,
          propertyData.created
        )
        const shareUrl = `${window.location.origin}/dienstleister/zaehler/${domainId}-${actualPropertyId}-${meterId}-${checksum}`

        // Create sharing modal
        const modal = document.createElement('div')
        modal.style.cssText = `
            position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
            background: rgba(0,0,0,0.5); display: flex; align-items: center; 
            justify-content: center; z-index: 100000;
          `

        modal.innerHTML = `
            <div style="background: white; padding: 24px; border-radius: 8px; min-width: 500px;">
              <h3 style="margin: 0 0 16px 0;">Zähler teilen</h3>
              <p style="margin: 0 0 16px 0; color: rgba(0, 0, 0, 0.65);">
                Teilen Sie diesen Link mit dem Dienstleister, um Zählerstände für <strong>${escapeHtml(meter?.name || 'Zähler')}</strong> zu erfassen:
              </p>
              <div style="margin-bottom: 16px;">
                <input type="text" id="share-url" value="${shareUrl}" readonly style="width: 100%; padding: 8px 12px; border: 1px solid #d9d9d9; border-radius: 4px; font-family: monospace; font-size: 12px; background: #f5f5f5;">
              </div>
              <div style="display: flex; gap: 8px; justify-content: flex-end;">
                <button class="ant-btn ant-btn-default" id="cancel-share">Abbrechen</button>
                <button class="ant-btn ant-btn-primary" id="copy-share-url">Link kopieren</button>
              </div>
            </div>
          `

        document.body.appendChild(modal)

        // Handle copy
        modal
          .querySelector('#copy-share-url')
          .addEventListener('click', async () => {
            const urlInput = modal.querySelector('#share-url')
            try {
              await navigator.clipboard.writeText(urlInput.value)
              alert('Link wurde in die Zwischenablage kopiert!')
              document.body.removeChild(modal)
            } catch (error) {
              // Fallback for older browsers
              urlInput.select()
              document.execCommand('copy')
              alert('Link wurde in die Zwischenablage kopiert!')
              document.body.removeChild(modal)
            }
          })

        // Handle cancel
        modal.querySelector('#cancel-share').addEventListener('click', () => {
          document.body.removeChild(modal)
        })
      }

      if (sharePropertyBtn) {
        // Get domainId from localStorage token
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
        const domainId = decodedToken.domainId || 1

        if (!actualPropertyId) {
          alert('Property ID nicht gefunden. Bitte laden Sie die Seite neu.')
          return
        }

        // Generate checksum using property ID and created field
        const checksum = generateSharingChecksum(
          actualPropertyId,
          propertyData.created
        )
        const shareUrl = `${window.location.origin}/dienstleister/zaehler/property/${domainId}-${actualPropertyId}-${checksum}`

        // Create sharing modal
        const modal = document.createElement('div')
        modal.style.cssText = `
            position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
            background: rgba(0,0,0,0.5); display: flex; align-items: center; 
            justify-content: center; z-index: 100000;
          `

        modal.innerHTML = `
            <div style="background: white; padding: 24px; border-radius: 8px; min-width: 500px;">
              <h3 style="margin: 0 0 16px 0;">Alle Zähler teilen</h3>
              <p style="margin: 0 0 16px 0; color: rgba(0, 0, 0, 0.65);">
                Teilen Sie diesen Link mit dem Dienstleister, um Zählerstände für <strong>alle ${allMeters.length} Zähler</strong> dieser Immobilie zu erfassen:
              </p>
              <div style="margin-bottom: 16px;">
                <input type="text" id="share-url" value="${shareUrl}" readonly style="width: 100%; padding: 8px 12px; border: 1px solid #d9d9d9; border-radius: 4px; font-family: monospace; font-size: 12px; background: #f5f5f5;">
              </div>
              <div style="display: flex; gap: 8px; justify-content: flex-end;">
                <button class="ant-btn ant-btn-default" id="cancel-share">Abbrechen</button>
                <button class="ant-btn ant-btn-primary" id="copy-share-url">Link kopieren</button>
              </div>
            </div>
          `

        document.body.appendChild(modal)

        // Handle copy
        modal
          .querySelector('#copy-share-url')
          .addEventListener('click', async () => {
            const urlInput = modal.querySelector('#share-url')
            try {
              await navigator.clipboard.writeText(urlInput.value)
              alert('Link wurde in die Zwischenablage kopiert!')
              document.body.removeChild(modal)
            } catch (error) {
              // Fallback for older browsers
              urlInput.select()
              document.execCommand('copy')
              alert('Link wurde in die Zwischenablage kopiert!')
              document.body.removeChild(modal)
            }
          })

        // Handle cancel
        modal.querySelector('#cancel-share').addEventListener('click', () => {
          document.body.removeChild(modal)
        })
      }
    })

    return meterReadingsContainer
  }

  window.__impowerxRefreshMeterReadings = async (eventPropertyId) => {
    if (Number(eventPropertyId) !== propertyId) return
    const current = document.querySelector(
      '#MeterReadingsSection .meter-readings-container'
    )
    if (!current || current.dataset.refreshing === 'true') return
    current.dataset.refreshing = 'true'
    try {
      const replacement = await createMeterReadingsSectionContent()
      replacement.classList.add('section-content')
      replacement.style.display = current.style.display || 'block'
      current.replaceWith(replacement)
    } catch (error) {
      current.dataset.refreshing = 'false'
      console.error('Zählerstände could not be refreshed:', error)
    }
  }
  if (!window.__impowerxMeterRefreshWired) {
    window.__impowerxMeterRefreshWired = true
    document.addEventListener('lux-technical-assets-refreshed', (event) => {
      void window.__impowerxRefreshMeterReadings?.(event.detail?.propertyId)
    })
  }

  function propertyFormSection(
    { id, title, hasSubSection },
    sectionContentFunction
  ) {
    const sectionNumber = getNextSectionNumber()
    const section = document.createElement('div')
    section.className = 'FormSection'
    section.id = id
    // Lets initializeComponent tell a section of this property apart from one left over
    // from a previously opened property.
    section.dataset.propertyHrId = propertyHrId
    section.innerHTML = `
        <div class="form-section-wrapper">
          <div class="main-section-header section-header not-open">
            <div class="section-number-box">
              <div class="section-number">${sectionNumber}</div>
            </div>
            <div class="section-title-box">
              <div class="section-title">${title}</div>
            </div>
          </div>
        </div>
      `

    propertyFormSidebarLink({ id, title, hasSubSection }, sectionNumber)

    function ensureSectionContentExists(wrapper) {
      let sectionContent = wrapper.querySelector('.section-content')
      if (!sectionContent) {
        // Handle async content functions
        if (sectionContentFunction.constructor.name === 'AsyncFunction') {
          sectionContentFunction().then((content) => {
            if (content) {
              content.classList.add('section-content')
              wrapper.appendChild(content)
              content.style.display = 'block'
            }
          })
          // Return a placeholder element for now
          sectionContent = document.createElement('div')
          sectionContent.className = 'section-content'
          sectionContent.style.display = 'none'
          wrapper.appendChild(sectionContent)
        } else {
          sectionContent = sectionContentFunction()
          sectionContent.classList.add('section-content')
          wrapper.appendChild(sectionContent)
        }
      }
      return sectionContent
    }

    function addEventListeners(section) {
      const sectionWrapper = section.querySelector('.form-section-wrapper')
      const sectionHeader = section.querySelector(
        '.main-section-header.section-header'
      )
      const sectionNumberBox = section.querySelector('.section-number-box')
      const sectionTitleBox = section.querySelector('.section-title-box')
      let sectionContent

      if (section) {
        sectionHeader.addEventListener('click', () => {
          sectionWrapper.classList.toggle('open')
          if (sectionHeader.classList.contains('not-open')) {
            replaceElementClass(sectionHeader, 'not-open', 'open')
            sectionContent = ensureSectionContentExists(sectionWrapper)
            sectionContent.style.display = 'block'

            setTimeout(() => {
              section.scrollIntoView({ behavior: 'smooth' })
            }, 100)
          } else {
            replaceElementClass(sectionHeader, 'open', 'not-open')
            sectionContent = sectionWrapper.querySelector('.section-content')
            if (sectionContent) {
              sectionContent.style.display = 'none'
            }
          }

          sectionNumberBox.classList.toggle('open')
          sectionTitleBox.classList.toggle('open')
        })
      }
    }

    addEventListeners(section)

    // Sidebar open path looks this up; without it injected sections never get a
    // content function and insertElements paints into a hidden sibling node.
    section._impowerxOpenSection = () => {
      const wrapper = section.querySelector('.form-section-wrapper')
      if (!wrapper) return
      const content = ensureSectionContentExists(wrapper)
      if (content) content.style.display = 'block'
    }

    return section
  }

  const createMeterReadingsFormSection = (id, title) => {
    initializeComponent(
      (config) =>
        propertyFormSection(config, createMeterReadingsSectionContent),
      { id, title }
    )
  }

  // empty default content function for sections without own content
  const createEmptySectionContent = () => {
    const container = document.createElement('div')
    return container
  }

  const createPropertyFormSection = (
    id,
    title,
    hasSubSection = false,
    contentFunction = createEmptySectionContent
  ) => {
    initializeComponent(
      (config) => propertyFormSection(config, contentFunction),
      { id, title, hasSubSection }
    )
  }

  const refreshBuildingsData = async () => {
    const buildingsData = await getImpowerXData(
      `${baseApiUrl}/api/impowerX/buildings?propertyHrId=${propertyHrId}`
    ).catch((error) => {
      console.error('Error fetching buildings:', error)
      return {}
    })
    const bList = Array.isArray(buildingsData?.buildings)
      ? buildingsData?.buildings
      : []
    const bFields =
      buildingsData?.fields && typeof buildingsData.fields === 'object'
        ? buildingsData.fields
        : {}
    resolveLoadedBuildings(bList)
    return {
      buildings: bList,
      buildingFieldsMap: bFields,
      buildingsLoaded: Array.isArray(buildingsData?.buildings),
    }
  }
  // Starts with the page so insurance does not wait for the properties and contacts loads below.
  const initialBuildingsRequest = refreshBuildingsData()

  let insuranceOverview = null
  const startInsuranceOverview = () => {
    insuranceOverview ??= injectInsurancePropertyTable({
      propertyId,
      propertyHrId,
      buildingsRequest: initialBuildingsRequest,
    })
  }

  const waitForPageLoad = setInterval(() => {
    const entwurfTag = document.querySelector('span.ant-tag')
    if (entwurfTag && entwurfTag.textContent.trim() === 'Entwurf') {
      isDraft = true
    }

    const propertyForm = document.querySelector('.form-content > div')
    if (propertyForm) {
      if (
        propertyForm.getAttribute('data-impowerx-property-enhanced') ===
        propertyHrId
      ) {
        clearInterval(waitForPageLoad)
        startInsuranceOverview()
        return
      }
      propertyForm.setAttribute('data-impowerx-property-enhanced', propertyHrId)
      clearInterval(waitForPageLoad)
      createPropertyFormSection(
        'NotesSection',
        'Notizen',
        false,
        createNotesSectionContent
      )
      createPropertyFormSection(
        'ContactRolesSection',
        'Dienstleister',
        false,
        createContactRolesSectionContent
      )
      createPropertyFormSection(
        'TaskAutomatorSection',
        'Aufgaben-Automator',
        false,
        () =>
          createTaskAutomatorSectionContent({
            propertyId,
            propertyHrId,
            baseApiUrl,
          })
      )
      startInsuranceOverview()
      const technicalAssetsSectionReused =
        document.getElementById('TechnicalAssetsSection')?.dataset
          .propertyHrId === propertyHrId
      createPropertyFormSection(
        'TechnicalAssetsSection',
        'Technische Anlagen',
        false,
        buildTechnicalAssetsSectionContent
      )
      // SPA return to the same property: the section node is already in the form, so
      // initializeComponent keeps it. Refetch its mounted tables. (A section left over
      // from another property is rebuilt above and fetches on its own.)
      if (technicalAssetsSectionReused) scheduleTechnicalAssetsTableRefresh()
      createMeterReadingsFormSection('MeterReadingsSection', 'Zählerstände')
      // Keep "Technische Anlagen" directly above "Versicherungen" with sequential numbering.
      initTechnicalAssetsSectionOrder()
    }
  }, 500)

  const propertiesData = await getImpowerXData(
    `${baseApiUrl}/api/impowerX/properties?propertyHrId=${propertyHrId}`
  ).catch((error) => {
    console.error('Error fetching properties:', error)
    return {}
  })
  window.__luxPropertyApprovalDefaults = propertiesData?.approvalDefaults || {}
  window.__luxPropertyExternalApprovalEnabled =
    propertiesData?.externalApprovalEnabled
  window.__luxPropertyExternalApprovalSkip = propertiesData?.fields?.find(
    (field) => field.name === 'proprety_allow_skip_external_approval'
  )?.value
  window.__luxPropertyApprovalRoleAvailability =
    propertiesData?.approvalRoleAvailability || {}
  const fields = Array.isArray(propertiesData?.fields)
    ? propertiesData?.fields
    : []

  const contactsData = await getImpowerXData(
    `${baseApiUrl}/api/impowerX/contacts`
  ).catch((error) => {
    console.error('Error fetching contacts:', error)
    return {}
  })
  const contacts = Array.isArray(contactsData?.contacts)
    ? contactsData?.contacts
    : []

  const contactOptions = contacts.map((contact) => ({
    label: contact?.companyName
      ? contact.companyName
      : contact?.firstName + ' ' + contact?.lastName,
    value: contact?.id,
  }))

  const fieldsWithContactOptions = fields.map((field) => {
    if (field.fieldType === 'ContactComboBox') {
      return {
        ...field,
        options: [...(field.options || []), ...contactOptions],
      }
    }
    if (field.fieldType === 'ContactMultiSelect') {
      return {
        ...field,
        options: [...(field.options || []), ...contactOptions],
      }
    }
    return field
  })

  const fieldsMerged =
    typeof ensureInternalApprovalPropertyFields === 'function'
      ? ensureInternalApprovalPropertyFields(fieldsWithContactOptions)
      : fieldsWithContactOptions

  const externalSkipApprovalOptionLabel =
    'Externe Rechnungsfreigabe überspringen möglich'
  const fieldsForSections = fieldsMerged.map((field) => {
    if (field.name !== 'proprety_allow_skip_external_approval') return field
    const options = (field.options || []).map((opt) =>
      opt && String(opt.value) === 'true'
        ? { ...opt, label: externalSkipApprovalOptionLabel }
        : opt
    )
    return {
      ...field,
      options: options.length
        ? options
        : [{ label: externalSkipApprovalOptionLabel, value: 'true', order: 0 }],
    }
  })

  const sections = {}
  for (const field of fieldsForSections) {
    const { section, subSection, newSection } = field

    if (!sections[section]) sections[section] = {}

    if (!sections[section][subSection])
      sections[section][subSection] = { fields: [], newSectionPlacement: null }
    if (newSection)
      sections[section][subSection].newSectionPlacement = newSection
    sections[section][subSection].fields.push(field)
  }

  let heatingElectricianConfig = null
  if (!sections['BuildingEquipment']) sections['BuildingEquipment'] = {}
  if (!sections['BuildingEquipment']['Heating'])
    sections['BuildingEquipment']['Heating'] = {
      fields: [],
      newSectionPlacement: null,
    }
  const heatingFields = sections['BuildingEquipment']['Heating'].fields
  const hasHeatingElectrician = heatingFields.some(
    (f) =>
      f.name === 'property_heating_electrician' &&
      f.fieldType === 'ContactMultiSelect'
  )
  if (!hasHeatingElectrician) {
    heatingFields.push({
      id: 'heating-electrician',
      name: 'property_heating_electrician',
      label: 'Elektriker',
      fieldType: 'ContactMultiSelect',
      section: 'BuildingEquipment',
      subSection: 'Heating',
      options: contactOptions,
      value: '',
    })
  }
  const hasHeatingAdditionalMaintenance = heatingFields.some(
    (f) =>
      f.name === 'property_heating_additional_maintenance_companies' &&
      f.fieldType === 'ContactMultiSelect'
  )
  if (!hasHeatingAdditionalMaintenance) {
    heatingFields.push({
      id: 'heating-additional-maintenance-companies',
      name: 'property_heating_additional_maintenance_companies',
      label: 'Weitere Wartungsfirmen',
      fieldType: 'ContactMultiSelect',
      section: 'BuildingEquipment',
      subSection: 'Heating',
      options: contactOptions,
      value: '',
    })
  }
  const observers = []
  observers.push({ disconnect: () => insuranceOverview?.disconnect() })
  const shouldDisableInjectedFields = () => {
    const isInEditMode = localStorage.getItem('isInEditMode') === 'true'
    return !(isDraft || isInEditMode)
  }

  const getHeatingElectricianFieldConfig = () =>
    heatingElectricianConfig?.fields?.find(
      (f) =>
        f.fieldType === 'ContactMultiSelect' &&
        f.name === 'property_heating_electrician'
    ) || null

  const getHeatingElectricianPayloadFromConfig = () => {
    const heatingFieldConfig = getHeatingElectricianFieldConfig()
    if (!heatingFieldConfig) return {}
    const raw = heatingFieldConfig.value
    try {
      if (raw && typeof raw === 'string') {
        const parsed = JSON.parse(raw)
        if (parsed && typeof parsed === 'object') return { ...parsed }
      } else if (raw && typeof raw === 'object') {
        return { ...raw }
      }
    } catch (_) {}
    return {}
  }

  const getHeatingAdditionalMaintenanceFieldConfig = () =>
    heatingElectricianConfig?.fields?.find(
      (f) =>
        f.fieldType === 'ContactMultiSelect' &&
        f.name === 'property_heating_additional_maintenance_companies'
    ) || null

  const getHeatingAdditionalMaintenancePayloadFromConfig = () => {
    const fieldConfig = getHeatingAdditionalMaintenanceFieldConfig()
    if (!fieldConfig) return {}
    const raw = fieldConfig.value
    try {
      if (raw && typeof raw === 'string') {
        const parsed = JSON.parse(raw)
        if (parsed && typeof parsed === 'object') return { ...parsed }
      } else if (raw && typeof raw === 'object') {
        return { ...raw }
      }
    } catch (_) {}
    return {}
  }

  const getBuildingBaujahrFieldDef = () =>
    (propertiesData?.fields || []).find(
      (f) => f.name === 'property_building_baujahr'
    ) || null

  const getBuildingBaujahrPayloadFromConfig = () => {
    const fieldDef = getBuildingBaujahrFieldDef()
    if (!fieldDef) return {}
    const raw = fieldDef.value
    try {
      if (raw && typeof raw === 'string') {
        const parsed = JSON.parse(raw)
        if (parsed && typeof parsed === 'object') return { ...parsed }
      } else if (raw && typeof raw === 'object') {
        return { ...raw }
      }
    } catch (_) {}
    return {}
  }

  const observer = new MutationObserver((mutations) => {
    if (mutations[0].oldValue?.includes('open')) {
      $(mutations[0].target)
        .closest('.main-link')
        .find('.impowerx-sidebar-link')
        .remove()
    }
  })
  observers.push(observer)

  const arrowWrapperToObserve = document.querySelector('.arrow-wrapper')
  if (arrowWrapperToObserve) {
    observer.observe(arrowWrapperToObserve, {
      attributeFilter: ['class'],
      attributeOldValue: true,
    })
  }

  for (let [section, subSections] of Object.entries(sections)) {
    for (let [subSection, { fields, newSectionPlacement }] of Object.entries(
      subSections
    )) {
      if (section === 'BuildingEquipment' && subSection === 'Heating') {
        heatingElectricianConfig = { fields }
        continue
      }

      const subSectionSelector = `#${section} #${subSection}`

      const insertElements = () => {
        const sectionElement = document.querySelector(`#${section}`)
        if (!sectionElement || !isFormSectionOpen(sectionElement)) return

        // Add section if it doesn't exist
        const elementInSection = $(subSectionSelector)
        if (newSectionPlacement?.startsWith('After:')) {
          const element = $(`#${newSectionPlacement.replace('After:', '')}`)
          if (element.length && !elementInSection.length) {
            if (element.hasClass('last')) {
              element.removeClass('last')
            }

            element.after(generateSubSection(subSection))
          }
        } else if (!newSectionPlacement && !elementInSection.length) {
          insertSubSectionElement(section, subSection)
        }

        // Add sidebar link if the section is open
        const SidebarSectionWrapper = document.querySelector(
          '.FormSidebar .Link.main-link .link-row.level1.active'
        )
        if (SidebarSectionWrapper) {
          const mainLinkEl = SidebarSectionWrapper.closest('.main-link')
          if (
            mainLinkEl &&
            mainLinkEl.dataset.sectionId === section &&
            !mainLinkEl.querySelector(`#sidebar-${subSection}`)
          ) {
            $(mainLinkEl).append(generateSidebarLink(subSection))
          }
          const arrowWrapper =
            SidebarSectionWrapper.querySelector('.arrow-wrapper')
          if (arrowWrapper && !arrowWrapper.classList.contains('open')) {
            $(`#sidebar-${subSection}`).remove()
          }
        }

        // Scroll to the section when the sidebar link is clicked
        $(`#sidebar-${subSection}`).on('click', () => {
          setTimeout(() => {
            if ($(`#${section} .form-section-wrapper`).hasClass('open')) {
              document
                .querySelector(subSectionSelector)
                .scrollIntoView({ behavior: 'smooth' })
            }
          }, 100)
        })

        let element = $(`${subSectionSelector} .sub-section-content`)

        const approvalNames =
          typeof LUX_INTERNAL_APPROVAL_PROPERTY_FIELD_CATALOG !== 'undefined'
            ? LUX_INTERNAL_APPROVAL_PROPERTY_FIELD_CATALOG.map((f) => f.name)
            : []
        const gridFields = fields.filter(
          (field) => approvalNames.indexOf(field.name) === -1
        )
        const approvalFields = fields.filter(
          (field) => approvalNames.indexOf(field.name) !== -1
        )

        const buildInjectedField = (field) => {
          const generated = generateInputField({
            ...field,
            isDisabled: shouldDisableInjectedFields(),
          })
          if (
            field.fieldType === 'ContactComboBox' &&
            field.value != null &&
            field.value !== ''
          ) {
            const raw = String(field.value).trim()
            const id =
              raw &&
              raw !== '""' &&
              raw !== "''" &&
              /^\d+$/.test(raw) &&
              parseInt(raw, 10) > 0
                ? raw
                : ''
            const contactSelect = generated.querySelector(
              `[name="${field.name}"]`
            )
            if (contactSelect && id) {
              contactSelect.setAttribute('data-selected-value', id)
              $(contactSelect).data('selected-value', id)
            }
          }
          return generated
        }

        gridFields.forEach((field, fieldIndex) => {
          if ($(`#${subSection} [name="${field.name}"]`).length) return

          const generateField = buildInjectedField(field)
          const isLastField = gridFields[fieldIndex + 1] ? false : true

          if (fieldIndex % 2 === 0 || field.isFullWidth || fieldIndex === 0) {
            const row = document.createElement('div')
            row.className = 'sub-section-content-row impowerx-row-' + fieldIndex
            row.appendChild(generateField)

            element.append(row)
          } else {
            const previousRow = $(
              `#${subSection} .sub-section-content-row:last-child`
            )
            previousRow.append(generateField)
          }

          if (gridFields[fieldIndex + 1]?.isFullWidth && fieldIndex % 2 === 0) {
            const emptyColumn = document.createElement('div')
            emptyColumn.className = 'sub-section-content-column'

            const previousRow = $(
              `#${subSection} .sub-section-content-row:last-child`
            )
            previousRow.append(emptyColumn)
          } else if (
            !field.isFullWidth &&
            fieldIndex % 2 === 0 &&
            isLastField
          ) {
            const row = document.createElement('div')
            row.className = 'sub-section-content-row impowerx-row-' + fieldIndex
            const emptyColumn = document.createElement('div')
            emptyColumn.className = 'sub-section-content-column'
            row.appendChild(generateField)
            row.appendChild(emptyColumn)
            element.append(row)
          }
        })

        if (
          subSection === 'PropertyCare' &&
          approvalFields.length &&
          typeof injectInternalApprovalPropertyFieldsGrouped === 'function'
        ) {
          injectInternalApprovalPropertyFieldsGrouped(approvalFields, {
            generateField: buildInjectedField,
          })
          if (typeof initInternalApprovalPropertyFields === 'function') {
            initInternalApprovalPropertyFields(propertyHrId)
          }
        }
      }

      insertElements()

      // when the section is clicked (opened), insert the elements
      $(`#${section}`).on('click', () => {
        setTimeout(() => insertElements(), 100)
      })

      // when the sidebar link is clicked, insert the elements
      $(`.FormSidebar .main-link`).on('click', () => {
        setTimeout(() => {
          if ($(`#${section} .form-section-wrapper`).hasClass('open')) {
            insertElements()
          }
        }, 100)
      })
    }
  }

  const editFunction = () => {
    const livePropertyHrIdFromPath = (window.location.pathname.match(regex) ||
      [])[1]
    if (
      !livePropertyHrIdFromPath ||
      livePropertyHrIdFromPath !== propertyHrId
    ) {
      return
    }
    // Remove any previously registered .impowerxProperty handlers before re-adding them,
    // so calling editFunction multiple times never stacks duplicate listeners.
    $(document).off('.impowerxProperty')
    setEditModeInStorage(true)
    $('.ant-radio-wrapper').removeClass('ant-radio-wrapper-disabled')
    $('.ant-radio').removeClass('ant-radio-disabled')
    $('.ant-radio-input, .ant-input')
      .removeAttr('disabled')
      .removeAttr('readonly')

    $('.ant-checkbox-wrapper').removeClass('ant-checkbox-wrapper-disabled')
    $('.ant-checkbox').removeClass('ant-checkbox-disabled')
    $('.ant-checkbox-input').removeAttr('disabled')

    $('.ant-input-affix-wrapper').removeClass(
      'ant-input-affix-wrapper-readonly ant-input-affix-wrapper-disabled disabled'
    )
    $(
      '.ant-input-disabled, .ant-input-affix-wrapper-disabled, .ant-input-number-disabled'
    ).removeClass('ant-input-disabled ant-input-number-disabled')
    $('.ant-select').removeClass('read-only ant-select-disabled')
    // ContactComboBox keeps ContactComboDisable + disabled="true" from view/save mode;
    // classes alone are cleared above — also unlock the attribute so clear/select work.
    $('.ContactComboDisable').removeAttr('disabled')
    $('.ContactComboDisable .ant-select-selection-search-input').removeAttr(
      'disabled'
    )
    $('.impowerx-select').removeAttr('disabled')
    $('.impowerx-select .ant-select-selection-search-input').removeAttr(
      'disabled'
    )

    $('.ant-input-number')
      .removeClass('ant-input-number-disabled')
      .css('border-color', '')
    $('.ant-input-number-input')
      .removeAttr('disabled')
      .removeAttr('readonly')
      .removeClass('ant-input-disabled')
      .css({ color: '', 'padding-right': '24px' })
    $('.ant-input-number .suffix')
      .css('color', '')
      .addClass('suffix-with-controls')
    $('.ant-input-number-handler-wrap').attr('style', '').show()

    // lux-picker DatePicker: enable for edit (masking / calendar live inside datePicker.js)
    document
      .querySelectorAll('.lux-picker.DatePicker[data-field-id]')
      .forEach((el) => {
        const input = el.querySelector('input')
        if (input && typeof input.setDisabled === 'function') {
          input.setDisabled(false)
        } else if (input) {
          el.classList.remove('read-only', 'lux-picker-disabled')
          input.removeAttribute('disabled')
          input.setAttribute('placeholder', 'TT.MM.JJJJ')
        }
      })
    $('.contact-multiselect-placeholder').css('visibility', 'visible')
    $('.contact-combobox-search-input').css('visibility', 'visible')

    // Per-building Baujahr: year only (digits, max 4)
    $(document).on(
      'input.impowerxProperty',
      '.impowerx-building-baujahr-year',
      function () {
        const el = this
        const digits = String(el.value).replace(/\D/g, '').slice(0, 4)
        if (el.value !== digits) el.value = digits
      }
    )
    $(document).on(
      'paste.impowerxProperty',
      '.impowerx-building-baujahr-year',
      function (e) {
        e.preventDefault()
        const paste =
          (e.originalEvent &&
            e.originalEvent.clipboardData &&
            e.originalEvent.clipboardData.getData('text')) ||
          (window.clipboardData && window.clipboardData.getData('Text')) ||
          ''
        this.value = paste.replace(/\D/g, '').slice(0, 4)
      }
    )

    $(document).on('click.impowerxProperty', '.impowerx-select', function (e) {
      if (
        $(e.target).closest(
          '.impowerx-contact-combobox-clear-btn, .impowerx-contact-combobox-clear'
        ).length
      ) {
        return
      }
      e.stopPropagation()
      const $root = $(this)
      if (
        $root.hasClass('ant-select-disabled') ||
        $root.hasClass('read-only')
      ) {
        return
      }

      const $dropdown = $(this)
        .siblings('.dropdown-wrapper')
        .find('.impowerx-select-dropdown')

      const isDropdownVisible = !$dropdown.hasClass(
        'ant-select-dropdown-hidden'
      )

      // hide all dropdowns first
      $('.impowerx-select-dropdown').addClass('ant-select-dropdown-hidden')
      $('.ant-select-dropdown').addClass('ant-select-dropdown-hidden')

      // toggle: if it was visible, keep it hidden; if it was hidden, show it
      if (!isDropdownVisible) {
        $dropdown.removeClass('ant-select-dropdown-hidden')

        if ($root.hasClass('ContactComboBox')) {
          const $searchInput = $root.find('.ant-select-selection-search-input')
          $searchInput.removeAttr('disabled')
          const previousValue = $root
            .find('.ant-select-selection-item')
            .text()
            .trim()

          if (previousValue) {
            $searchInput.attr('placeholder', previousValue)
          }
          const $selectedItem = $root.find('.ant-select-selection-item')
          $selectedItem.text('').attr('title', '')

          // focus input for immediate typing
          setTimeout(() => {
            $searchInput.trigger('focus')
          }, 0)
        }
        if ($root.hasClass('ContactMultiSelect')) {
          const $case = $root.closest('.contact-multiselect-case')
          const $list = $case.find('.contact-multiselect-list')
          const $searchInput = $case.find('.contact-multiselect-search-input')
          if ($searchInput.length) {
            $searchInput.val('')
            $case.find('.contact-multiselect-item').css('display', '')
          }
          const selectedIds = ($root.attr('data-selected-ids') || '')
            .split(',')
            .map((id) => id.trim())
            .filter(Boolean)
          const $items = $list.find('.contact-multiselect-item')
          $items.each(function () {
            const $item = $(this)
            const val = $item.data('value')
            const selected = selectedIds.includes(String(val))
            $item.toggleClass(
              'ant-select-item-option-selected contact-multiselect-item-selected',
              selected
            )
            $item.css('background-color', selected ? '#e6f7ff' : '')
            let $remove = $item.find('.contact-multiselect-remove')
            if (selected && !$remove.length) {
              $item
                .find('.ant-select-item-option-content')
                .append(
                  '<span class="contact-multiselect-remove" role="button" aria-label="Remove" style="margin-left: 8px; cursor: pointer; color: #999; font-size: 16px; line-height: 1;">×</span>'
                )
            } else if (!selected && $remove.length) $remove.remove()
          })
          const $selected = $list.find('.contact-multiselect-item-selected')
          const $rest = $list
            .find('.contact-multiselect-item')
            .not('.contact-multiselect-item-selected')
          $list.append($selected.get().concat($rest.get()))
          setTimeout(() => $searchInput.trigger('focus'), 0)
        }
      }
    })

    $('.impowerx-currency-input').on('blur', (event) => {
      const val = $(event.target).val()
      const valNumber = val.replace(/\./g, '')

      if (isNaN(valNumber.replace(',', '.'))) {
        $(event.target).val(undefined)
      } else {
        const formatted = formatGermanNumber(valNumber, true, true)
        $(event.target).val(formatted)
      }
    })

    $('.impowerx-currency-input').on('input', (event) => {
      const val = $(event.target).val()
      const formatted = formatGermanNumber(val, false)

      if (!isNaN(Number(val.replace(/./g, '')))) {
        $(event.target).val(formatted)
      }
    })

    $('.impowerx-number-input, .impowerx-percentage-input').on(
      'input',
      (event) => {
        const val = $(event.target).val()
        const formatted = formatGermanNumber(val, false)
        if (!isNaN(Number(val.replace(/\./g, '').replace(',', '.')))) {
          $(event.target).val(formatted)
        }
      }
    )

    $('.impowerx-number-input, .impowerx-percentage-input').on(
      'blur',
      (event) => {
        const val = $(event.target).val()
        if (!val || val.trim() === '') return
        const valNumber = val.replace(/\./g, '')
        if (isNaN(valNumber.replace(',', '.'))) {
          $(event.target).val('')
        } else {
          const formatted = formatGermanNumber(valNumber, true, true)
          $(event.target).val(formatted)
        }
      }
    )

    function stepNumberInput($input, direction) {
      const raw = $input.val() || '0'
      const normalized = raw.replace(/\./g, '').replace(',', '.')
      const current = parseFloat(normalized) || 0
      const newVal = direction === 'up' ? current + 1 : current - 1
      const formatted = formatGermanNumber(
        String(newVal.toFixed(2)).replace('.', ','),
        true,
        true
      )
      $input.val(formatted)
    }

    $('.ant-input-number-handler-up').on('click', function () {
      const $container = $(this).closest('.ant-input-number')
      if ($container.hasClass('ant-input-number-disabled')) return
      const $input = $container.find('.ant-input-number-input')
      stepNumberInput($input, 'up')
    })

    $('.ant-input-number-handler-down').on('click', function () {
      const $container = $(this).closest('.ant-input-number')
      if ($container.hasClass('ant-input-number-disabled')) return
      const $input = $container.find('.ant-input-number-input')
      stepNumberInput($input, 'down')
    })

    $('.ant-input-number-input').on('keydown', function (event) {
      const $container = $(this).closest('.ant-input-number')
      if ($container.hasClass('ant-input-number-disabled')) return
      if (event.key === 'ArrowUp') {
        event.preventDefault()
        stepNumberInput($(this), 'up')
      } else if (event.key === 'ArrowDown') {
        event.preventDefault()
        stepNumberInput($(this), 'down')
      }
    })

    // hide the dropdown when clicking outside of it
    $(document).on('click.impowerxProperty', function (event) {
      if ($(event.target).closest('.dropdown-wrapper').length) {
        const $wrapper = $(event.target).closest('.dropdown-wrapper')
        const $select = $wrapper.siblings('.ant-select')

        if ($select.hasClass('ContactComboBox')) {
          const $option = $(event.target).closest('.contact-combobox-item')
          if ($option.length) {
            const idValue = $option.data('value')
            const label =
              $option.find('.select-menu-item').text().trim() ||
              $option.text().trim()
            // store id separately; keep input empty to avoid showing id
            $select.data('selected-value', idValue)
            $select.attr('data-selected-value', String(idValue))
            $select.find('input').val('')
            $select
              .find('.ant-select-selection-search-input')
              .attr('placeholder', '')

            // display label only
            $select
              .find('.ant-select-selection-item')
              .text(label)
              .attr('title', label)
            $('.impowerx-select-dropdown').addClass(
              'ant-select-dropdown-hidden'
            )
          }
        } else if ($select.hasClass('ContactMultiSelect')) {
          const $remove = $(event.target).closest('.contact-multiselect-remove')
          const $item = $(event.target).closest('.contact-multiselect-item')
          if ($remove.length) {
            event.preventDefault()
            event.stopPropagation()
            const $option = $remove.closest('.contact-multiselect-item')
            const val = $option.data('value')
            const $case = $select.closest('.contact-multiselect-case')
            const ids = ($select.attr('data-selected-ids') || '')
              .split(',')
              .map((id) => id.trim())
              .filter(Boolean)
            const i = ids.indexOf(String(val))
            if (i !== -1) ids.splice(i, 1)
            $select.attr('data-selected-ids', ids.join(','))
            $option.removeClass(
              'ant-select-item-option-selected contact-multiselect-item-selected'
            )
            $option.css('background-color', '')
            $option.find('.contact-multiselect-remove').remove()
            const $list = $case.find('.contact-multiselect-list')
            const labels = []
            $list.find('.contact-multiselect-item-selected').each(function () {
              labels.push(
                $(this).data('label') ||
                  $(this).find('.select-menu-item').text().trim()
              )
            })
            const tagsHtml = labels
              .map(
                (l) =>
                  `<span class="contact-multiselect-tag" title="${String(l).replace(/"/g, '&quot;')}">${String(l).replace(/</g, '&lt;')}</span>`
              )
              .join('')
            $case
              .find('.contact-multiselect-display')
              .html(tagsHtml)
              .toggle(!!labels.length)
            $case
              .find('.ant-select-selection-placeholder')
              .toggle(!labels.length)
          } else if (
            $item.length &&
            !$(event.target).closest('.contact-multiselect-remove').length
          ) {
            event.preventDefault()
            event.stopPropagation()
            const val = $item.data('value')
            const label =
              $item.data('label') ||
              $item.find('.select-menu-item').text().trim()
            const $case = $select.closest('.contact-multiselect-case')
            let ids = ($select.attr('data-selected-ids') || '')
              .split(',')
              .map((id) => id.trim())
              .filter(Boolean)
            const selected = $item.hasClass('contact-multiselect-item-selected')
            if (selected) {
              ids = ids.filter((id) => id !== String(val))
              $item.removeClass(
                'ant-select-item-option-selected contact-multiselect-item-selected'
              )
              $item.find('.contact-multiselect-remove').remove()
              $item.css('background-color', '')
            } else {
              ids.push(String(val))
              $item.addClass(
                'ant-select-item-option-selected contact-multiselect-item-selected'
              )
              $item.css('background-color', '#e6f7ff')
              $item
                .find('.ant-select-item-option-content')
                .append(
                  '<span class="contact-multiselect-remove" role="button" aria-label="Remove" style="margin-left: 8px; cursor: pointer; color: #999; font-size: 16px; line-height: 1;">×</span>'
                )
            }
            $select.attr('data-selected-ids', ids.join(','))
            const $list = $case.find('.contact-multiselect-list')
            const labels = []
            $list.find('.contact-multiselect-item-selected').each(function () {
              labels.push(
                $(this).data('label') ||
                  $(this).find('.select-menu-item').text().trim()
              )
            })
            const tagsHtml = labels
              .map(
                (l) =>
                  `<span class="contact-multiselect-tag" title="${String(l).replace(/"/g, '&quot;')}">${String(l).replace(/</g, '&lt;')}</span>`
              )
              .join('')
            $case
              .find('.contact-multiselect-display')
              .html(tagsHtml)
              .toggle(!!labels.length)
            $case
              .find('.ant-select-selection-placeholder')
              .toggle(!labels.length)
            const $selected = $list.find('.contact-multiselect-item-selected')
            const $rest = $list
              .find('.contact-multiselect-item')
              .not('.contact-multiselect-item-selected')
            $list.append($selected.get().concat($rest.get()))
          }
        } else {
          // Check if click is on an option item (not just anywhere in dropdown)
          const $option = $(event.target).closest(
            '.impowerx-select-menu-item, .ant-select-item-option'
          )
          if ($option.length) {
            const label =
              $option.find('.select-menu-item').text().trim() ||
              event.target.textContent?.trim()
            $select.data('selected-value', label)
            $select.find('input').val('')
            $select
              .find('.ant-select-selection-item')
              .text(label)
              .attr('title', label)
            $select
              .find('.ant-select-selection-search-input')
              .attr('placeholder', '')
            // Close the dropdown after selection
            $('.impowerx-select-dropdown').addClass(
              'ant-select-dropdown-hidden'
            )
          }
        }
      }

      if (!$(event.target).closest('.ant-select, .dropdown-wrapper').length) {
        $('.impowerx-select-dropdown').addClass('ant-select-dropdown-hidden')
      }
    })
    $(
      '.file-input-button, .file-input, .impower-x, .impower-x-file-input, .file-input-label'
    ).removeAttr('disabled')
    $('.impower-x-file-input').removeAttr('disabled')
    $('.delete-button').removeAttr('disabled')

    //disable the input if the source building id is not the same as the building id
    const insuranceBuildingSections = document.querySelectorAll(
      '[id^="insurance-building-"]'
    )
    for (let i = 0; i < insuranceBuildingSections.length; i++) {
      const section = insuranceBuildingSections[i]
      const buildingId = section.getAttribute('data-building-id')
      const inheritedBuildingId = section
        .querySelector('[data-inherited-building-id]')
        ?.getAttribute('data-inherited-building-id')
      if (inheritedBuildingId !== buildingId) {
        section
          .querySelectorAll(
            '.file-input-button, .file-input, .impower-x, .impower-x-file-input, .file-input-label'
          )
          .forEach((el) => {
            el.setAttribute('disabled', true)
          })
        section.querySelectorAll('.delete-button').forEach((el) => {
          el.setAttribute('disabled', true)
          el.classList.add('disabled')
        })
      }
    }
    if (typeof refreshInternalApprovalPropertyVisibility === 'function') {
      refreshInternalApprovalPropertyVisibility()
    }
  }

  applyEditModeFromSync = () => {
    if (isSavingInProgress) return
    editFunction()
  }
  if (
    localStorage.getItem(editModeStorageKey) === 'true' &&
    detectDomEditMode()
  ) {
    applyEditModeFromSync()
  }

  const saveFunction = async () => {
    const livePropertyHrIdFromPath = (window.location.pathname.match(regex) ||
      [])[1]
    if (
      !livePropertyHrIdFromPath ||
      livePropertyHrIdFromPath !== propertyHrId
    ) {
      return
    }
    isSavingInProgress = true
    window.__luxImpowerxPropertyIsSaving = true
    try {
      setEditModeInStorage(false)
      const fieldsWithData = []

      $('.ant-radio-wrapper').addClass('ant-radio-wrapper-disabled')
      $('.ant-radio').addClass('ant-radio-disabled')
      $('.ant-radio-input').attr('disabled', true)

      $('.ant-checkbox-wrapper').addClass('ant-checkbox-wrapper-disabled')
      $('.ant-checkbox').addClass('ant-checkbox-disabled')
      $('.ant-checkbox-input').attr('disabled', true)

      $('.ant-select').off('click')

      // Get data from Radio Group Elements
      const switchElements = document.querySelectorAll('.SwitchElement')
      for (let i = 0; i < switchElements.length; i++) {
        const radios = switchElements[i].querySelectorAll('input[type="radio"]')
        let selectedValue = null
        radios.forEach((radio) => {
          if (radio.parentElement.classList.contains('ant-radio-checked')) {
            selectedValue = radio.value
          }
        })

        const fieldId = switchElements[i].getAttribute('data-field-id')

        fieldsWithData.push({
          fieldId,
          value: selectedValue,
          fieldType: 'RadioGroup',
          fieldName: switchElements[i].getAttribute('name'),
          propertyHrId,
        })
      }

      // Get data from Checkbox Group Elements
      const checkboxGroups = document.querySelectorAll('.ant-checkbox-group')
      for (let i = 0; i < checkboxGroups.length; i++) {
        const checkboxes = checkboxGroups[i].querySelectorAll(
          'input[type="checkbox"]'
        )
        const selectedValues = []

        checkboxes.forEach((checkbox) => {
          if (
            checkbox.parentElement.classList.contains('ant-checkbox-checked')
          ) {
            selectedValues.push(checkbox.value)
          }
        })

        const fieldId = checkboxGroups[i].getAttribute('data-field-id')
        fieldsWithData.push({
          fieldId,
          value:
            checkboxGroups[i].getAttribute('data-lux-external-skip-inherit') ===
            'true'
              ? 'inherit'
              : selectedValues.join('|'),
          fieldType: 'CheckboxGroup',
          fieldName: checkboxGroups[i].getAttribute('name'),
          propertyHrId,
        })
      }

      // Get data from Dropdown Elements
      const selectElements = $('.impowerx-select')
      for (let i = 0; i < selectElements.length; i++) {
        const elment = $(selectElements[i])
        if (elment.hasClass('ContactMultiSelect')) continue
        const name = elment.attr('name') || ''
        if (elment.hasClass('ContactComboBox')) {
          const fieldId = elment.attr('data-field-id')
          let value = elment.data('selected-value')
          const attrValue = elment.attr('data-selected-value')
          // Explicit clear sentinel for internal-approval preferred contacts (API expects '0').
          if (attrValue === '0' || String(value) === '0') {
            value = '0'
          } else if (value == null || value === '') {
            const selectedOption = elment
              .closest('.contact-combobox')
              .find('.contact-combobox-item.ant-select-item-option-selected')
            if (selectedOption.length) {
              value = selectedOption.attr('data-value')
            }
          }
          fieldsWithData.push({
            fieldId,
            value: value ?? '',
            fieldType: 'ContactComboBox',
            fieldName: name,
            propertyHrId,
          })
          continue
        }
        const fieldId = elment.attr('data-field-id')
        const input = elment.find('input')
        const dataSelected = elment.data('selected-value')
        const value = dataSelected ?? input.val()

        fieldsWithData.push({
          fieldId,
          value,
          fieldType: 'DropdownMenu',
          fieldName: name,
          propertyHrId,
        })
      }

      // Get data from ContactMultiSelect Elements
      const contactMultiSelects = document.querySelectorAll(
        '.impowerx-contact-multiselect'
      )
      const heatingElectricianPayload = getHeatingElectricianPayloadFromConfig()
      let heatingElectricianFieldId = null
      let hasHeatingElectricianField = false
      const heatingAdditionalMaintenancePayload =
        getHeatingAdditionalMaintenancePayloadFromConfig()
      let heatingAdditionalMaintenanceFieldId = null
      let hasHeatingAdditionalMaintenanceField = false
      for (let i = 0; i < contactMultiSelects.length; i++) {
        const el = contactMultiSelects[i]
        const name = el.getAttribute('name') || ''
        const value = el.getAttribute('data-selected-ids') || ''
        if (name.startsWith('heatingElectrician_')) {
          hasHeatingElectricianField = true
          if (!heatingElectricianFieldId)
            heatingElectricianFieldId = el.getAttribute('data-field-id')
          const buildingId = name.replace('heatingElectrician_', '')
          if (value) heatingElectricianPayload[buildingId] = value
          else delete heatingElectricianPayload[buildingId]
        } else if (name.startsWith('heatingAdditionalMaintenance_')) {
          hasHeatingAdditionalMaintenanceField = true
          if (!heatingAdditionalMaintenanceFieldId)
            heatingAdditionalMaintenanceFieldId =
              el.getAttribute('data-field-id')
          const buildingId = name.replace('heatingAdditionalMaintenance_', '')
          if (value) heatingAdditionalMaintenancePayload[buildingId] = value
          else delete heatingAdditionalMaintenancePayload[buildingId]
        } else {
          fieldsWithData.push({
            fieldId: el.getAttribute('data-field-id'),
            value,
            fieldType: 'ContactMultiSelect',
            fieldName: name,
            propertyHrId,
          })
        }
      }
      const needsHeatingLinkPropagation =
        hasHeatingElectricianField || hasHeatingAdditionalMaintenanceField

      if (needsHeatingLinkPropagation) {
        try {
          const token = JSON.parse(localStorage.getItem('auth'))?.token

          if (token && propertyHrId) {
            const pmpResponse = await fetch(
              `/services/pmp-accounting/api/v1/properties/${propertyHrId}`,
              {
                headers: { Authorization: 'Bearer ' + token },
              }
            )

            if (pmpResponse.ok) {
              const propertyData = await pmpResponse.json()
              const pmpBuildings = propertyData?.buildings || []

              const byHrId = new Map(
                pmpBuildings.map((b) => [b.buildingHrId, b])
              )

              const resolveLinkedRoot = (
                building,
                linkHrIdKey,
                labelForLog
              ) => {
                let current = building
                const visited = new Set()

                while (current?.[linkHrIdKey]) {
                  if (visited.has(current.buildingHrId)) {
                    console.warn(
                      `Circular ${labelForLog} link detected:`,
                      current.buildingHrId
                    )
                    break
                  }

                  visited.add(current.buildingHrId)

                  const next = byHrId.get(current[linkHrIdKey])
                  if (!next) break

                  current = next
                }

                return current
              }

              for (const b of pmpBuildings) {
                if (!b.heatingLinkedBuildingHrId) continue

                const root = resolveLinkedRoot(
                  b,
                  'heatingLinkedBuildingHrId',
                  'heating'
                )
                if (!root) continue

                const sourceId = String(root.id)
                const targetId = String(b.id)

                if (sourceId === targetId) continue

                if (hasHeatingElectricianField) {
                  if (sourceId in heatingElectricianPayload) {
                    heatingElectricianPayload[targetId] =
                      heatingElectricianPayload[sourceId]
                  } else {
                    delete heatingElectricianPayload[targetId]
                  }
                }

                if (hasHeatingAdditionalMaintenanceField) {
                  if (sourceId in heatingAdditionalMaintenancePayload) {
                    heatingAdditionalMaintenancePayload[targetId] =
                      heatingAdditionalMaintenancePayload[sourceId]
                  } else {
                    delete heatingAdditionalMaintenancePayload[targetId]
                  }
                }
              }
            }
          }
        } catch (e) {
          console.error(
            'Error propagating linked-building fields (heating):',
            e
          )
        }
      }
      if (hasHeatingElectricianField) {
        fieldsWithData.push({
          fieldId: heatingElectricianFieldId || 'heating-electrician',
          value: JSON.stringify(heatingElectricianPayload),
          fieldType: 'ContactMultiSelect',
          fieldName: 'property_heating_electrician',
          propertyHrId,
        })
      }
      if (hasHeatingAdditionalMaintenanceField) {
        fieldsWithData.push({
          fieldId:
            heatingAdditionalMaintenanceFieldId ||
            'heating-additional-maintenance-companies',
          value: JSON.stringify(heatingAdditionalMaintenancePayload),
          fieldType: 'ContactMultiSelect',
          fieldName: 'property_heating_additional_maintenance_companies',
          propertyHrId,
        })
      }

      const buildingBaujahrPayload = getBuildingBaujahrPayloadFromConfig()
      let hasBuildingBaujahrField = false
      let buildingBaujahrFieldId = null
      const buildingBaujahrInputs = document.querySelectorAll(
        'input.impowerx-building-baujahr-year[name^="buildingBaujahr_"]'
      )
      for (let i = 0; i < buildingBaujahrInputs.length; i++) {
        const input = buildingBaujahrInputs[i]
        hasBuildingBaujahrField = true
        if (!buildingBaujahrFieldId)
          buildingBaujahrFieldId = input.getAttribute('data-field-id')
        const name = input.getAttribute('name') || ''
        const buildingId = name.replace(/^buildingBaujahr_/, '')
        const value = String(input.value || '')
          .replace(/\D/g, '')
          .slice(0, 4)
        if (value.length > 0) {
          buildingBaujahrPayload[buildingId] = value
        } else {
          delete buildingBaujahrPayload[buildingId]
        }
      }
      if (hasBuildingBaujahrField) {
        fieldsWithData.push({
          fieldId: buildingBaujahrFieldId,
          value: JSON.stringify(buildingBaujahrPayload),
          fieldType: 'TextInput',
          fieldName: 'property_building_baujahr',
          propertyHrId,
        })
      }

      // Plain TextInput ImpowerX fields (e.g. property_kostenstelle) — not currency/number/baujahr
      const impowerxTextInputs = document.querySelectorAll(
        'input.impowerx-text-input[data-field-id]'
      )
      for (let i = 0; i < impowerxTextInputs.length; i++) {
        const el = impowerxTextInputs[i]
        if (el.classList.contains('impowerx-building-baujahr-year')) continue
        const fieldName = el.getAttribute('name') || ''
        if (fieldName === 'property_building_baujahr') continue
        fieldsWithData.push({
          fieldId: el.getAttribute('data-field-id'),
          value: el.value ?? '',
          fieldType: 'TextInput',
          fieldName,
          propertyHrId,
        })
        el.classList.add('ant-input-disabled')
        el.setAttribute('disabled', 'true')
      }

      const suffixedElements = document.querySelectorAll(
        '.ant-input-affix-wrapper'
      )
      for (let i = 0; i < suffixedElements.length; i++) {
        suffixedElements[i].classList.add(
          'ant-input-affix-wrapper-readonly',
          'disabled',
          'ant-input-affix-wrapper-disabled'
        )
      }

      const inputElements = document.querySelectorAll(
        '.impowerx-currency-input'
      )
      for (let i = 0; i < inputElements.length; i++) {
        const value =
          inputElements[i].getAttribute('data-lux-external-limit-inherit') ===
          'true'
            ? 'inherit'
            : typeof luxApprovalAmountValueForSave === 'function'
              ? luxApprovalAmountValueForSave(inputElements[i])
              : inputElements[i].value

        fieldsWithData.push({
          fieldId: inputElements[i].getAttribute('data-field-id'),
          value,
          fieldType: 'CurrencyInput',
          fieldName: inputElements[i].getAttribute('name'),
          propertyHrId,
        })

        inputElements[i].classList.add(
          'ant-input-disabled',
          'ant-input-number-disabled'
        )
        inputElements[i].setAttribute('readonly', true)
        inputElements[i].setAttribute('disabled', true)
      }

      const externalEnabledInput = document.querySelector(
        '.lux-external-approval-enabled'
      )
      if (externalEnabledInput) {
        fieldsWithData.push({
          fieldName: 'property_enable_external_approval',
          value:
            externalEnabledInput.getAttribute(
              'data-lux-external-enabled-inherit'
            ) === 'true'
              ? 'inherit'
              : String(externalEnabledInput.checked),
          fieldType: 'CheckboxGroup',
          propertyHrId,
        })
      }

      // Get data from NumberInput Elements
      const numberInputElements = document.querySelectorAll(
        '.impowerx-number-input'
      )
      for (let i = 0; i < numberInputElements.length; i++) {
        const rawValue = numberInputElements[i].value
        const normalized = rawValue.replace(/,/g, '.')
        const value =
          normalized !== '' && !isNaN(Number(normalized)) ? normalized : ''

        fieldsWithData.push({
          fieldId: numberInputElements[i].getAttribute('data-field-id'),
          value,
          fieldType: 'NumberInput',
          fieldName: numberInputElements[i].getAttribute('name'),
          propertyHrId,
        })

        numberInputElements[i].classList.add(
          'ant-input-disabled',
          'ant-input-number-disabled'
        )
        numberInputElements[i].setAttribute('readonly', true)
        numberInputElements[i].setAttribute('disabled', true)
      }

      // Get data from PercentageInput Elements
      const percentageInputElements = document.querySelectorAll(
        '.impowerx-percentage-input'
      )
      for (let i = 0; i < percentageInputElements.length; i++) {
        const rawValue = percentageInputElements[i].value
        const normalized = rawValue.replace(/\./g, '').replace(',', '.')
        const value =
          normalized !== '' && !isNaN(Number(normalized))
            ? String(Number(normalized) / 100)
            : ''

        fieldsWithData.push({
          fieldId: percentageInputElements[i].getAttribute('data-field-id'),
          value,
          fieldType: 'PercentageInput',
          fieldName: percentageInputElements[i].getAttribute('name'),
          propertyHrId,
        })

        percentageInputElements[i].classList.add(
          'ant-input-disabled',
          'ant-input-number-disabled'
        )
        percentageInputElements[i].setAttribute('readonly', true)
        percentageInputElements[i].setAttribute('disabled', true)
      }

      // Disable NumberInput and PercentageInput containers after saving
      $('.ant-input-number-input')
        .closest('.ant-input-number')
        .addClass('ant-input-number-disabled')
        .css('border-color', 'transparent')
      $('.ant-input-number-input').css({
        color: 'rgba(0, 0, 0, 0.25)',
        'padding-right': '11px',
      })
      $('.ant-input-number .suffix')
        .css('color', 'rgba(0, 0, 0, 0.25)')
        .removeClass('suffix-with-controls')
      $('.ant-input-number-handler-wrap').attr(
        'style',
        'display: none !important; width: 0; overflow: hidden;'
      )

      // Get data from lux-picker DatePicker roots (data-field-id on .lux-picker.DatePicker).
      // Per-building Baujahr uses year TextInput, not DatePicker.
      const datePickerElements = document.querySelectorAll(
        '.lux-picker.DatePicker[data-field-id]'
      )
      for (let i = 0; i < datePickerElements.length; i++) {
        const datePickerRoot = datePickerElements[i]
        const dpName = datePickerRoot.getAttribute('name') || ''
        if (dpName.startsWith('buildingBaujahr_')) continue
        const input = datePickerRoot.querySelector('input')
        if (input) {
          // Prefer display value (dd.MM.yyyy) for ImpowerX parity with prior saves
          let value = (input.value || '').replace(/_/g, '')
          if (
            (!value || value.replace(/[._]/g, '').length === 0) &&
            typeof input.getValue === 'function'
          ) {
            const iso = input.getValue()
            if (iso) {
              const [y, m, d] = iso.split('-')
              value = `${d}.${m}.${y}`
            }
          }

          if (value && value.replace(/[._]/g, '').length > 0) {
            const fieldId = datePickerRoot.getAttribute('data-field-id')
            const fieldName = datePickerRoot.getAttribute('name')

            fieldsWithData.push({
              fieldId,
              value,
              fieldType: 'DatePicker',
              fieldName,
              propertyHrId,
            })
          }
        }
      }

      // Disable lux-picker DatePicker fields after saving
      document
        .querySelectorAll('.lux-picker.DatePicker[data-field-id]')
        .forEach((el) => {
          const input = el.querySelector('input')
          if (input && typeof input.setDisabled === 'function') {
            input.setDisabled(true)
          } else if (input) {
            el.classList.add('read-only', 'lux-picker-disabled')
            input.setAttribute('disabled', true)
            input.setAttribute('placeholder', 'TT.MM.JJJJ')
          }
        })

      $('.impowerx-building-baujahr-year')
        .addClass('ant-input-disabled')
        .attr('disabled', true)

      $('.ant-select-dropdown').addClass('ant-select-dropdown-hidden')
      $('.ant-select').addClass('read-only ant-select-disabled')

      const propertyFieldIdByName = {}
      for (const f of fieldsForSections) {
        if (f.name && f.id != null) propertyFieldIdByName[f.name] = f.id
      }
      const resolveSaveFieldId = (fieldName, fieldId) => {
        if (
          fieldId != null &&
          fieldId !== '' &&
          fieldId !== 'undefined' &&
          !Number.isNaN(Number(fieldId))
        ) {
          return fieldId
        }
        const fromCatalog = propertyFieldIdByName[fieldName]
        return fromCatalog != null ? fromCatalog : fieldId
      }
      for (let i = 0; i < fieldsWithData.length; i++) {
        const entry = fieldsWithData[i]
        entry.fieldId = resolveSaveFieldId(entry.fieldName, entry.fieldId)
      }

      await saveImpowerXData(
        `${baseApiUrl}/api/impowerX/properties`,
        fieldsWithData
      )
      fieldsWithData.forEach((entry) => {
        if (!entry.fieldName || !entry.fieldName.startsWith('proprety_')) return
        const stored = (propertiesData?.fields || []).find(
          (x) => x.name === entry.fieldName
        )
        if (stored) stored.value = entry.value
      })
      if (typeof refreshInternalApprovalPropertyVisibility === 'function') {
        setTimeout(function () {
          refreshInternalApprovalPropertyVisibility()
        }, 150)
      }
      if (hasHeatingElectricianField) {
        const heatingFieldConfig = getHeatingElectricianFieldConfig()
        if (heatingFieldConfig) {
          heatingFieldConfig.value = JSON.stringify(heatingElectricianPayload)
        }
      }
      if (hasHeatingAdditionalMaintenanceField) {
        const additionalMaintenanceFieldConfig =
          getHeatingAdditionalMaintenanceFieldConfig()
        if (additionalMaintenanceFieldConfig) {
          additionalMaintenanceFieldConfig.value = JSON.stringify(
            heatingAdditionalMaintenancePayload
          )
        }
      }
      if (hasBuildingBaujahrField) {
        const baujahrFieldDef = getBuildingBaujahrFieldDef()
        if (baujahrFieldDef) {
          baujahrFieldDef.value = JSON.stringify(buildingBaujahrPayload)
        }
      }
      $('.file-input-button').attr('disabled', true)
      $('.file-input').attr('disabled', true)
      $('.impower-x').attr('disabled', true)
      $('.impower-x-file-input').attr('disabled', true)
      $('.impower-x-file-input').off('change')
      $('.delete-button').attr('disabled', true)
      // $('.impowerx-select').attr('disabled', 'true')
      setTimeout(() => {
        $('.ContactComboDisable').addClass('read-only ant-select-disabled')
        $('.ContactComboDisable').attr('disabled', true)
        $('.ContactComboDisable .ant-select-selection-search-input').attr(
          'disabled',
          true
        )
        $('.ContactComboDisable .ant-select-selection-search-input').attr(
          'placeholder',
          ''
        )
        //also for multi select
        $('.contact-multiselect-case .ContactMultiSelect').addClass(
          'read-only ant-select-disabled'
        )
        $('.contact-multiselect-case .ContactMultiSelect').attr(
          'disabled',
          true
        )
        $('.contact-multiselect-case .contact-multiselect-search-input').attr(
          'disabled',
          true
        )
        $('.contact-multiselect-case .contact-multiselect-search-input').attr(
          'placeholder',
          ''
        )
        // also disable all document delete buttons
        $('.FileUpload .delete-button').addClass('disabled')
        $('.FileUpload .delete-button').attr('disabled', true)
        // file upload input
        $('.FileUpload .Button').addClass('disabled')
        $('.FileUpload .Button').attr('disabled', true)
      }, 3000)

      // Refresh buildings data after save
      buildingsResult = await refreshBuildingsData()
      buildings = buildingsResult.buildings
      buildingFieldsMap = buildingsResult.buildingFieldsMap
      const notificationFlushError = await onPropertySaveSuccess?.()
      if (notificationFlushError) {
        alert(
          `Das Objekt wurde gespeichert, aber die Benachrichtigungseinstellungen konnten nicht übernommen werden.\n\n${notificationFlushError}`
        )
      }
    } catch (error) {
      console.error('[ImpowerX] Property save failed:', error)
      alert(
        'Fehler beim Speichern der Objektdaten. Bitte versuchen Sie es erneut.'
      )
    } finally {
      isSavingInProgress = false
      window.__luxImpowerxPropertyIsSaving = false
    }
  }

  const headerLastActionButton = document.querySelector(
    '.PageHeader .right-side button:last-child'
  )
  if (headerLastActionButton) {
    headerLastActionButton.addEventListener('click', editFunction)
    observers.push({
      disconnect: () =>
        headerLastActionButton.removeEventListener('click', editFunction),
    })
  }

  const registerHeaderSaveListener = (label, fn) => {
    const disconnect = listenToButtonClick(label, fn)
    observers.push({ disconnect })
  }
  registerHeaderSaveListener('Bearbeiten', editFunction)
  registerHeaderSaveListener('Edit', editFunction)
  registerHeaderSaveListener('Speichern und Weiter', saveFunction)
  registerHeaderSaveListener('Save and Continue', saveFunction)
  registerHeaderSaveListener('Speichern', saveFunction)
  registerHeaderSaveListener('Save', saveFunction)
  registerHeaderSaveListener('Als Entwurf Speichern', saveFunction)
  registerHeaderSaveListener('Save all', saveFunction)
  registerHeaderSaveListener('Bereit zur Verbuchung', saveFunction)
  registerHeaderSaveListener('Ready for invoice', saveFunction)

  let buildingsResult = await initialBuildingsRequest
  let buildings = buildingsResult.buildings
  let buildingFieldsMap = buildingsResult.buildingFieldsMap

  const injectHeatingAdditionalMaintenanceFields = () => {
    if (!heatingElectricianConfig?.fields?.length) return
    const fieldConfig = getHeatingAdditionalMaintenanceFieldConfig()
    if (!fieldConfig) return
    const payloadByBuilding = getHeatingAdditionalMaintenancePayloadFromConfig()
    const formSections = document.querySelectorAll(
      '.FormSection[id^="BuildingEquipment"]'
    )
    formSections.forEach((formSection, index) => {
      let buildingId = formSection.getAttribute('data-building-id')
      if (!buildingId && buildings && buildings[index]) {
        buildingId = String(buildings[index].id ?? '')
        if (buildingId) formSection.setAttribute('data-building-id', buildingId)
      }
      if (!buildingId) buildingId = `_index_${index}`
      const heatingSub = formSection.querySelector(
        '.sub-section[id^="Heating"]'
      )
      if (!heatingSub) return
      const name = `heatingAdditionalMaintenance_${buildingId}`
      if (heatingSub.querySelector(`[name="${name}"]`)) return
      const value =
        payloadByBuilding[buildingId] ||
        payloadByBuilding[`_index_${index}`] ||
        ''
      const content = heatingSub.querySelector('.sub-section-content')
      if (!content) return

      // Find the row that contains "Wartungsfirma" so Weitere Wartungsfirmen appears on the same row
      const rows = content.querySelectorAll('.sub-section-content-row')
      let targetRow = null
      for (const row of rows) {
        const label = row.querySelector(
          '.ant-form-item-label label span, label span'
        )
        if (label && label.textContent.trim() === 'Wartungsfirma') {
          targetRow = row
          break
        }
      }
      if (!targetRow)
        targetRow = content.querySelector('.sub-section-content-row')

      if (!targetRow) return

      // Replace the empty placeholder column in this row (avoids 3-column layout with a gap)
      const columns = targetRow.querySelectorAll('.sub-section-content-column')
      let emptyColumn = null
      for (const col of columns) {
        const hasContent = col.querySelector(
          '.ant-form-item, .ant-select, .ContactMultiSelect, .SmartSearch, .ehv-element, input, [data-building-id]'
        )
        if (!hasContent) {
          emptyColumn = col
          break
        }
      }

      const generateField = generateInputField({
        ...fieldConfig,
        name,
        value,
        options: fieldConfig.options || contactOptions,
        isDisabled: shouldDisableInjectedFields(),
      })
      generateField.setAttribute('data-building-id', buildingId)
      generateField.classList.add('impowerx-row-heating-additional-maintenance')

      if (emptyColumn) {
        emptyColumn.replaceWith(generateField)
      } else {
        targetRow.appendChild(generateField)
      }
    })
  }

  const injectBuildingBaujahrFields = () => {
    const fieldDef = getBuildingBaujahrFieldDef()
    if (!fieldDef) return
    const payloadByBuilding = getBuildingBaujahrPayloadFromConfig()
    const formSections = document.querySelectorAll(
      '.FormSection[id^="BuildingEquipment"]'
    )
    formSections.forEach((formSection, index) => {
      let buildingId = formSection.getAttribute('data-building-id')
      if (!buildingId && buildings && buildings[index]) {
        buildingId = String(buildings[index].id ?? '')
        if (buildingId) formSection.setAttribute('data-building-id', buildingId)
      }
      if (!buildingId) buildingId = `_index_${index}`
      const identificationSub =
        formSection.querySelector(
          '.sub-section[id^="buildingIdentification"]'
        ) ||
        formSection.querySelector('.sub-section[id^="BuildingIdentification"]')
      if (!identificationSub) return
      const name = `buildingBaujahr_${buildingId}`
      if (identificationSub.querySelector(`[name="${name}"]`)) return
      const value =
        payloadByBuilding[buildingId] ||
        payloadByBuilding[`_index_${index}`] ||
        ''
      const content = identificationSub.querySelector('.sub-section-content')
      if (!content) return

      const generateField = generateInputField({
        id: fieldDef.id,
        name,
        label: fieldDef.label || 'Baujahr',
        fieldType: 'TextInput',
        value: value || undefined,
        defaultValue: fieldDef.defaultValue,
        placeholder: fieldDef.placeholder || 'JJJJ',
        options: fieldDef.options || [],
        isDisabled: shouldDisableInjectedFields(),
      })
      generateField.setAttribute('data-building-id', buildingId)
      generateField.classList.add('impowerx-row-building-baujahr')
      const baujahrInput = generateField.querySelector('input')
      if (baujahrInput) {
        baujahrInput.classList.add('impowerx-building-baujahr-year')
        baujahrInput.setAttribute('inputmode', 'numeric')
        baujahrInput.setAttribute('maxlength', '4')
        baujahrInput.setAttribute('autocomplete', 'off')
      }

      const row = document.createElement('div')
      row.className = 'sub-section-content-row impowerx-row-building-baujahr'
      const spaceFillerColumn = document.createElement('div')
      spaceFillerColumn.className = 'sub-section-content-column'
      row.appendChild(generateField)
      row.appendChild(spaceFillerColumn)
      content.appendChild(row)
    })
  }

  const injectHeatingElectricianFields = () => {
    if (!heatingElectricianConfig?.fields?.length) return
    const heatingFieldConfig = getHeatingElectricianFieldConfig()
    if (!heatingFieldConfig) return
    const heatingByBuilding = getHeatingElectricianPayloadFromConfig()
    const formSections = document.querySelectorAll(
      '.FormSection[id^="BuildingEquipment"]'
    )
    formSections.forEach((formSection, index) => {
      let buildingId = formSection.getAttribute('data-building-id')
      if (!buildingId && buildings && buildings[index]) {
        buildingId = String(buildings[index].id ?? '')
        if (buildingId) formSection.setAttribute('data-building-id', buildingId)
      }
      if (!buildingId) buildingId = `_index_${index}`
      const heatingSub = formSection.querySelector(
        '.sub-section[id^="Heating"]'
      )
      if (!heatingSub) return
      const name = `heatingElectrician_${buildingId}`
      if (heatingSub.querySelector(`[name="${name}"]`)) return
      const value =
        heatingByBuilding[buildingId] ||
        heatingByBuilding[`_index_${index}`] ||
        ''
      const content = heatingSub.querySelector('.sub-section-content')
      if (!content) return

      // Anchor by label so placement is stable. "Wartungsvertrag Heizung (optional)" is only in the DOM
      // under certain conditions; when missing, we fall back to "Wartungsintervall" then last row.
      const rows = content.querySelectorAll('.sub-section-content-row')
      let anchorRow = null
      let insertBeforeAnchor = true
      for (const r of rows) {
        const labelEl = r.querySelector(
          '.ant-form-item-label label, .description-label, label.ant-form-item-label'
        )
        const labelText = labelEl?.textContent?.trim() ?? ''
        if (labelText.indexOf('Wartungsvertrag Heizung') !== -1) {
          anchorRow = r
          insertBeforeAnchor = true
          break
        }
        if (labelText === 'Wartungsintervall') {
          anchorRow = r
          insertBeforeAnchor = false
        }
      }
      // When "Wartungsvertrag Heizung" is missing (conditional UI), use last row and insert before it
      if (!anchorRow) {
        anchorRow = content.querySelector('.sub-section-content-row:last-child')
        insertBeforeAnchor = true
      }
      if (!anchorRow) return

      const generateField = generateInputField({
        ...heatingFieldConfig,
        name,
        value,
        options: heatingFieldConfig.options || contactOptions,
        isDisabled: shouldDisableInjectedFields(),
      })
      generateField.setAttribute('data-building-id', buildingId)

      const row = document.createElement('div')
      row.className = 'sub-section-content-row impowerx-row-heating-electrician'
      const spaceFillerColumn = document.createElement('div')
      spaceFillerColumn.className = 'sub-section-content-column'
      row.appendChild(generateField)
      row.appendChild(spaceFillerColumn)

      if (insertBeforeAnchor) {
        anchorRow.before(row)
      } else {
        anchorRow.after(row)
      }
    })
  }
  const injectHeatingFields = () => {
    // Migrated heating extras live on the technical asset; native equipment stays hidden (EHV-1200).
    if (!isNativeEquipmentHidden()) {
      injectHeatingAdditionalMaintenanceFields()
      injectHeatingElectricianFields()
    }
    injectBuildingBaujahrFields()
  }

  const runBuildingEquipmentInjects = () => {
    injectHeatingFields()
  }
  runBuildingEquipmentInjects()

  const processedFileUploads = new WeakSet()
  const processedFileUploadLineItems = new WeakSet()
  const processedFileInputs = new WeakSet()
  const processedFileUploadSections = new WeakSet()
  const processingFileInputs = new WeakSet()

  const hasBuildingReference = (element) => {
    return element
      ?.getAttribute('id')
      ?.replace(/\d/g, '')
      ?.toLowerCase()
      .includes('building')
  }

  /** Injected id uses insurance root building id; list/upload must use the same id as in fileInputId. */
  const INSURANCE_BUILDING_VV_FILE_INPUT_RE =
    /^impowerx-insurancebuildingversicherungsvertrag-(\d+)-file-input$/i
  const effectiveBuildingIdForFileInput = (fileInputId, derivedBuildingId) => {
    if (!fileInputId || typeof fileInputId !== 'string')
      return derivedBuildingId
    const m = fileInputId.match(INSURANCE_BUILDING_VV_FILE_INPUT_RE)
    return m ? m[1] : derivedBuildingId
  }

  const deriveBuildingId = async (element) => {
    const closestSubSection = element?.closest('.sub-section')
    const closestFormSection = element?.closest('.FormSection')
    let buildingId = ''
    let closestBuildingSection
    if (closestSubSection && hasBuildingReference(closestSubSection)) {
      closestBuildingSection = closestSubSection
    } else if (closestFormSection && hasBuildingReference(closestFormSection)) {
      closestBuildingSection = closestFormSection
    }

    if (!closestBuildingSection) return ''

    buildingId = closestBuildingSection.getAttribute('data-building-id')
    if (buildingId) return buildingId
    const buildingNumber = parseInt(
      closestBuildingSection.getAttribute('id')?.replace(/\D/g, '')
    )
    if (Number.isNaN(buildingNumber)) return ''
    if (buildingNumber < buildings?.length) {
      buildingId = buildings[buildingNumber].id ?? ''
      if (buildingId) {
        closestBuildingSection.setAttribute('data-building-id', buildingId)
      }
    } else {
      buildingsResult = await refreshBuildingsData()
      buildings = buildingsResult.buildings
      buildingFieldsMap = buildingsResult.buildingFieldsMap
      buildingId = buildings[buildingNumber]?.id ?? ''
      if (buildingId) {
        closestBuildingSection.setAttribute('data-building-id', buildingId)
      }
    }

    return buildingId ?? ''
  }

  // replace existing file input and document with new file input and document elements
  const processFileUploads = async (rootElement = document.body) => {
    const existingDocumentRows = rootElement?.querySelectorAll('.FileUpload')
    if (!existingDocumentRows?.length) return
    if (!propertyId) return
    addLoadingOverlay(rootElement)
    let removalScheduled = false
    try {
      const listPromises = []
      const isInEditMode = localStorage.getItem('isInEditMode') === 'true'
      for (const documentRow of existingDocumentRows) {
        if (processedFileUploads.has(documentRow)) continue
        processedFileUploads.add(documentRow)
        let fileInputId = ''
        const fileInput = documentRow.querySelector('input[type="file"]')
        const fileInputButton = documentRow.querySelector(
          'button.file-input-label'
        )

        if (fileInput) {
          fileInputId = fileInput?.id || ''
          const fileInputParent = fileInput.parentElement
          const fileInputLabel =
            fileInputParent
              ?.querySelector('.description-label')
              ?.textContent?.trim() || ''
          const newfileElement = generateFileInput(
            fileInputId,
            !isInEditMode,
            true
          )
          fileInput.parentElement.removeChild(fileInput)
          if (fileInputButton) {
            fileInputButton.parentElement.removeChild(fileInputButton)
          }
          fileInputParent.appendChild(newfileElement)
          const secondRow = documentRow.querySelector('.second-row')
          if (secondRow) {
            documentRow.removeChild(secondRow)
          }
          const buildingId = await deriveBuildingId(documentRow)
          const effectiveBuildingId = effectiveBuildingIdForFileInput(
            fileInputId,
            buildingId
          )
          listPromises.push(
            getAndListPropertyDocuments({
              propertyId,
              buildingId: effectiveBuildingId,
              fileInputId,
              fileInputLabel,
              documentRow,
            })
          )
        }
      }
      if (listPromises.length > 0) {
        removalScheduled = true
        Promise.allSettled(listPromises).finally(() =>
          removeLoadingOverlay(rootElement)
        )
      }
    } catch (e) {
      console.error('[ImpowerX] Failed to process file uploads', e)
    } finally {
      if (!removalScheduled) {
        removeLoadingOverlay(rootElement)
      }
    }
  }

  let insuranceUploadDebounceTimer = null
  const scheduleInsuranceVersicherungsvertragUploads = () => {
    clearTimeout(insuranceUploadDebounceTimer)
    insuranceUploadDebounceTimer = setTimeout(() => {
      if (
        !document.querySelector(
          '#insuranceIdentity, #insurance-weg, [id^="insurance-building-"]'
        )
      )
        return
      if (isNativeInsuranceReplaced()) return
      if (
        typeof window.runInsuranceVersicherungsvertragInjection === 'function'
      ) {
        window.runInsuranceVersicherungsvertragInjection({
          processFileUploads,
          buildings,
          shouldDisableInjectedFields,
        })
      }
    }, 200)
  }

  const isStandaloneLuxFileInput = (fileInput) =>
    fileInput?.closest?.('.lux-file-picker, .lux-meter-reading-modal')

  const processFileInput = (fileInput) => {
    if (
      !fileInput ||
      fileInput?.classList?.contains('impower-x-file-input') ||
      fileInput?.classList?.contains('Button')
    )
      return
    if (isStandaloneLuxFileInput(fileInput)) return
    if (processedFileInputs.has(fileInput)) return
    const fileInputId = fileInput?.id || 'file-input'
    const isInEditMode = localStorage.getItem('isInEditMode') === 'true'
    const newfileElement = generateFileInput(fileInputId, !isInEditMode)
    const fileInputParent = fileInput.parentElement
    fileInputParent.removeChild(fileInput)
    const fileInputLabel = fileInputParent.querySelector('.file-input-label')
    if (fileInputLabel) {
      fileInputParent.removeChild(fileInputLabel)
    }
    fileInputParent.appendChild(newfileElement)
    processedFileInputs.add(fileInput)
  }

  const processFileUploadLineItems = async (rootElement = document.body) => {
    const documentRows = rootElement?.querySelectorAll('.FileUploadLine')
    if (!documentRows?.length) return
    if (!propertyId) return
    addLoadingOverlay(rootElement)
    let removalScheduled = false
    try {
      const listPromises = []
      const isInEditMode = localStorage.getItem('isInEditMode') === 'true'
      for (const documentRow of documentRows) {
        if (processedFileUploadLineItems.has(documentRow)) continue
        processedFileUploadLineItems.add(documentRow)
        let fileInputId = ''
        const documentLine = documentRow.querySelector('.line')
        const fileInputLabel =
          documentLine.querySelector('div.file-name')?.textContent ||
          documentLine?.querySelector('div.file-name > a')?.textContent
        const fileInput = documentLine.querySelector('input[type="file"]')
        if (fileInput) {
          fileInputId = fileInput.id
          processFileInput(fileInput)
        } else {
          fileInputId = `${fileInputLabel}-file-input`
          const deleteBtn = documentLine.querySelector('.delete-button')
          if (deleteBtn) {
            deleteBtn.parentElement.removeChild(deleteBtn)
            const fileNameField = documentLine.querySelector('div.file-name')
            if (fileNameField) {
              fileNameField.innerHTML = fileInputLabel
            }
            const newFileInput = generateFileInput(fileInputId, !isInEditMode)
            documentLine.appendChild(newFileInput)
          }
        }
        if (fileInputId) {
          const buildingId = await deriveBuildingId(documentRow)
          const effectiveBuildingId = effectiveBuildingIdForFileInput(
            fileInputId,
            buildingId
          )
          listPromises.push(
            getAndListPropertyDocuments({
              propertyId,
              buildingId: effectiveBuildingId,
              fileInputId,
              fileInputLabel: fileInputLabel.trim(),
              documentRow,
            })
          )
        }
      }
      if (listPromises.length > 0) {
        removalScheduled = true
        Promise.allSettled(listPromises).finally(() =>
          removeLoadingOverlay(rootElement)
        )
      }
    } catch (e) {
      console.error('[ImpowerX] Failed to process file upload line items', e)
    } finally {
      if (!removalScheduled) {
        removeLoadingOverlay(rootElement)
      }
    }
  }

  const processFileUploadSections = async (sections) => {
    if (!sections?.length) return
    for (const section of sections) {
      if (processedFileUploadSections.has(section)) continue
      processedFileUploadSections.add(section)
      try {
        addLoadingOverlay(section)
        await Promise.allSettled([
          processFileUploads(section),
          processFileUploadLineItems(section),
        ])
      } catch (e) {
        console.error('[ImpowerX] Failed to process file upload sections', e)
      } finally {
        removeLoadingOverlay(section)
      }
    }
  }

  const getSubSectionElements = async (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (!node) continue
          if (node?.nodeType !== 1) continue
          if (
            node.classList?.contains('impower-x') ||
            node.classList?.contains('impower-x-file-input') ||
            node.classList?.contains('Link') ||
            node.classList?.contains('second-row')
          )
            continue
          if (
            node.id === 'insuranceIdentity' ||
            node.id === 'insurance-weg' ||
            (node.id && /^insurance-building-\d+$/.test(node.id)) ||
            (node.querySelector &&
              node.querySelector(
                '#insuranceIdentity, #insurance-weg, [id^="insurance-building-"]'
              ))
          ) {
            scheduleInsuranceVersicherungsvertragUploads()
          }
          if (
            node.matches &&
            node.matches('.FormSection[id^="BuildingEquipment"]')
          ) {
            setTimeout(runBuildingEquipmentInjects, 80)
          }
          if (node.classList?.contains('section-content')) {
            const formSection =
              node.closest?.('.FormSection') ||
              node.parentElement?.closest?.('.FormSection')
            if (formSection?.id?.startsWith?.('BuildingEquipment')) {
              setTimeout(runBuildingEquipmentInjects, 80)
            }
            const subSections = node.querySelectorAll('.sub-section')
            if (subSections.length > 0) {
              await processFileUploadSections(subSections)
            }
            const formSectionForFiles = node.closest('.FormSection')
            if (formSectionForFiles) {
              await processFileUploadSections([formSectionForFiles])
            }
          } else if (node.classList?.contains('sub-section')) {
            if (
              node.id?.startsWith?.('Heating') ||
              (typeof node.id === 'string' &&
                /buildingIdentification/i.test(node.id))
            ) {
              setTimeout(runBuildingEquipmentInjects, 80)
            }
            await processFileUploadSections([node])
          } else if (node.classList?.contains('sub-section-content')) {
            const subSection = node.closest?.('.sub-section')
            if (
              subSection?.id?.startsWith?.('Heating') ||
              (typeof subSection?.id === 'string' &&
                /buildingIdentification/i.test(subSection.id))
            ) {
              setTimeout(runBuildingEquipmentInjects, 80)
            }
            processFileUploads(node)
            processFileUploadLineItems(node)
          } else if (node.classList?.contains('FileUpload')) {
            processFileUploads(node)
          } else if (node.classList?.contains('FileUploadLine')) {
            processFileUploadLineItems(node)
          } else if (
            node?.querySelector &&
            node?.querySelector('input[type="file"]')
          ) {
            const fileInput = node.querySelector('input[type="file"]')
            if (fileInput && !isStandaloneLuxFileInput(fileInput)) {
              processFileInput(fileInput)
            }
          } else if (
            node?.querySelector &&
            (node.querySelector(
              '.FormSection[id^="BuildingEquipment"] .section-content'
            ) ||
              node.querySelector('.sub-section[id^="Heating"]') ||
              node.querySelector(
                '.sub-section[id^="buildingIdentification"]'
              ) ||
              node.querySelector('.sub-section[id^="BuildingIdentification"]'))
          ) {
            setTimeout(runBuildingEquipmentInjects, 80)
          } else {
            continue
          }
        }
      }
    }
  }

  $(document).off('change.impowerxFileInput')
  $(document).on(
    'change.impowerxFileInput',
    '.impower-x-file-input',
    async (event) => {
      const fileInput = event.target

      if (isStandaloneLuxFileInput(fileInput)) {
        return
      }

      // Prevent multiple simultaneous executions
      if (processingFileInputs.has(fileInput)) {
        event.target.value = '' // Reset file input to prevent re-triggering
        return
      }

      const files = fileInput.files
      if (files && files.length > 0) {
        // Mark as processing
        processingFileInputs.add(fileInput)

        try {
          const fileInputId = fileInput.id
          const buildingId = await deriveBuildingId(fileInput)
          const effectiveBuildingId = effectiveBuildingIdForFileInput(
            fileInputId,
            buildingId
          )
          const parentDiv =
            fileInput.closest('.FileUpload') ||
            fileInput.closest('.FileUploadLine')
          let fileInputLabel =
            parentDiv
              ?.querySelector('.description-label')
              ?.textContent?.trim()
              ?.toLowerCase() || ''
          if (!fileInputLabel) {
            fileInputLabel =
              parentDiv
                ?.querySelector('div.file-name')
                ?.textContent?.trim()
                ?.toLowerCase() || ''
          }
          const MAX_FILE_SIZE =
            (!isNaN(window?.maxFileSizeSingleMB)
              ? window?.maxFileSizeSingleMB
              : 20) *
            1024 *
            1024
          const MAX_TOTAL_SIZE =
            (!isNaN(window?.maxFileSizeTotalMB)
              ? window?.maxFileSizeTotalMB
              : 50) *
            1024 *
            1024

          const filesArray = Array.from(files)

          // Check individual file sizes
          const oversizedFiles = filesArray.filter(
            (file) => file.size > MAX_FILE_SIZE
          )
          if (oversizedFiles.length > 0) {
            const fileNames = oversizedFiles.map((f) => f.name).join(', ')
            const maxSizeFormatted = formatFileSize(MAX_FILE_SIZE)
            showFileInputError(
              parentDiv,
              `Datei(en) zu groß: ${fileNames}. Maximale Größe pro Datei: ${maxSizeFormatted}`
            )
            fileInput.value = '' // Reset file input
            return
          }

          // Check total file size
          const totalSize = filesArray.reduce((sum, file) => sum + file.size, 0)
          if (totalSize > MAX_TOTAL_SIZE) {
            const totalSizeFormatted = formatFileSize(totalSize)
            const maxTotalFormatted = formatFileSize(MAX_TOTAL_SIZE)
            showFileInputError(
              fileInput.closest('.FileUpload') ||
                fileInput.closest('.FileUploadLine'),
              `Gesamtgröße der Dateien (${totalSizeFormatted}) überschreitet das Limit von ${maxTotalFormatted}`
            )
            fileInput.value = '' // Reset file input
            return
          }

          await handleImpowerxFileInputChange({
            files,
            propertyId,
            buildingId: effectiveBuildingId,
            fileInputId,
            fileInputLabel,
            documentRow: parentDiv,
          })
        } catch (error) {
          console.error('Error handling file input change:', error)
        } finally {
          // Clear processing flag and reset input value
          processingFileInputs.delete(fileInput)
          fileInput.value = '' // Reset file input to allow selecting the same files again
        }
      }
    }
  )

  const formSections = document.querySelectorAll('.FormSection')
  processFileUploadSections(Array.from(formSections))
  setTimeout(scheduleInsuranceVersicherungsvertragUploads, 400)

  const buildingElementsObserver = new MutationObserver(getSubSectionElements)
  buildingElementsObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
  observers.push(buildingElementsObserver)

  $(document).on(
    'click.impowerxProperty',
    '.FormSidebar .main-link .link-title, .main-section-header.section-header',
    () => {
      setTimeout(runBuildingEquipmentInjects, 150)
      setTimeout(scheduleInsuranceVersicherungsvertragUploads, 300)
    }
  )

  $(document).on(
    'click.impowerxInsuranceVvRadio',
    '#ServiceProvider .ant-radio-wrapper',
    () => {
      setTimeout(scheduleInsuranceVersicherungsvertragUploads, 50)
    }
  )

  // =============================================================================
  // Force notification settings (property-scoped)
  // =============================================================================
  // Mirrors the admin card in /einstellungen but scoped to the current property:
  // a FormSection at the end of the form plus a FormSidebar link, with target
  // toggles + a button to open a modal that loads portal users and POSTs to
  // /api/notification-settings/property/[id].
  const propertyNotificationsTeardown = (() => {
    if (!propertyId) {
      window.__impowerxPropertyInjectInFlight = null
      return () => {}
    }

    const SECTION_ID = 'ImpowerxPropertyNotificationsSection'
    const DIALOG_ID = 'ImpowerxPropertyNotificationsDialog'
    const STYLE_ID = 'impowerx-property-notifications-style'

    const NOTIFICATION_DEFS = [
      {
        key: 'all',
        label: 'E-Mail-Benachrichtigungen aktivieren',
        isChild: false,
      },
      {
        key: 'statusChanges',
        label: 'E-Mail Benachrichtigung für Statusänderungen',
        isChild: true,
      },
      {
        key: 'newUploadedDocuments',
        label: 'E-Mail-Benachrichtigungen für neue hochgeladene Dokumente',
        isChild: true,
      },
      {
        key: 'phaseChanges',
        label: 'E-Mail Benachrichtigung für Phasenänderungen',
        isChild: true,
      },
    ]

    const DEFAULT_FORCED_SETTINGS = {
      all: true,
      statusChanges: true,
      newUploadedDocuments: true,
      phaseChanges: false,
    }

    const BELL_SVG = `
      <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 20a2.4 2.4 0 0 0 2.4-2.4H6.6A2.4 2.4 0 0 0 9 20Zm7.2-6V8.4c0-3.69-1.98-6.78-5.4-7.6V0H7.2v.8C3.78 1.62 1.8 4.71 1.8 8.4V14L0 15.8v.9h18v-.9L16.2 14Z" fill="currentColor"/>
      </svg>
    `

    const injectStyles = () => {
      if (document.getElementById(STYLE_ID)) return
      const style = document.createElement('style')
      style.id = STYLE_ID
      style.textContent = `
        #${SECTION_ID} .impowerx-pn-body { padding: 0px 24px 24px; }
        #${SECTION_ID} .impowerx-pn-subtitle {
          font-size: 13px;
          color: rgba(0,0,0,0.6);
          margin: 0 0 32px;
          line-height: 1.45;
        }
        #${SECTION_ID} .impowerx-pn-rows {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        #${SECTION_ID} .impowerx-pn-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
        }
        #${SECTION_ID} .impowerx-pn-row.is-child { padding-left: 24px; }
        #${SECTION_ID} .impowerx-pn-label {
          font-size: 14px;
          color: rgba(0,0,0,0.85);
          cursor: pointer;
        }
        #${SECTION_ID} .impowerx-pn-actions { padding-top: 24px; }
        #${SECTION_ID} .impowerx-pn-open-btn {
          width: 100%;
          background: #18181b;
          color: #fff;
          border: 1px solid #18181b;
          padding: 10px 16px;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.15s, opacity 0.15s;
        }
        #${SECTION_ID} .impowerx-pn-open-btn:hover:not(:disabled) { background: #27272a; }
        #${SECTION_ID} .impowerx-pn-open-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        #${SECTION_ID} .impowerx-pn-switch {
          position: relative;
          display: inline-block;
          width: 36px;
          height: 20px;
          flex-shrink: 0;
          cursor: pointer;
        }
        #${SECTION_ID} .impowerx-pn-switch input { opacity: 0; width: 0; height: 0; }
        #${SECTION_ID} .impowerx-pn-slider {
          position: absolute;
          cursor: pointer;
          inset: 0;
          background-color: #e4e4e7;
          transition: background-color 0.2s;
          border-radius: 20px;
        }
        #${SECTION_ID} .impowerx-pn-slider::before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 2px;
          bottom: 2px;
          background-color: #fff;
          transition: transform 0.2s;
          border-radius: 50%;
          box-shadow: 0 1px 2px rgba(0,0,0,0.15);
        }
        #${SECTION_ID} .impowerx-pn-switch input:checked + .impowerx-pn-slider { background-color: #18181b; }
        #${SECTION_ID} .impowerx-pn-switch input:checked + .impowerx-pn-slider::before { transform: translateX(16px); }
        #${SECTION_ID} .impowerx-pn-switch.is-disabled,
        #${SECTION_ID} .impowerx-pn-switch.is-disabled .impowerx-pn-slider { cursor: not-allowed; }
        #${SECTION_ID} .impowerx-pn-switch.is-disabled .impowerx-pn-slider { opacity: 0.5; }
        #${SECTION_ID} .impowerx-pn-pending {
          margin-top: 12px;
          padding: 10px 12px;
          background: #f4f4f5;
          border: 1px solid #e4e4e7;
          border-radius: 6px;
          font-size: 12px;
          color: rgba(0,0,0,0.7);
          display: flex;
          align-items: center;
          gap: 8px;
        }
        #${SECTION_ID} .impowerx-pn-pending .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #f59e0b;
          flex-shrink: 0;
        }
        #${SECTION_ID} .impowerx-pn-pending.is-error {
          background: #fef2f2;
          border-color: #fecaca;
          color: #dc2626;
        }
        #${SECTION_ID} .impowerx-pn-pending.is-error .dot {
          background: #dc2626;
        }

        #${DIALOG_ID}-backdrop {
          position: fixed; inset: 0; background: rgba(0,0,0,0.45);
          z-index: 2147483600; display: flex; align-items: center; justify-content: center;
        }
        #${DIALOG_ID} {
          background: #fff; border-radius: 8px;
          width: min(720px, calc(100vw - 32px));
          max-height: calc(100vh - 64px);
          display: flex; flex-direction: column;
          box-shadow: 0 12px 32px rgba(0,0,0,0.25);
        }
        #${DIALOG_ID} .impowerx-pn-dialog-header {
          padding: 20px 24px 12px;
          position: relative;
        }
        #${DIALOG_ID} .impowerx-pn-dialog-title { font-size: 18px; font-weight: 600; margin: 0 0 4px; padding-right: 28px; }
        #${DIALOG_ID} .impowerx-pn-dialog-subtitle { font-size: 13px; color: rgba(0,0,0,0.6); margin: 0; padding-right: 28px; line-height: 1.45; }
        #${DIALOG_ID} .impowerx-pn-dialog-close {
          position: absolute;
          top: 16px;
          right: 16px;
          background: transparent;
          border: none;
          padding: 4px;
          width: 28px;
          height: 28px;
          border-radius: 4px;
          cursor: pointer;
          color: rgba(0,0,0,0.55);
          font-size: 18px;
          line-height: 1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        #${DIALOG_ID} .impowerx-pn-dialog-close:hover { background: rgba(0,0,0,0.05); color: rgba(0,0,0,0.85); }
        #${DIALOG_ID} .impowerx-pn-dialog-body {
          padding: 0 24px 16px;
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }
        #${DIALOG_ID} .impowerx-pn-target-box {
          border: 1px solid rgba(0,0,0,0.08);
          background: rgba(244,244,245,0.55);
          border-radius: 6px;
          padding: 12px 14px;
          margin-bottom: 12px;
        }
        #${DIALOG_ID} .impowerx-pn-target-label {
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: rgba(0,0,0,0.55);
          margin-bottom: 8px;
        }
        #${DIALOG_ID} .impowerx-pn-target-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 6px 12px;
          font-size: 13px;
        }
        @media (max-width: 540px) {
          #${DIALOG_ID} .impowerx-pn-target-grid { grid-template-columns: 1fr; }
        }
        #${DIALOG_ID} .impowerx-pn-target-item {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          color: rgba(0,0,0,0.85);
        }
        #${DIALOG_ID} .impowerx-pn-target-item svg {
          flex-shrink: 0;
          margin-top: 2px;
        }
        #${DIALOG_ID} .impowerx-pn-target-item.is-on svg { color: #16a34a; }
        #${DIALOG_ID} .impowerx-pn-target-item.is-off svg { color: #dc2626; }
        #${DIALOG_ID} .impowerx-pn-dialog-toolbar {
          padding: 8px 0; display: flex; flex-direction: column; gap: 8px;
          border-bottom: 1px solid rgba(0,0,0,0.08);
        }
        #${DIALOG_ID} .impowerx-pn-checkboxes-grid {
          display: grid; grid-template-columns: 1fr 1fr; gap: 8px 24px;
        }
        #${DIALOG_ID} .impowerx-pn-select-all { display: flex; align-items: center; gap: 8px; font-size: 13px; cursor: pointer; }
        #${DIALOG_ID} .impowerx-pn-select-all input { width: 16px; height: 16px; cursor: pointer; accent-color: #18181b; }
        #${DIALOG_ID} .impowerx-pn-only-affected { display: flex; align-items: center; gap: 8px; font-size: 13px; cursor: pointer; }
        #${DIALOG_ID} .impowerx-pn-only-affected input { width: 16px; height: 16px; cursor: pointer; accent-color: #18181b; }
        #${DIALOG_ID} .impowerx-pn-show-unregistered,
        #${DIALOG_ID} .impowerx-pn-apply-future { display: flex; align-items: center; gap: 8px; font-size: 13px; cursor: pointer; }
        #${DIALOG_ID} .impowerx-pn-show-unregistered input,
        #${DIALOG_ID} .impowerx-pn-apply-future input { width: 16px; height: 16px; cursor: pointer; accent-color: #18181b; }
        #${DIALOG_ID} .impowerx-pn-user-badge {
          display: inline-block;
          margin-top: 4px;
          padding: 1px 6px;
          font-size: 11px;
          border-radius: 4px;
          background: #fef3c7;
          color: #92400e;
        }
        #${DIALOG_ID} .impowerx-pn-search-wrapper {
          position: relative;
          width: 100%;
        }
        #${DIALOG_ID} .impowerx-pn-search-wrapper svg {
          position: absolute;
          top: 50%;
          left: 8px;
          transform: translateY(-50%);
          color: rgba(0,0,0,0.4);
          pointer-events: none;
        }
        #${DIALOG_ID} .impowerx-pn-search {
          width: 100%;
          padding: 6px 10px 6px 30px;
          border: 1px solid rgba(0,0,0,0.15);
          border-radius: 6px;
          font-size: 13px;
          height: 32px;
          box-sizing: border-box;
        }
        #${DIALOG_ID} .impowerx-pn-search:focus {
          outline: none;
          border-color: rgba(0,0,0,0.4);
        }
        #${DIALOG_ID} .impowerx-pn-count { font-size: 12px; color: rgba(0,0,0,0.55); margin-right: auto; }
        #${DIALOG_ID} .impowerx-pn-list {
          flex: 1;
          overflow-y: auto;
          padding: 8px 0;
          display: flex;
          flex-direction: column;
          gap: 8px;
          max-height: 360px;
        }
        #${DIALOG_ID} .impowerx-pn-empty { padding: 24px; text-align: center; color: rgba(0,0,0,0.55); font-size: 13px; }
        #${DIALOG_ID} .impowerx-pn-user {
          display: flex;
          gap: 12px;
          padding: 12px;
          border: 1px solid rgba(0,0,0,0.08);
          border-radius: 6px;
          align-items: flex-start;
        }
        #${DIALOG_ID} .impowerx-pn-user.is-no-change { opacity: 0.6; }
        #${DIALOG_ID} .impowerx-pn-user input[type="checkbox"] {
          width: 16px; height: 16px; cursor: pointer; margin-top: 2px; accent-color: #18181b;
        }
        #${DIALOG_ID} .impowerx-pn-user input[type="checkbox"]:disabled { cursor: not-allowed; }
        #${DIALOG_ID} .impowerx-pn-user-main { flex: 1; min-width: 0; }
        #${DIALOG_ID} .impowerx-pn-user-name { font-size: 13px; font-weight: 500; color: rgba(0,0,0,0.9); }
        #${DIALOG_ID} .impowerx-pn-user-email { font-size: 12px; color: rgba(0,0,0,0.55); margin-top: 2px; }
        #${DIALOG_ID} .impowerx-pn-user-note { font-size: 12px; color: rgba(0,0,0,0.55); margin-top: 4px; }
        #${DIALOG_ID} .impowerx-pn-user-diff { font-size: 12px; margin: 4px 0 0; padding: 0; list-style: none; }
        #${DIALOG_ID} .impowerx-pn-user-diff li { display: flex; align-items: center; gap: 6px; padding: 1px 0; }
        #${DIALOG_ID} .impowerx-pn-user-diff .label { color: rgba(0,0,0,0.55); }
        #${DIALOG_ID} .impowerx-pn-user-diff .arrow { color: rgba(0,0,0,0.4); }
        #${DIALOG_ID} .impowerx-pn-user-diff .on { color: #16a34a; }
        #${DIALOG_ID} .impowerx-pn-user-diff .off { color: #dc2626; }
        #${DIALOG_ID} .impowerx-pn-user-diff .next { font-weight: 500; }
        #${DIALOG_ID} .impowerx-pn-dialog-footer {
          padding: 16px 24px;
          border-top: 1px solid rgba(0,0,0,0.08);
          display: flex;
          justify-content: flex-end;
          gap: 8px;
        }
        #${DIALOG_ID} .impowerx-pn-dialog-footer button {
          padding: 8px 16px;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.15s, opacity 0.15s;
        }
        #${DIALOG_ID} .impowerx-pn-cancel {
          background: #fff;
          border: 1px solid rgba(0,0,0,0.15);
          color: rgba(0,0,0,0.85);
        }
        #${DIALOG_ID} .impowerx-pn-cancel:hover { background: rgba(0,0,0,0.04); }
        #${DIALOG_ID} .impowerx-pn-apply {
          background: #18181b;
          color: #fff;
          border: 1px solid #18181b;
        }
        #${DIALOG_ID} .impowerx-pn-apply:hover:not(:disabled) { background: #27272a; }
        #${DIALOG_ID} .impowerx-pn-apply:disabled { opacity: 0.5; cursor: not-allowed; }
        #${DIALOG_ID} .impowerx-pn-status { padding: 0 24px 12px; font-size: 12px; color: rgba(0,0,0,0.55); }
        #${DIALOG_ID} .impowerx-pn-status.is-error { color: #dc2626; }
      `
      document.head.appendChild(style)
    }

    const readAuthToken = () => {
      try {
        const stored = JSON.parse(localStorage.getItem('auth') || '{}')
        return stored?.token || null
      } catch (_) {
        return null
      }
    }

    let forcedSettings = { ...DEFAULT_FORCED_SETTINGS }
    let forcedSettingsUserEdited = false
    let forcedSettingsLoadId = 0
    let sectionEl = null
    let sectionInputsByKey = {}
    let sectionOpenBtnEl = null
    let sectionPendingIndicatorEl = null
    let dialogBackdropEl = null
    let dialogState = null
    let isMounted = false
    let isInEditMode = localStorage.getItem(editModeStorageKey) === 'true'
    let pendingApply = null
    let sectionApplyError = null
    let flushPendingApplyPromise = null

    const closeDialog = () => {
      if (!dialogBackdropEl) return
      dialogBackdropEl.remove()
      dialogBackdropEl = null
      dialogState = null
      document.removeEventListener('keydown', onDialogKeydown)
    }

    const onDialogKeydown = (event) => {
      if (event.key === 'Escape') closeDialog()
    }

    const applyFutureContactRuleSettings = (settings) => {
      if (forcedSettingsUserEdited || !settings || typeof settings !== 'object')
        return
      const next = { ...DEFAULT_FORCED_SETTINGS }
      NOTIFICATION_DEFS.forEach((definition) => {
        if (typeof settings[definition.key] === 'boolean') {
          next[definition.key] = settings[definition.key]
        }
      })
      forcedSettings = next
      updateSectionInputs()
    }

    const loadForcedSettings = async () => {
      const loadId = ++forcedSettingsLoadId
      const token = readAuthToken()
      if (!token) return

      try {
        const response = await fetch(
          `${baseApiUrl}/api/notification-settings/property/${propertyId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )
        if (loadId !== forcedSettingsLoadId || !response.ok) return
        const data = await response.json()
        if (loadId !== forcedSettingsLoadId) return
        applyFutureContactRuleSettings(data?.futureContactRuleSettings)
      } catch (error) {
        console.error(
          '[ImpowerX] Error loading property notification rule:',
          error
        )
      }
    }

    const willChangeForUser = (user) =>
      NOTIFICATION_DEFS.map((definition) => definition.key).filter(
        (key) =>
          Boolean(user.notificationSettings?.[key]) !==
          Boolean(forcedSettings[key])
      )

    const isUnregistered = (user) => user.isRegistered === false

    // Applies the same visibility filters (registration, affected-only, search)
    // used by both the rendered list and the select-all action.
    const getFilteredUsers = () => {
      const normalizedQuery = dialogState.searchQuery.trim().toLowerCase()
      let pool = dialogState.users
      if (!dialogState.showUnregistered)
        pool = pool.filter((user) => !isUnregistered(user))
      if (dialogState.onlyAffected)
        pool = pool.filter((user) => willChangeForUser(user).length > 0)
      if (normalizedQuery) {
        pool = pool.filter((user) =>
          `${user.name || ''} ${user.email || ''}`
            .toLowerCase()
            .includes(normalizedQuery)
        )
      }
      return pool
    }

    const renderDialogList = () => {
      if (!dialogState) return
      const {
        listEl,
        selectAllEl,
        selectAllLabelEl,
        countEl,
        statusEl,
        applyBtn,
      } = dialogState

      const normalizedQuery = dialogState.searchQuery.trim().toLowerCase()
      const filtered = getFilteredUsers()

      const visibleSelectable = filtered.filter(
        (user) => willChangeForUser(user).length > 0
      )
      const visibleSelectableIds = new Set(
        visibleSelectable.map((user) => user.id)
      )
      const allVisibleSelected =
        visibleSelectableIds.size > 0 &&
        Array.from(visibleSelectableIds).every((id) =>
          dialogState.selected.has(id)
        )

      selectAllEl.checked = allVisibleSelected
      selectAllEl.disabled = visibleSelectableIds.size === 0

      if (selectAllLabelEl) {
        selectAllLabelEl.textContent = `Alle auswählen (${dialogState.selected.size}/${visibleSelectableIds.size})`
      }

      const totalUsers = dialogState.users.length
      if (normalizedQuery) {
        countEl.textContent = `${filtered.length} von ${totalUsers} Benutzern`
      } else if (dialogState.onlyAffected) {
        countEl.textContent = `${filtered.length} von ${totalUsers} Benutzern (betroffen)`
      } else {
        countEl.textContent =
          totalUsers === 1
            ? '1 Benutzer für dieses Objekt'
            : `${totalUsers} Benutzer für dieses Objekt`
      }

      listEl.replaceChildren()

      if (dialogState.isLoading) {
        const empty = document.createElement('div')
        empty.className = 'impowerx-pn-empty'
        empty.textContent = 'Benutzer werden geladen...'
        listEl.appendChild(empty)
      } else if (filtered.length === 0) {
        const empty = document.createElement('div')
        empty.className = 'impowerx-pn-empty'
        empty.textContent = normalizedQuery
          ? 'Keine Benutzer entsprechen Ihrer Suche.'
          : dialogState.onlyAffected && dialogState.users.length > 0
            ? 'Keine betroffenen Kontakte. Aktivieren Sie alle anzeigen, um die übrigen zu sehen.'
            : 'Für dieses Objekt sind keine Portal-Benutzer registriert.'
        listEl.appendChild(empty)
      } else {
        filtered.forEach((user) => {
          const changing = willChangeForUser(user)
          const isAlreadyMatching = changing.length === 0
          const isSelected = dialogState.selected.has(user.id)

          const row = document.createElement('div')
          row.className = `impowerx-pn-user${isAlreadyMatching ? ' is-no-change' : ''}`

          const checkbox = document.createElement('input')
          checkbox.type = 'checkbox'
          checkbox.checked = isSelected
          checkbox.disabled = isAlreadyMatching
          checkbox.addEventListener('change', () => {
            if (checkbox.checked) dialogState.selected.add(user.id)
            else dialogState.selected.delete(user.id)
            renderDialogList()
          })

          const main = document.createElement('div')
          main.className = 'impowerx-pn-user-main'

          const name = document.createElement('div')
          name.className = 'impowerx-pn-user-name'
          name.textContent =
            user.name || user.email || `Kontakt #${user.contactId}`
          main.appendChild(name)

          if (user.name && user.email) {
            const email = document.createElement('div')
            email.className = 'impowerx-pn-user-email'
            email.textContent = user.email
            main.appendChild(email)
          }

          if (isUnregistered(user)) {
            const badge = document.createElement('span')
            badge.className = 'impowerx-pn-user-badge'
            badge.textContent =
              'Noch nicht registriert — gilt bei Registrierung'
            main.appendChild(badge)
          }

          if (isAlreadyMatching) {
            const note = document.createElement('div')
            note.className = 'impowerx-pn-user-note'
            note.textContent =
              'Bereits identisch — keine Änderung erforderlich.'
            main.appendChild(note)
          } else {
            const diffList = document.createElement('ul')
            diffList.className = 'impowerx-pn-user-diff'
            changing.forEach((key) => {
              const definition = NOTIFICATION_DEFS.find((d) => d.key === key)
              if (!definition) return
              const li = document.createElement('li')
              const current = Boolean(user.notificationSettings?.[key])
              const next = Boolean(forcedSettings[key])
              li.innerHTML = `
                <span class="label">${definition.label}:</span>
                <span class="${current ? 'on' : 'off'}">${current ? 'an' : 'aus'}</span>
                <span class="arrow">→</span>
                <span class="next ${next ? 'on' : 'off'}">${next ? 'an' : 'aus'}</span>
              `
              diffList.appendChild(li)
            })
            main.appendChild(diffList)
          }

          row.appendChild(checkbox)
          row.appendChild(main)
          listEl.appendChild(row)
        })
      }

      const selectedCount = dialogState.selected.size
      applyBtn.disabled =
        dialogState.isLoading ||
        (selectedCount === 0 && !dialogState.applyToFuture)
      if (selectedCount === 0 && dialogState.applyToFuture) {
        applyBtn.textContent = 'Regel speichern'
      } else {
        applyBtn.textContent = `Auf ${selectedCount} Kontakte anwenden`
      }

      statusEl.classList.toggle('is-error', Boolean(dialogState.errorMessage))
      statusEl.textContent = dialogState.errorMessage || ''
    }

    const fetchPropertyUsers = async () => {
      if (!dialogState) return

      const token = readAuthToken()
      if (!token) {
        dialogState.errorMessage =
          'Nicht angemeldet. Benutzer können nicht geladen werden.'
        dialogState.isLoading = false
        renderDialogList()
        return
      }

      try {
        const response = await fetch(
          `${baseApiUrl}/api/notification-settings/property/${propertyId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )
        if (!dialogState) return
        if (!response.ok) {
          dialogState.errorMessage = 'Benutzer konnten nicht geladen werden.'
          dialogState.isLoading = false
          renderDialogList()
          return
        }
        const data = await response.json()
        if (!dialogState) return
        applyFutureContactRuleSettings(data?.futureContactRuleSettings)
        dialogState.users = Array.isArray(data?.users) ? data.users : []
        // Pre-select registered, affected users only. Unregistered contacts are
        // hidden by default and opted into via the "show unregistered" toggle.
        dialogState.selected = new Set(
          dialogState.users
            .filter(
              (user) =>
                !isUnregistered(user) && willChangeForUser(user).length > 0
            )
            .map((user) => user.id)
        )
      } catch (error) {
        console.error('Error loading property notification users:', error)
        if (!dialogState) return
        dialogState.errorMessage = 'Benutzer konnten nicht geladen werden.'
      } finally {
        if (!dialogState) return
        dialogState.isLoading = false
        renderDialogList()
      }
    }

    const applyForceUpdate = () => {
      if (!dialogState) return
      const applyToFuture = dialogState.applyToFuture
      if (dialogState.selected.size === 0 && !applyToFuture) return

      const selectedIds = Array.from(dialogState.selected)
      const userIds = selectedIds.filter(
        (id) => !String(id).startsWith('unregistered:')
      )
      const contactIds = selectedIds
        .filter((id) => String(id).startsWith('unregistered:'))
        .map((id) => Number(String(id).slice('unregistered:'.length)))
        .filter((id) => Number.isFinite(id) && id > 0)

      sectionApplyError = null
      pendingApply = {
        userIds,
        contactIds,
        applyToFuture,
      }
      closeDialog()
      updatePendingIndicator()
    }

    const ensureSectionExpanded = () => {
      if (!sectionEl) return
      const sectionWrapper = sectionEl.querySelector('.form-section-wrapper')
      const sectionHeader = sectionEl.querySelector(
        '.main-section-header.section-header'
      )
      const sectionNumberBox = sectionEl.querySelector('.section-number-box')
      const sectionTitleBox = sectionEl.querySelector('.section-title-box')
      if (!sectionWrapper || !sectionHeader) return
      sectionWrapper.classList.add('open')
      if (sectionHeader.classList.contains('not-open')) {
        sectionHeader.classList.remove('not-open')
        sectionHeader.classList.add('open')
        sectionNumberBox?.classList.add('open')
        sectionTitleBox?.classList.add('open')
        if (typeof sectionEl._impowerxOpenSection === 'function') {
          sectionEl._impowerxOpenSection()
        }
      }
    }

    const surfaceApplyError = (message) => {
      sectionApplyError = message
      ensureSectionExpanded()
      updatePendingIndicator()
      sectionPendingIndicatorEl?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      })
    }

    const NOTIFICATION_APPLY_FAILED_MESSAGE =
      'Benachrichtigungseinstellungen konnten nicht gespeichert werden. Bitte Objekt erneut bearbeiten und speichern.'

    const runFlushLoop = async () => {
      while (pendingApply) {
        const token = readAuthToken()
        if (!token) {
          console.warn(
            '[ImpowerX] Cannot save notification settings: missing auth token.'
          )
          const message =
            'Nicht angemeldet. Benachrichtigungseinstellungen konnten nicht gespeichert werden.'
          surfaceApplyError(message)
          return message
        }

        const payload = pendingApply
        try {
          const response = await fetch(
            `${baseApiUrl}/api/notification-settings/property/${propertyId}`,
            {
              method: 'POST',
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                propertyId,
                userIds: payload.userIds,
                contactIds: payload.contactIds,
                applyToFuture: payload.applyToFuture,
                notificationSettings: { ...forcedSettings },
              }),
            }
          )

          if (!response.ok) {
            console.error(
              '[ImpowerX] Failed to apply property notification settings.',
              response.status
            )
            surfaceApplyError(NOTIFICATION_APPLY_FAILED_MESSAGE)
            return NOTIFICATION_APPLY_FAILED_MESSAGE
          }

          await response.json().catch(() => null)
          sectionApplyError = null
          if (pendingApply === payload) {
            pendingApply = null
          }
          updatePendingIndicator()
        } catch (error) {
          console.error(
            '[ImpowerX] Error applying property notification settings:',
            error
          )
          surfaceApplyError(NOTIFICATION_APPLY_FAILED_MESSAGE)
          return NOTIFICATION_APPLY_FAILED_MESSAGE
        }
      }
      return null
    }

    const flushPendingApply = async () => {
      if (flushPendingApplyPromise) {
        await flushPendingApplyPromise
        return flushPendingApply()
      }
      if (!pendingApply) return null

      flushPendingApplyPromise = runFlushLoop().finally(() => {
        flushPendingApplyPromise = null
      })
      return flushPendingApplyPromise
    }
    onPropertySaveSuccess = flushPendingApply

    const openDialog = () => {
      if (dialogBackdropEl) return

      injectStyles()
      dialogBackdropEl = document.createElement('div')
      dialogBackdropEl.id = `${DIALOG_ID}-backdrop`
      dialogBackdropEl.addEventListener('click', (event) => {
        if (event.target === dialogBackdropEl) closeDialog()
      })

      const dialog = document.createElement('div')
      dialog.id = DIALOG_ID
      dialog.setAttribute('role', 'dialog')
      dialog.setAttribute('aria-modal', 'true')

      const checkIconSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`
      const xIconSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`
      const closeIconSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`
      const searchIconSvg = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>`

      const targetItems = NOTIFICATION_DEFS.map((definition) => {
        const value = Boolean(forcedSettings[definition.key])
        return `<div class="impowerx-pn-target-item ${value ? 'is-on' : 'is-off'}">
          ${value ? checkIconSvg : xIconSvg}
          <span>${definition.label}</span>
        </div>`
      }).join('')

      dialog.innerHTML = `
        <div class="impowerx-pn-dialog-header">
          <h2 class="impowerx-pn-dialog-title">Benachrichtigungseinstellungen</h2>
          <p class="impowerx-pn-dialog-subtitle">Wählen Sie die Kontakte aus, deren Einstellungen jetzt erzwungen werden sollen. Bereits registrierte Benutzer werden sofort aktualisiert, nicht registrierte Kontakte erhalten die Einstellung bei ihrer Registrierung. Mit "Für künftige Kontakte speichern" gilt sie zusätzlich für später hinzukommende Kontakte.</p>
          <button type="button" class="impowerx-pn-dialog-close" aria-label="Schließen">${closeIconSvg}</button>
        </div>
        <div class="impowerx-pn-dialog-body">
          <div class="impowerx-pn-target-box">
            <div class="impowerx-pn-target-label">Zielzustand</div>
            <div class="impowerx-pn-target-grid">${targetItems}</div>
          </div>
          <div class="impowerx-pn-dialog-toolbar">
            <div class="impowerx-pn-checkboxes-grid">
              <label class="impowerx-pn-select-all">
                <input type="checkbox" class="impowerx-pn-select-all-input" />
                <span class="impowerx-pn-select-all-text">Alle auswählen</span>
              </label>
              <label class="impowerx-pn-only-affected">
                <input type="checkbox" class="impowerx-pn-only-affected-input" checked />
                <span>Nur betroffene Kontakte anzeigen</span>
              </label>
              <label class="impowerx-pn-show-unregistered">
                <input type="checkbox" class="impowerx-pn-show-unregistered-input" />
                <span>Auch nicht registrierte Kontakte anzeigen</span>
              </label>
              <label class="impowerx-pn-apply-future">
                <input type="checkbox" class="impowerx-pn-apply-future-input" checked />
                <span>Für künftige Kontakte des Objekts speichern</span>
              </label>
            </div>
            <div class="impowerx-pn-search-wrapper">
              ${searchIconSvg}
              <input type="search" class="impowerx-pn-search" placeholder="Benutzer nach Name oder E-Mail suchen" />
            </div>
          </div>
          <div class="impowerx-pn-list"></div>
        </div>
        <div class="impowerx-pn-status"></div>
        <div class="impowerx-pn-dialog-footer">
          <span class="impowerx-pn-count"></span>
          <button type="button" class="impowerx-pn-cancel">Abbrechen</button>
          <button type="button" class="impowerx-pn-apply">Auf 0 Benutzer anwenden</button>
        </div>
      `

      dialogBackdropEl.appendChild(dialog)
      document.body.appendChild(dialogBackdropEl)
      document.addEventListener('keydown', onDialogKeydown)

      const searchEl = dialog.querySelector('.impowerx-pn-search')
      const selectAllEl = dialog.querySelector('.impowerx-pn-select-all-input')
      const selectAllLabelEl = dialog.querySelector(
        '.impowerx-pn-select-all-text'
      )
      const onlyAffectedEl = dialog.querySelector(
        '.impowerx-pn-only-affected-input'
      )
      const showUnregisteredEl = dialog.querySelector(
        '.impowerx-pn-show-unregistered-input'
      )
      const applyFutureEl = dialog.querySelector(
        '.impowerx-pn-apply-future-input'
      )
      const listEl = dialog.querySelector('.impowerx-pn-list')
      const countEl = dialog.querySelector('.impowerx-pn-count')
      const statusEl = dialog.querySelector('.impowerx-pn-status')
      const applyBtn = dialog.querySelector('.impowerx-pn-apply')

      dialog
        .querySelector('.impowerx-pn-cancel')
        .addEventListener('click', () => closeDialog())
      dialog
        .querySelector('.impowerx-pn-dialog-close')
        .addEventListener('click', () => closeDialog())
      applyBtn.addEventListener('click', () => applyForceUpdate())
      searchEl.addEventListener('input', () => {
        dialogState.searchQuery = searchEl.value
        renderDialogList()
      })
      onlyAffectedEl.addEventListener('change', () => {
        dialogState.onlyAffected = onlyAffectedEl.checked
        renderDialogList()
      })
      showUnregisteredEl.addEventListener('change', () => {
        dialogState.showUnregistered = showUnregisteredEl.checked
        // Hidden unregistered contacts must not stay silently selected.
        if (!dialogState.showUnregistered) {
          dialogState.users
            .filter((user) => user.isRegistered === false)
            .forEach((user) => dialogState.selected.delete(user.id))
        }
        renderDialogList()
      })
      applyFutureEl.addEventListener('change', () => {
        dialogState.applyToFuture = applyFutureEl.checked
        renderDialogList()
      })
      selectAllEl.addEventListener('change', () => {
        const ids = getFilteredUsers()
          .filter((user) => willChangeForUser(user).length > 0)
          .map((user) => user.id)
        if (selectAllEl.checked)
          ids.forEach((id) => dialogState.selected.add(id))
        else ids.forEach((id) => dialogState.selected.delete(id))
        renderDialogList()
      })

      dialogState = {
        users: [],
        selected: new Set(),
        searchQuery: '',
        onlyAffected: true,
        showUnregistered: false,
        applyToFuture: true,
        isLoading: true,
        errorMessage: '',
        listEl,
        searchEl,
        selectAllEl,
        selectAllLabelEl,
        onlyAffectedEl,
        showUnregisteredEl,
        applyFutureEl,
        countEl,
        statusEl,
        applyBtn,
      }
      renderDialogList()
      fetchPropertyUsers()
    }

    const updateSectionInputs = () => {
      NOTIFICATION_DEFS.forEach((definition) => {
        const input = sectionInputsByKey[definition.key]
        if (!input) return
        input.checked = Boolean(forcedSettings[definition.key])
        const isChildDisabled =
          definition.key !== 'all' && forcedSettings.all === false
        const isDisabled = !isInEditMode || isChildDisabled
        input.disabled = isDisabled
        input.parentElement?.classList.toggle('is-disabled', isDisabled)
      })
      if (sectionOpenBtnEl) {
        sectionOpenBtnEl.disabled = !isInEditMode
      }
    }

    const updatePendingIndicator = () => {
      if (!sectionPendingIndicatorEl) return
      if (sectionApplyError) {
        sectionPendingIndicatorEl.style.display = 'flex'
        sectionPendingIndicatorEl.classList.add('is-error')
        sectionPendingIndicatorEl.querySelector('.text').textContent =
          sectionApplyError
        return
      }
      sectionPendingIndicatorEl.classList.remove('is-error')
      if (pendingApply) {
        sectionPendingIndicatorEl.style.display = 'flex'
        const count =
          (pendingApply.userIds?.length || 0) +
          (pendingApply.contactIds?.length || 0)
        const parts = []
        if (count > 0) {
          parts.push(
            count === 1
              ? '1 Kontakt ausgewählt'
              : `${count} Kontakte ausgewählt`
          )
        }
        if (pendingApply.applyToFuture) {
          parts.push('Regel für künftige Kontakte')
        }
        const summary =
          parts.length > 0 ? parts.join(' + ') : 'Änderung vorgemerkt'
        sectionPendingIndicatorEl.querySelector('.text').textContent =
          `${summary} — wird beim Klick auf "Speichern" übernommen.`
      } else {
        sectionPendingIndicatorEl.style.display = 'none'
      }
    }

    const handleToggleChange = (definition, nextValue) => {
      forcedSettingsUserEdited = true
      const next = { ...forcedSettings, [definition.key]: nextValue }
      if (definition.key === 'all' && nextValue === false) {
        next.statusChanges = false
        next.newUploadedDocuments = false
        next.phaseChanges = false
      }
      forcedSettings = next
      updateSectionInputs()
    }

    const buildSection = () => {
      const section = document.createElement('div')
      section.className = 'FormSection '
      section.id = SECTION_ID
      section.dataset.testid = `section-${SECTION_ID}`

      section.innerHTML = `
        <div class="form-section-wrapper ">
          <div class="main-section-header section-header not-open" data-testid="section-${SECTION_ID}-toggle">
            <div class="section-number-box  ">
              <span role="img" class="anticon section-number">${BELL_SVG}</span>
            </div>
            <div class="section-title-box ">
              <div class="section-title">Benachrichtigungseinstellungen</div>
            </div>
          </div>
        </div>
      `

      const sectionWrapper = section.querySelector('.form-section-wrapper')
      const sectionHeader = section.querySelector(
        '.main-section-header.section-header'
      )
      const sectionNumberBox = section.querySelector('.section-number-box')
      const sectionTitleBox = section.querySelector('.section-title-box')

      let sectionContent = null

      const buildSectionContent = () => {
        sectionContent = document.createElement('div')
        sectionContent.className = 'section-content'
        sectionContent.setAttribute(
          'data-testid',
          `section-${SECTION_ID}-content`
        )

        const body = document.createElement('div')
        body.className = 'impowerx-pn-body'

        const subtitle = document.createElement('p')
        subtitle.className = 'impowerx-pn-subtitle'
        subtitle.textContent =
          'Legen Sie den Zielzustand fest und wählen Sie anschließend die Kontakte aus. Die ausgewählten Schalter werden erzwungen; optional wird die Einstellung als Regel für künftige Kontakte des Objekts gespeichert.'
        body.appendChild(subtitle)

        const rows = document.createElement('div')
        rows.className = 'impowerx-pn-rows'
        body.appendChild(rows)

        sectionInputsByKey = {}
        NOTIFICATION_DEFS.forEach((definition) => {
          const row = document.createElement('div')
          row.className = `impowerx-pn-row${definition.isChild ? ' is-child' : ''}`

          const label = document.createElement('label')
          label.className = 'impowerx-pn-label'
          label.textContent = definition.label
          label.setAttribute('for', `impowerx-pn-${definition.key}`)

          const switchWrapper = document.createElement('label')
          switchWrapper.className = 'impowerx-pn-switch'

          const input = document.createElement('input')
          input.type = 'checkbox'
          input.id = `impowerx-pn-${definition.key}`
          input.dataset.notificationKey = definition.key

          const slider = document.createElement('span')
          slider.className = 'impowerx-pn-slider'

          switchWrapper.append(input, slider)
          row.append(label, switchWrapper)
          rows.appendChild(row)
          sectionInputsByKey[definition.key] = input

          input.addEventListener('change', () =>
            handleToggleChange(definition, input.checked)
          )
        })

        const actions = document.createElement('div')
        actions.className = 'impowerx-pn-actions'
        const openBtn = document.createElement('button')
        openBtn.type = 'button'
        openBtn.className = 'impowerx-pn-open-btn'
        openBtn.textContent = 'Benutzer auswählen'
        openBtn.addEventListener('click', () => openDialog())
        actions.appendChild(openBtn)
        body.appendChild(actions)
        sectionOpenBtnEl = openBtn

        const pendingIndicator = document.createElement('div')
        pendingIndicator.className = 'impowerx-pn-pending'
        pendingIndicator.style.display = 'none'
        pendingIndicator.innerHTML = `<span class="dot"></span><span class="text"></span>`
        body.appendChild(pendingIndicator)
        sectionPendingIndicatorEl = pendingIndicator

        sectionContent.appendChild(body)
        sectionWrapper.appendChild(sectionContent)
        updateSectionInputs()
        updatePendingIndicator()
      }

      sectionHeader.addEventListener('click', () => {
        const willOpen = sectionHeader.classList.contains('not-open')
        if (willOpen) {
          sectionHeader.classList.remove('not-open')
          sectionHeader.classList.add('open')
          sectionWrapper.classList.add('open')
          sectionNumberBox.classList.add('open')
          sectionTitleBox.classList.add('open')
          if (!sectionContent) buildSectionContent()
        } else {
          sectionHeader.classList.remove('open')
          sectionHeader.classList.add('not-open')
          sectionWrapper.classList.remove('open')
          sectionNumberBox.classList.remove('open')
          sectionTitleBox.classList.remove('open')
          if (sectionContent) {
            sectionContent.remove()
            sectionContent = null
            sectionInputsByKey = {}
            sectionOpenBtnEl = null
            sectionPendingIndicatorEl = null
          }
        }
      })

      section._impowerxOpenSection = () => {
        if (!sectionContent) buildSectionContent()
      }

      return section
    }

    const insertSectionAtEnd = (section) => {
      const target = findLastSectionInsertionPoint()
      if (target?.parentNode) {
        target.insertAdjacentElement('afterend', section)
        return true
      }
      const formRoot = document.querySelector('.form-content > div')
      if (formRoot) {
        formRoot.appendChild(section)
        return true
      }
      return false
    }

    const ensureSidebarLink = () => {
      const sidebar = document.querySelector('.FormSidebar')
      if (!sidebar) return null

      const existingLinks = sidebar.querySelectorAll(
        `.Link.main-link[data-section-id="${SECTION_ID}"]`
      )
      existingLinks.forEach((node, index) => {
        if (index > 0) node.remove()
      })

      let link = existingLinks[0]
      if (!link) {
        link = propertyFormSidebarLink(
          {
            id: SECTION_ID,
            title: 'Benachrichtigungseinstellungen',
            hasSubSection: false,
          },
          getNextSectionNumber()
        )
      }

      const lastLink = findLastSidebarLinkInsertionPoint()
      if (link && lastLink && lastLink !== link) {
        lastLink.insertAdjacentElement('afterend', link)
      } else if (link && !lastLink) {
        sidebar.appendChild(link)
      }

      return link
    }

    const getMountedSections = () => [
      ...document.querySelectorAll(`#${SECTION_ID}`),
    ]

    const removeExtraSections = () => {
      const sections = getMountedSections()
      sections.slice(1).forEach((node) => node.remove())
      return sections[0] || null
    }

    const tryMount = () => {
      if (
        !findLastSectionInsertionPoint() &&
        !document.querySelector('.form-content > div')
      ) {
        return false
      }

      removeExtraSections()

      let section = getMountedSections()[0]
      if (section && document.body.contains(section)) {
        if (
          section.dataset.propertyHrId &&
          section.dataset.propertyHrId !== propertyHrId
        ) {
          section.remove()
          section = null
          forcedSettingsUserEdited = false
          forcedSettings = { ...DEFAULT_FORCED_SETTINGS }
        } else {
          sectionEl = section
          isMounted = true
          insertSectionAtEnd(section)
          ensureSidebarLink()
          loadForcedSettings()
          return true
        }
      }

      if (section) section.remove()
      sectionEl = null
      isMounted = false

      injectStyles()
      sectionEl = buildSection()
      sectionEl.dataset.propertyHrId = propertyHrId
      if (!insertSectionAtEnd(sectionEl)) return false
      ensureSidebarLink()
      isMounted = true
      loadForcedSettings()
      return true
    }

    let mountDebounceTimer = null
    const scheduleTryMount = () => {
      clearTimeout(mountDebounceTimer)
      mountDebounceTimer = setTimeout(() => {
        const sections = getMountedSections()
        const mounted =
          sections.length === 1 &&
          document.body.contains(sections[0]) &&
          sections[0].dataset.propertyHrId === propertyHrId
        if (!mounted) tryMount()
      }, 150)
    }

    const syncEditModeState = () => {
      const nextIsInEditMode =
        localStorage.getItem(editModeStorageKey) === 'true'
      if (nextIsInEditMode === isInEditMode) return
      isInEditMode = nextIsInEditMode
      updateSectionInputs()
    }

    const editModeSyncInterval = setInterval(syncEditModeState, 250)

    tryMount()
    const sectionObserver = new MutationObserver(scheduleTryMount)
    sectionObserver.observe(document.body, { childList: true, subtree: true })
    observers.push(sectionObserver)

    return () => {
      clearTimeout(mountDebounceTimer)
      clearInterval(editModeSyncInterval)
      sectionObserver.disconnect()
      closeDialog()
      getMountedSections().forEach((node) => node.remove())
      document
        .querySelector(
          `.FormSidebar .Link.main-link[data-section-id="${SECTION_ID}"]`
        )
        ?.remove()
      sectionEl = null
      sectionInputsByKey = {}
      sectionOpenBtnEl = null
      sectionPendingIndicatorEl = null
      sectionApplyError = null
      pendingApply = null
      forcedSettingsUserEdited = false
      forcedSettings = { ...DEFAULT_FORCED_SETTINGS }
      forcedSettingsLoadId += 1
      isMounted = false
      onPropertySaveSuccess = null
      document.getElementById(STYLE_ID)?.remove()
    }
  })()

  const cleanup = () => {
    window.__impowerxPropertyInjectInFlight = null
    window.__impowerxRefreshMeterReadings = null
    if (typeof releaseNativeEquipmentUi === 'function') {
      releaseNativeEquipmentUi()
    }
    if (typeof cleanupTechnicalAssetsSectionOrder === 'function') {
      cleanupTechnicalAssetsSectionOrder()
    }
    if (typeof waitForPageLoad !== 'undefined') {
      clearInterval(waitForPageLoad)
    }
    if (window.__impowerxPropertyEditModeSyncInterval) {
      clearInterval(window.__impowerxPropertyEditModeSyncInterval)
      window.__impowerxPropertyEditModeSyncInterval = null
    }
    observers.forEach((obs) => {
      if (obs && typeof obs.disconnect === 'function') {
        obs.disconnect()
      }
    })
    observers.length = 0
    $(document).off('.impowerxProperty')
    $(document).off('change.impowerxFileInput')
    $(document).off('click.impowerxInsuranceVvRadio')
    clearTimeout(insuranceUploadDebounceTimer)
    if (window.__luxSecondApprovalPropertyEditWatch) {
      clearInterval(window.__luxSecondApprovalPropertyEditWatch)
      window.__luxSecondApprovalPropertyEditWatch = null
    }
    try {
      propertyNotificationsTeardown?.()
    } catch (_) {}
    document
      .querySelectorAll('.form-content > div[data-impowerx-property-enhanced]')
      .forEach((form) =>
        form.removeAttribute('data-impowerx-property-enhanced')
      )
  }
  window.__impowerxPropertyCleanup = cleanup

  window.addEventListener('beforeunload', () => cleanup())

  //Cleanup on popstate(browser back / forward)
  window.addEventListener('popstate', () => cleanup())
  // Add unit-sets table to DistributionKeys section for WEG properties
  if (propertyHrId.startsWith('WEG')) {
    let propertyId = null
    let unitSetsData = []

    // Fetch property data to get propertyId
    const fetchPropertyData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem('auth'))?.token
        if (!token) throw new Error('Auth Token nicht gefunden.')

        const response = await fetch(
          `/services/pmp-accounting/api/v1/properties/${propertyHrId}`,
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        )

        if (!response.ok) {
          throw new Error(
            `Failed to fetch property data: ${response.statusText}`
          )
        }

        const propertyData = await response.json()
        return propertyData
      } catch (error) {
        console.error('Error fetching property data:', error)
        throw error
      }
    }

    // Fetch unit-sets data
    const fetchUnitSets = async (propertyId) => {
      try {
        const token = JSON.parse(localStorage.getItem('auth'))?.token
        if (!token) throw new Error('Auth Token nicht gefunden.')

        const response = await fetch(
          `/services/pmp-accounting/api/v1/unit-sets?propertyId=${propertyId}`,
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        )

        if (!response.ok) {
          throw new Error(`Failed to fetch unit-sets: ${response.statusText}`)
        }

        const unitSetsData = await response.json()
        return Array.isArray(unitSetsData) ? unitSetsData : []
      } catch (error) {
        console.error('Error fetching unit-sets:', error)
        return []
      }
    }

    // Create unit-sets table UI
    const createUnitSetsTable = (unitSets) => {
      const container = document.createElement('div')
      container.className = 'weg-unit-sets-container'
      container.style.cssText = `
        margin-top: 16px;
        margin-left: 64px;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
      `

      // Header with title and create button
      const header = document.createElement('div')
      header.style.cssText = `
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        border-bottom: 1px solid #e8e8e8;
      `

      const title = document.createElement('h3')
      title.textContent = 'Einheitensets'
      title.style.cssText = `
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
      `

      const createButton = document.createElement('button')
      createButton.className = 'ant-btn ant-btn-default Button'
      createButton.innerHTML = `
        <span style="margin-right: 8px;">+</span>
        Erstellen
      `
      createButton.style.cssText = `
        display: flex;
        align-items: center;
        padding: 4px 15px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        background: #fff;
        cursor: pointer;
        font-size: 14px;
      `
      createButton.onmouseover = () => {
        createButton.style.borderColor = '#40a9ff'
        createButton.style.color = '#40a9ff'
      }
      createButton.onmouseout = () => {
        createButton.style.borderColor = '#d9d9d9'
        createButton.style.color = 'rgba(0, 0, 0, 0.85)'
      }
      createButton.onclick = () => {
        window.location.href = `/properties/${propertyHrId}/edit/unit-set/create`
      }

      header.appendChild(title)
      header.appendChild(createButton)
      container.appendChild(header)

      // Table
      const table = document.createElement('div')
      table.style.cssText = `
        width: 100%;
      `

      // Table header
      const tableHeader = document.createElement('div')
      tableHeader.style.cssText = `
        display: flex;
        padding: 12px 24px;
        background: #fafafa;
        border-bottom: 1px solid #e8e8e8;
        font-size: 12px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.45);
        text-transform: uppercase;
      `

      const titleHeader = document.createElement('div')
      titleHeader.textContent = 'TITEL'
      titleHeader.style.flex = '1'

      const unitsHeader = document.createElement('div')
      unitsHeader.textContent = 'EINHEITEN'
      unitsHeader.style.cssText = `
        flex: 0 0 150px;
        text-align: right;
        padding-right: 32px;
      `

      tableHeader.appendChild(titleHeader)
      tableHeader.appendChild(unitsHeader)
      table.appendChild(tableHeader)

      // Table rows
      if (unitSets.length === 0) {
        const emptyRow = document.createElement('div')
        emptyRow.style.cssText = `
          padding: 24px;
          text-align: center;
          color: rgba(0, 0, 0, 0.45);
        `
        emptyRow.textContent = 'Keine Einheitensets vorhanden'
        table.appendChild(emptyRow)
      } else {
        unitSets.forEach((unitSet) => {
          const row = document.createElement('div')
          row.style.cssText = `
            display: flex;
            padding: 12px 24px;
            border-bottom: 1px solid #f0f0f0;
            cursor: pointer;
            align-items: center;
          `
          row.onmouseover = () => {
            row.style.backgroundColor = '#fafafa'
          }
          row.onmouseout = () => {
            row.style.backgroundColor = 'transparent'
          }
          row.onclick = () => {
            window.location.href = `/properties/${propertyHrId}/edit/unit-set/${unitSet.id}`
          }

          const titleCell = document.createElement('div')
          titleCell.textContent = unitSet.name || 'Unbenannt'
          titleCell.style.cssText = `
            flex: 1;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            text-decoration: underline;
            text-decoration-style: dotted;
            text-underline-offset: 4px;
          `

          const unitsCell = document.createElement('div')
          const unitsCount = unitSet.units ? unitSet.units.length : 0
          unitsCell.textContent = unitsCount.toString()
          unitsCell.style.cssText = `
            flex: 0 0 150px;
            text-align: right;
            padding-right: 24px;
            color: rgba(0, 0, 0, 0.85);
          `

          row.appendChild(titleCell)
          row.appendChild(unitsCell)
          table.appendChild(row)
        })
      }

      container.appendChild(table)
      return container
    }

    const addUnitSetsTable = async () => {
      const targetElement = document.querySelector(
        '#DistributionKeys > .form-section-wrapper.open > .section-content'
      )
      if (targetElement) {
        // Check if table already exists in DOM to avoid duplicates
        if (
          targetElement.querySelector('.weg-unit-sets-container') ||
          targetElement.querySelector('.weg-unit-sets-loading')
        ) {
          return
        }

        // Show loading state
        const loadingDiv = document.createElement('div')
        loadingDiv.className = 'weg-unit-sets-loading'
        loadingDiv.style.cssText = `
          margin-top: 16px;
          padding: 24px;
          text-align: center;
          color: rgba(0, 0, 0, 0.45);
        `
        loadingDiv.textContent = 'Lade Einheitensets...'
        targetElement.appendChild(loadingDiv)

        try {
          // Fetch property data to get propertyId
          if (!propertyId) {
            const propertyData = await fetchPropertyData()
            propertyId = propertyData.id || propertyData.propertyId
            if (!propertyId) {
              throw new Error('Property ID not found in property data')
            }
          }

          // Fetch unit-sets
          unitSetsData = await fetchUnitSets(propertyId)

          // Remove loading state
          loadingDiv.remove()

          // Create and append table
          const table = createUnitSetsTable(unitSetsData)
          targetElement.appendChild(table)
        } catch (error) {
          console.error('Error loading unit-sets:', error)
          loadingDiv.textContent = 'Fehler beim Laden der Einheitensets'
          loadingDiv.style.color = '#ff4d4f'
        }
      }
    }

    // Wait for the element to be present and the section to be open
    let attempts = 0
    const maxAttempts = 60 // 30 seconds max (60 * 500ms)
    const waitForDistributionKeysSection = setInterval(() => {
      attempts++
      const distributionKeysSection =
        document.querySelector('#DistributionKeys')
      if (distributionKeysSection) {
        const sectionWrapper = distributionKeysSection.querySelector(
          '.form-section-wrapper'
        )
        if (sectionWrapper && sectionWrapper.classList.contains('open')) {
          addUnitSetsTable()
          clearInterval(waitForDistributionKeysSection)
        }
      }
      // Clear interval after max attempts to prevent infinite polling
      if (attempts >= maxAttempts) {
        clearInterval(waitForDistributionKeysSection)
      }
    }, 500)

    // Also observe for when the section opens
    const distributionKeysObserver = new MutationObserver(() => {
      const sectionWrapper = document.querySelector(
        '#DistributionKeys > .form-section-wrapper'
      )
      if (sectionWrapper && sectionWrapper.classList.contains('open')) {
        addUnitSetsTable()
      }
    })

    const distributionKeysSection = document.querySelector('#DistributionKeys')
    if (distributionKeysSection) {
      const sectionWrapper = distributionKeysSection.querySelector(
        '.form-section-wrapper'
      )
      if (sectionWrapper) {
        distributionKeysObserver.observe(sectionWrapper, {
          attributes: true,
          attributeFilter: ['class'],
        })
        observers.push(distributionKeysObserver)
      }
    }

    // Also check when clicking on the DistributionKeys section header
    const distributionKeysHeader = document.querySelector(
      '#DistributionKeys .main-section-header'
    )
    if (distributionKeysHeader) {
      distributionKeysHeader.addEventListener('click', () => {
        setTimeout(() => {
          addUnitSetsTable()
        }, 200)
      })
    }
  }

  // Domain-specific standard accounts button configuration
  // All endpoints now use the unified /api/subaccounts?framework=xxx pattern
  const standardAccountsConfigs = [
    {
      domainId: 1116,
      domainName: 'zieglmeier',
      buttonClass: 'zhv-accounts-weg-btn',
      statusClass: 'zhv-accounts-status',
      buttonLabel: 'Standardkonten Zieglmeier (WEG) erstellen',
      framework: 'zhvWEG',
    },
    {
      domainId: 2674,
      domainName: 'hv-tesche',
      buttonClass: 'hv-accounts-btn',
      statusClass: 'hv-accounts-status',
      buttonLabel: 'Standardkonten H+V erstellen',
      framework: 'hvTesche',
    },
    {
      domainId: 3265,
      domainName: 'sgv-murr',
      buttonClass: 'sgv-murr-accounts-btn',
      statusClass: 'sgv-murr-accounts-status',
      buttonLabel: 'Standardkonten SGV Murr erstellen',
      framework: 'sgvMurr',
    },
  ]

  // Generic function to inject a standard accounts button
  const injectStandardAccountsButton = (config) => {
    try {
      const authData = JSON.parse(localStorage.getItem('auth') || '{}')
      const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
      const domainId = decodedToken.domainId

      if (domainId !== config.domainId && domainId !== config.domainName) {
        return
      }
    } catch (error) {
      console.error('Error checking domain:', error)
      return
    }

    const costCenterSubsection = document.querySelector('#costCenterSubsection')

    if (
      costCenterSubsection &&
      !costCenterSubsection.querySelector(`.${config.buttonClass}`)
    ) {
      const buttonContainer = document.createElement('div')
      buttonContainer.style.marginBottom = '16px'
      buttonContainer.style.display = 'flex'
      buttonContainer.style.gap = '8px'
      buttonContainer.style.alignItems = 'center'

      buttonContainer.innerHTML = `
        <button 
          class="ant-btn ${config.buttonClass}" 
          type="button"
          style="margin-right: 8px; background-color: #000; border-color: #000; color: #fff;"
        >
          <span>${config.buttonLabel}</span>
        </button>
        <span class="${config.statusClass}" style="font-size: 14px; color: rgba(0, 0, 0, 0.65);"></span>
      `

      const firstChild = costCenterSubsection.querySelector(
        '.sub-section-content, .form-section-wrapper'
      )
      if (firstChild) {
        firstChild.insertBefore(buttonContainer, firstChild.firstChild)
      } else {
        costCenterSubsection.prepend(buttonContainer)
      }

      const button = costCenterSubsection.querySelector(
        `.${config.buttonClass}`
      )
      const statusSpan = costCenterSubsection.querySelector(
        `.${config.statusClass}`
      )

      button.addEventListener('click', async () => {
        const setButtonState = (state) => {
          const states = {
            loading: {
              disabled: true,
              label: 'Wird erstellt...',
              bg: '#000',
              color: '#fff',
            },
            success: {
              disabled: true,
              label: '✓ Erfolgreich erstellt',
              bg: '#52c41a',
              color: '#fff',
            },
            error: {
              disabled: false,
              label: config.buttonLabel,
              bg: '#000',
              color: '#fff',
            },
            default: {
              disabled: false,
              label: config.buttonLabel,
              bg: '#000',
              color: '#fff',
            },
          }
          const s = states[state]
          button.disabled = s.disabled
          button.innerHTML = `<span>${s.label}</span>`
          button.style.backgroundColor = s.bg
          button.style.borderColor = s.bg
          button.style.color = s.color
        }

        try {
          setButtonState('loading')
          statusSpan.textContent = ''

          const currentPath = window.location.pathname
          const pathMatch = currentPath.match(/\/properties\/([^\/]+)/)
          const currentPropertyHrId = pathMatch ? pathMatch[1] : propertyHrId

          const token = JSON.parse(localStorage.getItem('auth')).token

          const response = await fetch(
            `${baseApiUrl}/api/subaccounts?propertyHrId=${currentPropertyHrId}&framework=${config.framework}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )

          const result = await response.json()

          if (!response.ok) {
            throw new Error(
              result.message ||
                result.error ||
                'Fehler beim Erstellen der Accounts'
            )
          }

          setButtonState('success')
          statusSpan.style.color = '#52c41a'
          statusSpan.textContent =
            result.message ||
            `${result.results?.length || 0} Unterkonten erstellt`

          setTimeout(() => setButtonState('default'), 3000)
        } catch (error) {
          console.error(`Error creating ${config.domainName} accounts:`, error)
          setButtonState('error')
          statusSpan.style.color = '#ff4d4f'
          statusSpan.textContent = error.message || 'Fehler beim Erstellen'
        }
      })
    }
  }

  // Inject all standard accounts buttons and set up observer
  const injectAllStandardAccountsButtons = () => {
    standardAccountsConfigs.forEach(injectStandardAccountsButton)
  }

  injectAllStandardAccountsButtons()

  const standardAccountsObserver = new MutationObserver(
    injectAllStandardAccountsButtons
  )
  standardAccountsObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
  observers.push(standardAccountsObserver)

  if (typeof renameImpowerDienstleisterSection === 'function') {
    renameImpowerDienstleisterSection()
    let renameDienstleisterScheduled = false
    const scheduleRenameDienstleister = () => {
      if (renameDienstleisterScheduled) return
      renameDienstleisterScheduled = true
      requestAnimationFrame(() => {
        renameDienstleisterScheduled = false
        renameImpowerDienstleisterSection()
      })
    }
    const renameDienstleisterObserver = new MutationObserver(
      scheduleRenameDienstleister
    )
    renameDienstleisterObserver.observe(document.body, {
      childList: true,
      subtree: true,
    })
    observers.push(renameDienstleisterObserver)
  }

  // --- Internal contact roles under PropertyCare (replaces former operational contacts UI) ---
  function injectInternalContactRolesSection() {
    const propertyCareSection = document.querySelector('#PropertyCare')
    if (!propertyCareSection) return
    const adminSection =
      propertyCareSection.closest('.FormSection') ||
      document.querySelector('#AdministrationData')
    if (!isFormSectionOpen(adminSection)) return
    const subSectionContent = propertyCareSection.querySelector(
      '.sub-section-content'
    )
    if (!subSectionContent) return
    if (subSectionContent.querySelector('.lux-internal-contact-roles-host'))
      return

    const hostRow = document.createElement('div')
    hostRow.className = 'lux-internal-contact-roles-host'

    const firstImpowerRow = subSectionContent.querySelector(
      '.sub-section-content-row[class*="impowerx-row-"]'
    )
    if (firstImpowerRow) {
      subSectionContent.insertBefore(hostRow, firstImpowerRow)
    } else {
      subSectionContent.appendChild(hostRow)
    }

    if (typeof initContactRolesPropertySection === 'function' && propertyId) {
      initContactRolesPropertySection(hostRow, propertyId, 'internal')
    }
  }

  injectInternalContactRolesSection()

  setTimeout(function () {
    if (typeof initInternalApprovalPropertyFields === 'function') {
      initInternalApprovalPropertyFields(propertyHrId)
    } else if (typeof initSecondInternalApprovalPropertyFields === 'function') {
      initSecondInternalApprovalPropertyFields(propertyHrId)
    }
    if (typeof refreshInternalApprovalPropertyVisibility === 'function') {
      refreshInternalApprovalPropertyVisibility()
    }
  }, 800)

  const internalContactRolesObserver = new MutationObserver(() => {
    injectInternalContactRolesSection()
  })
  internalContactRolesObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
  observers.push(internalContactRolesObserver)

  const adminSectionClickHandler = () => {
    const adminSection = document.querySelector('#AdministrationData')
    if (adminSection && !adminSection.dataset.luxInternalContactRolesBound) {
      adminSection.dataset.luxInternalContactRolesBound = '1'
      adminSection.addEventListener('click', () => {
        setTimeout(injectInternalContactRolesSection, 200)
      })
    }
  }
  adminSectionClickHandler()
  const adminClickObserver = new MutationObserver(adminSectionClickHandler)
  adminClickObserver.observe(document.body, { childList: true, subtree: true })
  observers.push(adminClickObserver)

  // Preferred providers (EHV-1302) under PropertyCare, below the internal
  // contact roles; see features/preferredProviders.js.
  let preferredProvidersTeardown = null
  function injectPreferredProvidersSection() {
    if (
      typeof initPreferredProvidersPropertySection !== 'function' ||
      !propertyId
    )
      return
    const rolesHost = document.querySelector('.lux-internal-contact-roles-host')
    if (!rolesHost) return
    const existingHost = rolesHost.parentElement?.querySelector(
      '.lux-preferred-providers-host'
    )
    // Keep a failed host so the observer does not refetch in a loop. A full
    // PropertyCare remount drops the host and allows one fresh attempt.
    if (existingHost) return

    const hostRow = document.createElement('div')
    hostRow.className = 'lux-preferred-providers-host'
    rolesHost.insertAdjacentElement('afterend', hostRow)
    if (typeof preferredProvidersTeardown === 'function')
      preferredProvidersTeardown()
    preferredProvidersTeardown = initPreferredProvidersPropertySection(
      hostRow,
      {
        propertyId,
        baseApiUrl,
        shouldDisableInjectedFields,
      }
    )
  }
  injectPreferredProvidersSection()
  const preferredProvidersObserver = new MutationObserver(
    injectPreferredProvidersSection
  )
  preferredProvidersObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
  observers.push(preferredProvidersObserver)
  observers.push({
    disconnect: () => {
      if (typeof preferredProvidersTeardown === 'function')
        preferredProvidersTeardown()
    },
  })

  // "Prozentsatz der Miete" management-fee method (EHV-1093, D3): extends the
  // native fee-type radio group; see features/managementFeePercentage.js.
  if (propertyId && typeof initManagementFeePercentageInject === 'function') {
    const managementFeePercentageTeardown = initManagementFeePercentageInject({
      propertyId,
      baseApiUrl,
      shouldDisableInjectedFields,
    })
    if (typeof managementFeePercentageTeardown === 'function') {
      observers.push({ disconnect: managementFeePercentageTeardown })
    }
  }
}
